<template>
    <div id="page-selects">
      <v-container fluid fill-height class="grey lighten-5">
        <v-card style="border-radius: 10px;" class="mx-3 mt-3" flat max-height="100%" max-width="100%" width="2000">
          <v-card-title>
            <v-row no-gutters class="mt-5">
              <v-col cols="3" sm="3" md="3">
                <span class="font-weight-bold"><h3 style="color: #003057;" >{{ $t('WpLabRequest.labRequestHeader') }}</h3></span>
              </v-col>
              <v-col cols="6" sm="6" md="6"></v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <!-- <v-divider class="mx-1" inset vertical></v-divider> -->
          <v-card  flat  class="ml-6 mb-3 pr-2" height="100%">
            <v-row dense  justify="start" align="center">
              <v-col cols="2" sm="2"  lg="2">
                <v-btn  
                  color="#04AB2F" 
                  height="40px"
                  width="100%"
                  id="createOrderMainBtn"
                  @click="addNew(appName)"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-plus</v-icon>
                  {{$t('WpLabRequest.addNew')}}
                </v-btn>
              </v-col>
              <v-col cols="2" sm="2"  lg="2">
                <v-btn
                  color="#0073BE"
                  height="40px"
                  width="100%"
                  @click="checkSendRequestSelected"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-package</v-icon>
                  <span v-html="formatText($t('WpLabRequest.sendPackage'))" class="text-left"></span>
                </v-btn>
              </v-col>
              <v-col cols="2" sm="1" md="2" lg="2">
                <v-btn  
                  color="#CC0202" 
                  height="40px"
                  width="100%" 
                  @click="checkCancelSendRequestSelected"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-package</v-icon>
                  {{$t('WpLabRequest.cancelPackage')}}
                </v-btn>
              </v-col>
              <v-col cols="2" sm="2" md="2" lg="2">
                <v-btn  
                  color="#CC0202" 
                  height="40px"
                  width="100%" 
                  @click="checkCancelLabSelected"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-note-remove-outline</v-icon>
                  {{$t('WpLabRequest.cancelLab')}}
                </v-btn>
              </v-col>
              <v-col cols="2" sm="1" md="1" lg="1">
                <v-btn  
                  color="#0A7AFF" 
                  height="40px"
                  width="100%" 
                  @click="checkPrintRequestSelected"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                >
                  <v-icon color="#FFF" :small="$vuetify.breakpoint.mdAndDown" class="mr-1">mdi-file-account</v-icon>
                  {{$t('WpLabRequest.requestReport')}}
                </v-btn>
              </v-col>

              <!-- ปุ่ม แพคเกจ -->
              <v-col cols="2" sm="1" md="1" lg="1">
                <v-btn  
                  color="#0A7AFF" 
                  height="40px"
                  width="100%" 
                  @click="checkPrintPackageSelected"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                >
                  <v-icon color="#FFF" :small="$vuetify.breakpoint.mdAndDown" class="mr-1">mdi-folder-account-outline</v-icon>
                  {{$t('WpLabRequest.packageReport')}}
                </v-btn>
              </v-col>

              <!-- ปุ่ม เคลียร์ข้อมูล -->
              <v-col cols="1" sm="1" md="1" lg="1">
                <!-- <v-btn  
                  color="#003057"
                  height="46px" 
                  width="100%"
                  outlined
                  @click="clearData(appName)"
                >
                  <v-icon color="#003057" height="24px" width="24px" class="mr-1" >mdi-rotate-left</v-icon>
                  {{$t('WpLabRequest.clearData')}}
                </v-btn> -->
                <v-btn  
                  color="#003057"
                  height="40px" 
                  width="100%"
                  outlined
                  @click="clearData(appName)"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                >
                  <v-icon 
                    color="#003057" 
                    :small="$vuetify.breakpoint.mdAndDown"
                    class="mr-1"
                  >
                    mdi-rotate-left
                  </v-icon>
                  {{ $t('WpLabRequest.clearData') }}
                </v-btn>
              </v-col>

              <!-- <v-col cols="" sm="1" md="1" lg="1">
                <v-btn  
                    color="#003057"
                    height="46px" 
                    width="100%"
                    
                    @click="retrieveLabRequest(appName)"
                  >
                    <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-magnify</v-icon>
                    {{$t('WpLabRequest.searchData')}}
                  </v-btn>
              </v-col> -->
              <v-col cols="" sm="1" md="1" lg="1">
                <v-btn  
                    color="#003057"
                    height="40px" 
                    width="100%"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                      'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                    }"
                    @click="retrieveLabRequest(appName)"
                  >
                    <v-icon color="#FFF" :small="$vuetify.breakpoint.mdAndDown" class="mr-1">mdi-magnify</v-icon>
                    {{$t('WpLabRequest.searchData')}}
                  </v-btn>
              </v-col>
              <v-col cols="4" sm="4" md="4" lg="4">

              </v-col>
            </v-row>
            <div class="mt-0" ></div>
            <v-row dense flat>
              <v-col cols="2" xl="2" sm="2" md="2" lg="2">
                <v-dialog ref="dialogReceivedDateFromTo" v-model="dialog.dialogReceivedDateFromTo"
                  :return-value.sync="criteria.ReceivedDateFromTo" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    height="40px" 
                    width="16.1%"
                    color="#003057"
                    class="mr-1"
                    :label="$t('WpLabRequest.dateCreated')" 
                    style="position: absolute;"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                      'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                    }"
                    v-bind="attrs" 
                    v-on="on">
                      <v-icon color="#FFF" :small="$vuetify.breakpoint.mdAndDown" class="mr-1">mdi-calendar</v-icon> {{$t('WpLabRequest.dateCreated')}} {{ dateRangeText }}
                    </v-btn>
                  </template>
                  <v-date-picker v-model="criteria.ReceivedDateFromTo" :selected-items-text="selectDate" range scrollable @keydown.enter="retrieveLabRequest">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog.dialogReceivedDateFromTo = false">Cancel</v-btn>
                    <v-btn text color="primary"
                      @click="$refs.dialogReceivedDateFromTo.save(criteria.ReceivedDateFromTo)">Ok</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>


              <v-col cols="2" sm="2" md="2" lg="2">
                <div class="ml-0">
                  <v-text-field 
                  class="text-center"
                  dense
                  outlined 
                  color="#003057"
                  height="30px" 
                  width="198"
                  hide-details 
                  :label="$t('WpLabRequest.patientName')" 
                  @keydown.enter="retrieveLabRequest"
                  v-model="searchName">
                </v-text-field>
                </div>
              </v-col>

              <v-col cols="2" sm="2" md="2" lg="2">
                <div class="ml-0">
                  <v-text-field 
                  class="text-center"
                  dense
                  outlined 
                  color="#003057"
                  height="30px" 
                  width="198"
                  hide-details 
                  :label="$t('WpLabRequest.packageNo')" 
                  @keydown.enter="retrieveLabRequest"
                  v-model="searchPackage">
                </v-text-field>
                </div>
              </v-col>

              <v-col cols="2" sm="2" md="2" lg="2">
                <v-text-field 
                outlined 
                dense 
                color="#003057"
                height="30px" 
                width="195.75px"
                hide-details 
                :label="$t('WpLabRequest.HN')" 
                @keydown.enter="retrieveLabRequest"
                v-model="find_hn">
              </v-text-field>
              </v-col>

              <v-col cols="3" sm="2" md="2" lg="2">
                <v-select 
                  height="30px" 
                  width="195.75px"
                  :items="viewList"
                  v-model="request_view_skey" 
                  item-text="view_desc" item-value="view_skey"
                  :label="$t('WpLabRequest.lablaboratoryName')" 
                  persistent-hint single-line outlined dense hide-details
                  clearable
                  @keydown.enter="retrieveLabRequest"
                >
                </v-select>
              </v-col>

              <v-col cols="2" sm="2" md="2" lg="2">
                <v-autocomplete 
                dense 
                hide-details 
                color="#003057"
                height="30px" 
                width="195.75px"
                :label="$t('WpLabRequest.status')" 
                :items="statusListAll" 
                v-model="status"
                :item-text="item => $t(item.status_name)"
                item-value="status"
                class="text-center"
                @keydown.enter="retrieveLabRequest"
                clearable
                outlined>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
          <div class="mx-4 mb-4 fill-height mt-5" >
            <v-data-table
              v-model="vDataTable.selected"
              :headers="headersMain"
              :items="vDataTable.data"
              :search="vDataTable.search"
              fixed-header
              show-select
              :page.sync="vDataTable.options.page"
              :itemsPerPage.sync="vDataTable.options.itemsPerPage"
              :options.sync="vDataTable.options"
              :height="$vuetify.breakpoint.height - 340 - offsetAppBar"
              :footer-props="{
                itemsPerPageText: $t('itemsPerPageText'),
                itemsPerPageAllText: $t('itemsPerPageAllText'),
                showFirstLastPage: true,
                showCurrentPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
              }"
              item-key="order_skey"
              class="custom-table "
            >
              <template v-slot:[`item.lab_status`]="{ item }">
                {{ getStatusName(item.lab_status, item.is_received_check, item.group_status_ratio) }}
              </template>
              <template v-slot:[`item.is_approved`]="{ item }">
                <span v-if="item.lab_status === 'LASTAPPROVE'">
                  {{ getStatusApproveName(item.is_approved) }}
                </span>
              </template>
              <template v-slot:[`item.date_receive`]="{ item }">
                <span>{{ formatDateTimeDisplay(item.date_receive) }}</span>
              </template>
              <template v-slot:[`item.date_result`]="{ item }">
                <span>{{ formatDateTimeDisplay(item.date_result) }}</span>
              </template>

              <template v-slot:[`item.date_created`]="{ item }">
                <span>{{ formatDateTimeDisplay(item.date_created) }}</span>
              </template>
              <template v-slot:[`item.date_send`]="{ item }">
                <span>{{ formatDateTimeDisplay(item.date_send) }}</span>
              </template>
              <template v-slot:[`item.invoice_desc`]="{ item }">
                <v-row v-if="item.invoice_desc !== null">
                  <v-col cols="12">
                    <v-container class="d-flex justify-center">
                      <div
                        :style="{
                          backgroundColor: item.invoice_desc === 'Receipt Issued'
                                          ? '#35C75A'
                                          : item.invoice_desc === 'Receipt Emailed'
                                          ? '#3085d6'
                                          : '#FF2626',
                          color: '#FFFFFF',
                          padding: '8px',
                          textAlign: 'center',
                          width: '110px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          minHeight: '40px',
                        }"
                      >
                        {{ item.invoice_desc }}
                      </div>
                    </v-container>
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="d-flex align-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editOrder(item)">edit</v-icon>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="blue" small class="mr-2" v-bind="attrs" v-on="on" @click="requestLabResultReportPdf('S', item.order_id, null)">mdi-file-search-outline</v-icon>
                  </template>
                  <span>View Report</span>
                </v-tooltip> -->
                </div>
              </template>
              
              <template v-slot:item.is_get_back="{ item }">
                <v-icon v-if="item.is_get_back === 1" large color="green">mdi-checkbox-marked-circle</v-icon>
              </template>

              <template v-slot:item.is_urgent="{ item }">
                
                <v-row dense flat justify="start" align="center" >
                  <v-col cols="9" class="d-flex justify-center align-center">
                    <div>
                      <v-icon  class="icon-noti" v-if="item.is_urgent !== null && item.is_urgent !== 0" color="red" size="30">
                        mdi-bell-ring-outline
                      </v-icon>
                      <v-icon  class="icon-noti" v-else color="#A9A9A9" size="30">
                        mdi-bell-ring-outline
                      </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:footer>
                <tr class="sticky-table-footer" style="position: absolute">
                  <td>Selected({{ vDataTable.selected.length }})s</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-container>

    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          <span class="white--text">
            {{ progressMessage }}
          </span>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.dialogEditPatient" max-width="1300px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('WpLabRequest.editPatient') }}</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-col cols="2">
                <v-text-field outlined dense hide-details
                  v-model="hn"
                  :label="$t('WpLabRequest.HN')"
                  @keydown.enter.prevent="retrieveFromIDCard(hn)"
                />
              </v-col>
              <v-col cols="2">
                <v-select outlined dense hide-details
                  :items="prefixList"
                  v-model="prefix"
                  item-text="prefix_desc"
                  item-value="prefix_cd"
                  :label="$t('WpLabRequest.prefixRequire')"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field outlined dense hide-details
                  v-model="firstName"
                  :label="$t('WpLabRequest.firstName')"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field outlined dense hide-details
                  v-model="middleName"
                  :label="$t('WpLabRequest.middleName')"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field outlined dense hide-details
                  v-model="lastName"
                  :label="$t('WpLabRequest.lastName')"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field outlined dense hide-details
                  v-model="idCardText"
                  :label="$t('WpLabRequest.cid')"
                />
              </v-col>
              <v-col cols="4" sm="3" md="4" class="d-flex align-center">
                <v-text-field
                  class="ma-0 pa-0"
                  hide-details
                  outlined
                  dense
                  clearable
                  :label="$t('WpLabRequest.customer')"
                  v-model="cust_name"
                  append-outer-icon="mdi-magnify"
                  @click:append-outer="openBrowseCustomer"
                  @click:clear="clearCustomer"
                />
                <!-- Edit -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      class="ml-1 cursor-pointer"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="copyPatientToCustomer"
                    >
                      mdi-content-copy
                    </v-icon>
                  </template>
                  <span>Copy Patient Info to Customer2</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col cols="4" sm="4" md="4">
                <div>
                    <v-menu
                      v-model="menuEditRequestBrithday"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <!--  วันเกิด -->
                        <!-- :append-icon="dateRequestBrithday ? 'mdi-close' : ''" -->
                        <v-text-field
                          dense
                          v-model="dateRequestBrithdayText"
                          :label="$t('WpLabRequest.brithDayRequire')"
                          append-icon="mdi-calendar-month"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          @click:append="clearDate"
                          hide-details
                          :error="!dateRequestBrithdayText && showError"           
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateRequestBrithday"
                        @input="updateRequestAge"
                        :disabled="ageEditing"
                        :max-width="'none'"
                        
                        color="primary"
                      ></v-date-picker>
                    </v-menu>
                  </div>
              </v-col>

              <v-col cols="3" sm="3" md="3">
                <div>
                  <!--  อายุ -->
                <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="age"
                    :disabled="ageEditing"
                    @focus="disableDatePicker"
                    @blur="enableDatePicker"
                    @input="handleAgeChange"
                    maxlength="3"
                    :error="!age && showError"
                    :label="$t('WpLabRequest.age')"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="2">
                <v-select outlined dense hide-details
                  :items="sexListAll"
                  v-model="sex"
                  item-text="sex_desc"
                  item-value="sex_cd"
                  :label="$t('WpLabRequest.sexRequire')"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field outlined dense hide-details
                  v-model="hospital_lab_no"
                  :label="$t('WpLabRequest.hln')"
                />
              </v-col>
            </v-row>
            <!-- Row 3: Hospital -->
            <v-row class="mt-2">
              <v-col cols="4" sm="4" md="4">
                <div>
                  <v-menu
                    v-model="editMenuRequestReceive"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                  <!-- v-model="dateRequestCollectionText" -->
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dense
                        append-icon="mdi-calendar-month"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        color="#003057"
                        width="30%"
                        style="position: absolute;"
                      >
                      <v-icon color="#FFF" class="mr-1">mdi-calendar</v-icon> {{ $t('WpLabRequest.collectDate') }} {{ dateRequestCollectionText }}
                    </v-btn>
                    </template>
                    <v-date-picker
                    v-model="dateRequestCollection"
                      @input="editMenuRequestReceive = false"
                      
                      color="primary"
                    ></v-date-picker>
                  </v-menu>
              </div>
            </v-col>


            <v-col cols="1" sm="1" md="1">
              <div>
                <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                  :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']"
                  label="Hour"
                  v-model="selectedHour"
                  outlined
                ></v-select>
              </div>
            </v-col>
            <v-col cols="1" sm="1" md="1">
              <div>
                <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                  :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                  label="Minute"
                  v-model="selectedMinute"
                  outlined
                ></v-select>
              </div>
            </v-col>
            <v-col cols="1" sm="1" md="1">
              <div>
                <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                  :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                  label="Second"
                  v-model="selectedSecond"
                  outlined
                ></v-select>
              </div>
            </v-col>
              <v-col cols="2">
                <v-text-field outlined dense hide-details
                  v-model="requestBy"
                  :label="$t('WpLabRequest.requestBy')"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field outlined dense hide-details
                  v-model="refDoc"
                  :label="$t('WpLabRequest.refDoc')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mr-5 pb-4">
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click="confirmEditPatient">
            {{ $t('WpLabRequest.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialog.dialogOrderItemDiagnosis" max-width="1000px" eager persistent>
      <v-card>
        <v-card-title>
          <span class="headline"><h6 style="color: #003057;">{{$t('WpLabRequest.diagnosis')}}</h6></span>
        </v-card-title>
        <v-card-text>
          <v-container>
                <h6 class="headline ms-2 mb-2" style="color: #003057;">{{$t('WpLabRequest.diagnosisDesc')}}</h6>
                <v-textarea
                    class="ma-0 pa-0"
                    v-model="orderItemDiagnosis"
                    :label="$t('WpLabRequest.diagnosisDesc')"
                    outlined
                    dense
                    auto-grow
                  />
                <h6 class="headline ms-2 mb-2" style="color: #003057;">{{$t('WpLabRequest.requestBy')}}</h6>
                <v-text-field
                  class="ma-0 pa-0"
                  outlined
                  :label="$t('WpLabRequest.requestBy')"
                  v-model="requestBy"
                  hide-details
                  clearable>
                </v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submitOrderItemDiagnosis()">
            {{ $t('submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.dialogOrderItemComment" max-width="1000px" eager persistent>
      <v-card>
        <v-card-title>
          <span class="headline"><h6 style="color: #003057;">{{$t('WpLabRequest.comment')}}</h6></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-combobox v-if="orderItemCommentList.length !== 0"
                  class="ma-0 pa-0"
                  outlined
                  :label="$t('WpLabRequest.note')"
                  v-model="orderItemComment"
                  :items="orderItemCommentList ? orderItemCommentList.map(item => item.comment) : ''"
                  hide-details
                  clearable
                  :search-input.sync="orderItemComment"
                ></v-combobox>
                <v-text-field v-if="orderItemCommentList.length === 0"
                  class="ma-0 pa-0"
                  outlined
                  :label="$t('WpLabRequest.note')"
                  v-model="orderItemComment"
                  hide-details
                  clearable>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submitOrderItemComment()">
            {{ $t('WpLabRequest.submit') }}
          </v-btn>
          <!-- <v-btn outlined color="error" @click="closeOrderItemComment()">{{$t('cancel')}}</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.dialogOrderItemVolumeUrine" max-width="1000px" eager persistent>
      <v-card>
        <v-card-title>
          <span class="headline"><h6 style="color: #003057;">{{$t('WpLabRequest.volumnUrine')}}</h6></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="ma-0 pa-0"
                  outlined
                  :label="$t('Volume Urine')"
                  v-model="orderItemVolumeUrine"
                  hide-details
                  clearable>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submitOrderItemVolumeUrine()">
            {{ $t('WpLabRequest.submit') }}
          </v-btn>
          <!-- <v-btn outlined color="error" @click="closeOrderItemComment()">{{$t('cancel')}}</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.dialogviewRemark" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline" ><h6 style="color: #003057;" >{{$t('WpLabRequest.remark')}}</h6></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('WpLabRequest.note')"
                  v-model="itemRemark"
                  rows="4"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeViewRemark()">{{$t('WpLabRequest.cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpdfShow" scrollable max-width="900px" fullscreen>
      <v-card flat>
        <v-card-title>
            <v-toolbar dense flat scrollable color="white">
            <v-toolbar-title class="primary--text">Report</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-divider class="mx-1" inset vertical></v-divider>
            <v-divider class="mx-1" inset vertical></v-divider>
            <v-btn outlined color="primary" style="text-transform: capitalize" @click="closeDialogpdfShow">
              <img src="../assets/SoftwareClinicIcon/close-icon.png" height="30" weight="30"/>Close
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <iframe :src="pdfShow"
           type="application/pdf" style="overflow: auto; width: 100%; height: 100%;">
          </iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.dialogEditCollectionDate" scrollable max-width="900px" >
      <v-card>
        <v-card-title>
          <span class="headline" ><h6 style="color: #003057;" >{{$t('WpLabRequest.editCollectionDate')}}</h6></span>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-3" no-gutters>
            <v-col cols="6" sm="6" md="6">
              <div class="mx-3">
                <v-menu
                    v-model="menuCollectionDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        dense
                        block
                        v-model="editCollectionDate"
                        append-icon="mdi-calendar-month"
                        v-bind="attrs"
                        v-on="on"
                        color="#003057"
                      >
                      <v-icon color="#FFF" class="mr-1">mdi-calendar</v-icon> {{ $t('WpLabRequest.collectDate') }} {{ editCollectionDate }}
                    </v-btn>
                    </template>
                    <v-date-picker  
                      v-model="editCollectionDate"
                      
                      color="primary"
                        @input="menuCollectionDate = true"
                    ></v-date-picker>
                  </v-menu>
              </div>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <div class="mx-3">
                <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                  :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']"
                  label="Hour"
                  v-model="editCollectionHour"
                  outlined
                ></v-select>
              </div>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <div class="mx-3">
                <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                  :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                  label="Minute"
                  v-model="editCollectionMinute"
                  outlined
                ></v-select>
              </div>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <div class="mx-3">
                <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                  :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                  label="Second"
                  v-model="editCollectionSecond"
                  outlined
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions dense flat>
          <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click="submitEditCollectionDate">{{$t('WpLabRequest.save')}}</v-btn>
            <v-btn outlined color="primary" @click="closeEditCollectionDate">{{$t('WpLabRequest.cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.dialogFindPatient" max-width="700px" eager>
    <v-card id="patientDialogCard">
      <v-card-title>
        <span class="headline">{{$t('WpLabRequest.searchPatient')}}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="pa-0">
            <v-data-table v-model="vDataTableFindPatient.selected"
              :headers="headersFindPatient"
              :items="vDataTableFindPatient.data"
              :search="vDataTableFindPatient.search"
              :page.sync="vDataTableFindPatient.options.page"
              :itemsPerPage.sync="vDataTableFindPatient.options.itemsPerPage"
              :options.sync="vDataTableFindPatient.options"
              show-select single-select
              :footer-props="{
                  itemsPerPageText: $t('itemsPerPageText'),
                  itemsPerPageAllText: $t('itemsPerPageAllText'),
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  firstIcon: 'mdi-arrow-collapse-left',
                  lastIcon: 'mdi-arrow-collapse-right',
                  prevIcon: 'mdi-minus',
                  nextIcon: 'mdi-plus',
                }"
              item-key="patient_skey"
              class="fill-height">
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions dense flat>
        <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click="addPatient" id="addSelectedPatientBtn">{{$t('WpLabRequest.add')}}</v-btn>
          <v-btn outlined color="primary" @click="dialog.dialogFindPatient = false">{{$t('WpLabRequest.cancel')}}</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
    <!-- Create Lab Dialog -->
    <v-dialog v-model="dialog.dialogAddRequest" max-width="90%" persistent>
      <v-card max-width="100%" flat>
        <!-- <v-icon size="30" @click="closeRequestCreated" style="left: 97%; top: 2%; position: absolute;"> mdi-close</v-icon>
        <v-card-title flat>
        </v-card-title> -->
        <v-card-title class="d-flex justify-space-between align-center py-4">
          <h3 style="color: #003057; margin: 0 !important">
            {{ $t('WpLabRequest.labRequest') }}
            <span v-if="current_order_id">
              {{ ' (' + $t('WpLabRequest.labNumber') + ' : ' + current_order_id + ')' }}
            </span>
          </h3>
          <v-icon size="30" @click="closeRequestCreated">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="py-1">
            <v-divider class="mt-0"></v-divider>
            <v-row no-gutters flat  dense justify="start" class="mt-2 mb-2">
              <v-col cols="auto" class="ml-0 mr-0" v-if="showButtons.addNew">
                <div style="align-items: center">
                  <v-btn  
                    color="#0073BE" 
                    height="46px"
                    @click="addOther"
                  >
                    <v-icon color="#FFF" height="24px" width="24px" class="mr-1">mdi-plus</v-icon>
                    {{$t('WpLabRequest.addNew')}}
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mr-0" v-if="showButtons.saveOrder">
                <div style="align-items: center">
                  <v-btn  
                    color="#04AB2F" 
                    height="46px" 
                    @click="createOrder" 
                  >
                    <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-folder-open-outline</v-icon>
                    {{$t('WpLabRequest.saveCreateLabOreder')}}
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-0" v-if="showButtons.savePatient">
                <div style="align-items: center">
                  <v-btn
                  v-if="current_order_skey" 
                  color="#04AB2F"
                  height="46px"
                  :disabled="isAddItemDisabled" 
                  @click="savePatientButton(appName)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-content-save</v-icon>
                  <span v-html="formatText($t('WpLabRequest.save'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <!-- <v-col cols="auto" class="mx-2" v-if="showButtons.editPatient">
                <div style="align-items: center">
                  <v-btn
                  color="primary"
                  height="46px"
                  :disabled="isAddItemDisabled" 
                  @click="editpatientButton(appName)" 
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-square-edit-outline</v-icon>
                  <span v-html="formatText($t('WpLabRequest.editPatientInfo'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col> -->
              <v-col cols="auto" class="mx-0">
                <div style="align-items: center">
                  <v-btn
                  color="#0073BE"
                  height="46px"
                  @click="addSendRequestSelected('|' + orderSkeyCreateList)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-package</v-icon>
                  <span v-html="formatText($t('WpLabRequest.sendPackage'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-0">
                <div style="align-items: center">
                  <v-btn  
                  color="#003057" 
                  height="46px"
                  @click="printRequest(current_order_id)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-1">mdi-printer-outline</v-icon>
                  {{$t('WpLabRequest.requestReport')}}
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-0">
                <div style="align-items: center">
                  <v-btn  
                  color="#003057"
                  height="46px"
                  @click="printReceiptForm('S')"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-1">mdi-printer-outline</v-icon>
                  {{$t('WpLabRequest.ReceiptForm')}}
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-0">
                <div style="align-items: center">
                  <v-btn  
                  color="#e69138" 
                  height="46px"
                  @click="callGetStickerBarcode(orderSkeyCreateList)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-1">mdi-printer-outline</v-icon>
                  {{$t('WpLabRequest.SIDSticker')}}
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-0" v-if="showButtons.cancelPackage">
                <div style="align-items: center">
                  <v-btn
                  color="#CC0202"
                  height="46px"
                  @click="deleteSendRequestSelected('|' + current_package_no)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-file-cancel-outline</v-icon>
                  <span v-html="formatText($t('WpLabRequest.cancelPackage'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-0" v-if="showButtons.cancelLab">
                <div style="align-items: center">
                  <v-btn
                  color="#CC0202"
                  height="46px"
                  @click="deletelabSelected(current_order_skey)" 
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-file-cancel-outline</v-icon>
                  <span v-html="formatText($t('WpLabRequest.cancelLab'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
            </v-row>
            <h4 style="color: black; margin: 16px;">{{$t('WpLabRequest.patientInfo')}}</h4>
            <v-card flat class="mt-2" max-width="100%" v-if="showButtons.searchPatient">
              <v-row no-gutters align="center" class="mt-0 pb-3">
                <v-col class="ms-3 flex-grow-1">
                  <v-text-field 
                    hide-details 
                    outlined 
                    dense 
                    id="searchFirstnameInput"
                    :label="$t('WpLabRequest.searchName')"
                    v-model="criteria.firstname"
                    class="mr-2"
                  ></v-text-field>
                </v-col>

                <v-col class="flex-grow-1">
                  <v-text-field 
                    hide-details 
                    outlined 
                    dense 
                    :label="$t('WpLabRequest.searchLastName')"
                    v-model="criteria.lastname"
                    class="mr-2"
                  ></v-text-field>
                </v-col>

                <v-col class="flex-grow-1">
                  <v-text-field 
                    hide-details 
                    outlined 
                    dense 
                    :label="$t('WpLabRequest.searchHN')"
                    v-model="criteria.hn"
                    class="mr-2"
                  ></v-text-field>
                </v-col>

                <v-col cols="auto" class="mr-0">
                  <v-btn 
                    height="40px" 
                    color="primary" 
                    @click="findPatient" 
                    :disabled="editpatient" 
                    id="searchPatientBtn"
                  >
                    <v-icon class="mr-1">mdi-clipboard-text-search-outline</v-icon>
                    {{$t('WpLabRequest.searchPatient')}}
                  </v-btn>
                </v-col>

                <v-col cols="auto" class="mr-0">
                  <v-btn 
                    height="40px" 
                    color="info" 
                    @click="() => { clearIDCardData(); dialog.dialogIDCard = true; }"
                  >
                    <v-icon class="mr-1">mdi-smart-card-outline</v-icon>
                    Load Smart Card
                  </v-btn>
                </v-col>

                <v-col cols="auto" class="mr-0">
                  <v-btn  
                    height="40px"
                    color="#04AB2F" 
                    class="white--text"                              
                    @click="editpatientFix" 
                    :disabled="!editpatient"
                  >
                    <v-icon color="#FFF" class="mr-2">mdi-folder-open-outline</v-icon>
                    {{$t('WpLabRequest.editPatientInfo')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <v-divider style="border-color: black; border-width: 2px;" class="mb-3"></v-divider>
            <v-card flat>
              <!-- Mark -->
              <v-row class="mt-0" no-gutters>
                <v-col cols="12" sm="4" md="4" lg="3">
                  <v-row no-gutters>
                    <v-col cols="12" sm="7" md="7" lg="6">
                      <div class="ml-3 mr-1">
                        <v-text-field 
                        outlined 
                        dense 
                        hide-details 
                        v-model="hn" 
                        @keydown.enter.prevent="retrieveFromIDCard(hn)" 
                        :readonly="editpatient || currentMode === 'edit'"
                        :label="$t('WpLabRequest.HN')"
                        :style="{ 
                          'font-size': $vuetify.breakpoint.mdAndDown ? '10px' : '16px',
                          'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                        }"
                        >
                        </v-text-field>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="5" md="5" lg="6">
                      <div class="mr-1">
                        <v-select                                    
                          class="custom-select"
                          :items="prefixList"
                          v-model="prefix"
                          item-text="prefix_desc"
                          item-value="prefix_cd"
                          :label="$t('WpLabRequest.prefixRequire')"
                          outlined
                          dense
                          autocomplete
                          hide-details 
                          :readonly="editpatient || currentMode === 'edit'"
                          :error="!prefix && showError"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                          }"
                        >
                        </v-select>
                      </div>
                    </v-col>

                  </v-row>
                </v-col>

                <v-col cols="12" sm="2" md="2" lg="2">
                  <div class="mr-1">
                    <v-text-field 
                      outlined 
                      dense 
                      hide-details 
                      v-model="firstName" 
                      :readonly="editpatient || currentMode === 'edit'"
                      maxlength="100" 
                      :label="$t('WpLabRequest.firstName')"
                      :error="!firstName && showError"
                      :style="{ 
                        'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                        'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                      }"
                    >
                    </v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="2" md="2" lg="2">
                  <div class="mr-1">
                    <v-text-field 
                    outlined 
                    dense 
                    hide-details 
                    v-model="middleName" 
                    :readonly="editpatient || currentMode === 'edit'"
                    maxlength="100"
                    :label="$t('WpLabRequest.middleName')"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                      'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                    }"
                    >
                    </v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="2" md="2" lg="2">
                  <div class="mr-1">
                    <v-text-field 
                    outlined 
                    dense 
                    hide-details 
                    v-model="lastName" 
                    :readonly="editpatient || currentMode === 'edit'"
                    :label="$t('WpLabRequest.lastName')"
                    :error="!lastName && showError"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                      'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                    }"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="2" md="2" lg="3" class="d-flex align-center">
                  <v-text-field
                    class="ma-0 pa-0"
                    hide-details
                    outlined
                    dense
                    :readonly="currentMode === 'edit'"
                    :clearable="currentMode !== 'edit'"
                    :label="$t('WpLabRequest.customer')"
                    v-model="cust_name"
                    :append-outer-icon="currentMode === 'edit' ? null : 'mdi-magnify'"
                    @click:append-outer="openBrowseCustomer"
                    @click:clear="clearCustomer"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                      'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                    }"
                  />
                  <!-- <v-tooltip v-if="currentMode !== 'edit'" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="ml-1 cursor-pointer"
                        @click.stop="newCustomer"
                      >
                        <v-icon small color="primary">
                          mdi-plus
                        </v-icon>
                      </span>
                    </template>
                    <span>New Customer</span>
                  </v-tooltip> -->
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="ml-1"
                        :ripple="false" 
                        style="background-color: transparent !important;"
                      >
                        <v-icon>mdi-account-cog-outline</v-icon>
                      </v-btn>
                    </template>
                    
                    <v-list dense>
                      <v-list-item @click="viewCustomerInfo" :disabled="!cust_skey">
                        <v-list-item-icon class="mr-2">
                          <v-icon small color="blue">mdi-eye</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>View Customer</v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="currentMode !== 'edit'" @click="newCustomer">
                        <v-list-item-icon class="mr-2">
                          <v-icon small color="success">mdi-plus</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>New Customer</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="12" sm="4" md="4" lg="3">
                  <v-row no-gutters>
                    <v-col cols="12" sm="7" md="7" lg="6">
                      <div class="ml-3 mr-1">
                        <v-text-field 
                          outlined 
                          dense 
                          hide-details 
                          v-model="patient_id" 
                          :readonly="editpatient || currentMode === 'edit'"
                          maxlength="100" 
                          :label="$t('Patient ID')"
                          :error="!firstName && showError"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                          }"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="5" md="5" lg="6">
                      <div class="mr-1">
                        <v-menu
                          v-model="menuRequestBrithday"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                          :disabled="editpatient || currentMode === 'edit'"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              readonly
                              dense
                              v-model="dateRequestBrithdayText"
                              :label="$t('WpLabRequest.brithDayRequire')"
                              v-bind="attrs"
                              v-on="(editpatient || currentMode === 'edit') ? {} : on"
                              outlined
                              @click:append="clearDate"
                              hide-details 
                              :append-icon="(dateRequestBrithday && !editpatient && currentMode !== 'edit') ? 'mdi-close' : ''"
                              :error="!dateRequestBrithdayText && showError"     
                              :style="{ 
                                'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                                'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                                'cursor': (editpatient || currentMode === 'edit') ? 'default' : 'pointer'
                              }"      
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateRequestBrithday"
                            @input="updateRequestAge"
                            :max-width="'none'"
                            :disable="editpatient || currentMode === 'edit'"
                            color="primary"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <!-- <v-col cols="12" sm="2" md="2" lg="3">
                      <div class="mx-0">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="age"
                          :readonly="!!dateRequestBrithday || editpatient || currentMode === 'edit'"
                          @focus="disableDatePicker"
                          @blur="enableDatePicker"
                          @input="handleAgeChange"
                          maxlength="3"
                          :error="!age && showError"
                          :label="$t('WpLabRequest.age')"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '10px' : '16px',
                            'background-color': (!!dateRequestBrithday || editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                          }"
                        >
                        </v-text-field>
                      </div>
                    </v-col> -->

                  </v-row>
                </v-col>

                <v-col cols="12" sm="2" md="2" lg="2">
                  <v-row no-gutters>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <div class="mr-1">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="age"
                          :readonly="!!dateRequestBrithday || editpatient || currentMode === 'edit'"
                          @focus="disableDatePicker"
                          @blur="enableDatePicker"
                          @input="handleAgeChange"
                          maxlength="3"
                          :error="!age && showError"
                          :label="$t('WpLabRequest.age')"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '10px' : '16px',
                            'background-color': (!!dateRequestBrithday || editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent'
                          }"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <div class="mr-1">
                        <v-select
                          :items="sexListAll"
                          v-model="sex"
                          item-text="sex_desc"
                          item-value="sex_cd"
                          :label="$t('WpLabRequest.sexRequire')"
                          outlined dense hide-details
                          :readonly="editpatient || currentMode === 'edit'"
                          :error="!sex && showError"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                          }"
                        >
                        </v-select>
                      </div>
                    </v-col>

                  </v-row>
                  
                </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2">
                    <div class="mr-1">
                      <v-text-field
                        v-model="idCardText"
                        :label="$t('WpLabRequest.cid')"
                        prepend-inner-icon="mdi-card-account-details-outline"
                        outlined
                        dense
                        hide-details
                        :readonly="editpatient || currentMode === 'edit'"
                        :style="{ 
                          'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                          'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                        }"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" lg="5">
                    <v-row no-gutters>
                      <v-col cols="12" sm="4" md="4" lg="4">
                      <div class="mr-1">
                        <v-text-field 
                          outlined 
                          dense 
                          hide-details 
                          v-model="hospital_lab_no" 
                          :readonly="editpatient || currentMode === 'edit'"
                          maxlength="100"
                          :label="$t('WpLabRequest.hln')"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            'background-color': (editpatient || currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                          }"
                        >
                        </v-text-field>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="4" md="4" lg="4">
                      <div class="mr-1">
                        <v-select
                          v-model="payment"
                          :items="paymentListAll"
                          :label="$t('WpLabRequest.payment')"
                          item-text="description"
                          item-value="code"
                          outlined
                          dense
                          hide-details
                          :readonly="currentMode === 'edit'"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                          }"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4">
                      <div class="mr-1">
                        <v-select
                          :items="patientRightsList"
                          v-model="patientRights"
                          item-text="description"
                          item-value="code"
                          :label="$t('WpLabRequest.patientRights')"
                          outlined dense hide-details
                          :readonly="currentMode === 'edit'"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                          }"
                        >
                        </v-select>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="3" sm="3" md="3">
                    <div class="ml-3">
                      <v-menu
                        v-model="menuRequestReceive"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        :readonly="currentMode === 'edit'"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            dense
                            append-icon="mdi-calendar-month"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :disabled="currentMode === 'edit'"
                            color="#003057"
                            width="23.5%"
                            style="position: absolute;"
                            :style="{ 
                              'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            }"
                          >
                          <v-icon color="#FFF" class="mr-1">mdi-calendar</v-icon> {{ $t('WpLabRequest.collectDate') }} {{ dateRequestCollectionText }}
                        </v-btn>
                        </template>
                        <v-date-picker
                          v-model="dateRequestCollection"
                          @input="menuRequestReceive = false"
                          :readonly="editpatient"
                          color="primary"
                          :disable="currentMode === 'edit'"
                        ></v-date-picker>
                      </v-menu>
                  </div>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="">
                  <div class="d-flex">                    
                    <v-select
                      v-model="selectedHour"
                      :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                      label="Hour"
                      dense outlined hide-details
                      :readonly="currentMode === 'edit'"
                      class="mr-1"
                      :style="{ 
                        'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                        'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                      }"
                    ></v-select>

                    <v-select
                      v-model="selectedMinute"
                      :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                      label="Minute"
                      dense outlined hide-details
                      :readonly="currentMode === 'edit'"
                      class="mr-1"
                      :style="{ 
                        'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                        'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                      }"
                    ></v-select>

                    <v-select
                      v-model="selectedSecond"
                      :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                      label="Second"
                      dense outlined hide-details
                      :readonly="currentMode === 'edit'"
                      class="mr-1"
                      :style="{ 
                        'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                        'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                      }"
                    ></v-select>
                    
                  </div>
                </v-col>
                
                <v-col cols="4" sm="2" md="2">
                  <div class="mr-1">
                    <v-text-field 
                    outlined 
                    dense 
                    hide-details 
                    v-model="requestBy" 
                    maxlength="100"
                    :label="$t('WpLabRequest.requestBy')"
                    :readonly="currentMode === 'edit'"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                      'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                    }"
                  >
                  </v-text-field>
                  </div>
                </v-col>

                <v-col cols="4" sm="2" md="2">
                  <div class="mr-1">
                    <v-text-field 
                    outlined 
                    dense 
                    hide-details 
                    v-model="refDoc" 
                    maxlength="100"
                    :label="$t('WpLabRequest.refDoc')"
                    :readonly="currentMode === 'edit'"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                      'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                    }"
                  >
                  </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="2" md="2" lg="2">
                      <div class="mr-1">
                        <v-select
                          :items="serviceChannelList"
                          v-model="serviceChannel"
                          item-text="code"
                          item-value="code"
                          :label="$t('WpLabRequest.serviceChannel')"
                          outlined dense hide-details
                          :readonly="currentMode === 'edit'"
                          :style="{ 
                            'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                            'background-color': (currentMode === 'edit') ? '#F5F5F5' : 'transparent',
                          }"
                        >
                        </v-select>
                      </div>
                    </v-col>
                
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="12" sm="12">
              <!-- <v-row no-gutters class="mt-3"> -->
                  <v-card flat class="custom-tabs-container">
                    <v-tabs
                      v-model="tab"
                      background-color="transparent"
                      color="primary"
                      height="40" 
                      active-class="font-weight-bold"
                      slider-size="3"
                    >
                      <v-tab href="#order-item" class="text-capitalize custom-tab-item">
                        <v-icon small left>mdi-cart-outline</v-icon>
                        {{ $t('WpLabRequest.aOrderItem') }}
                      </v-tab>

                      <v-tab href="#pricing" class="text-capitalize custom-tab-item">
                        <v-icon small left>mdi-currency-usd</v-icon>
                        {{ $t('WpLabRequest.pricing') }}
                      </v-tab>

                      <v-tab href="#specimen-type" class="text-capitalize custom-tab-item">
                        <v-icon small left>mdi-test-tube</v-icon>
                        {{ $t('WpLabRequest.specimenType') }}
                      </v-tab>
                    </v-tabs>
                    <v-divider></v-divider>
                    <v-tabs-items v-model="tab" style="height: auto; min-height: 300px;">
                      <v-tab-item value="order-item">
                        <div class="ml-3 mt-1">
                          <!-- ส่วนปุ่มด้านบน (แสดงเฉพาะเมื่อยังไม่ create) -->
                          <v-row style="margin-top: -10px;">
                            <v-col class="mb-2">
                              <v-btn  
                                id="addOrderItemBtn"
                                color="#0073BE" 
                                height="46px"
                                @click="addOrderItem(true)"
                              >
                                <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-plus</v-icon>
                                {{ $t('WpLabRequest.addOrderItem') }}
                              </v-btn>
                              <v-divider class="mx-1" inset vertical></v-divider>
                              <v-btn  
                                color="#CC0202" 
                                height="46px"
                                @click="checkDeleteselected"
                                style="text-transform: capitalize"
                              >
                                <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-trash-can-outline</v-icon>
                                {{ $t('WpLabRequest.deleteOrderItem') }}
                              </v-btn>
                            </v-col>
                          </v-row>
                          <!-- :headers="LabOrderItemHeadersList" -->
                          <!-- :height="$vuetify.breakpoint.height - 700" -->
                          <v-data-table
                            dense
                            v-model="vDataTable2.selected"
                            :headers="LabOrderItemHeadersList"
                            :items="vDataTable2.data"
                            :search="vDataTable2.search"
                            fixed-header
                            :page.sync="vDataTable2.options.page"
                            :itemsPerPage.sync="vDataTable2.options.itemsPerPage"
                            :options.sync="vDataTable2.options"
                            show-select
                            :footer-props="{
                              itemsPerPageText: $t('itemsPerPageText'),
                              itemsPerPageAllText: $t('itemsPerPageAllText'),
                              showFirstLastPage: true,
                              showCurrentPage: true,
                              firstIcon: 'mdi-arrow-collapse-left',
                              lastIcon: 'mdi-arrow-collapse-right',
                              prevIcon: 'mdi-minus',
                              nextIcon: 'mdi-plus',
                            }"
                            item-key="order_item_skey"
                            class="elevation-0">
                            
                            <template v-slot:item.is_urgent="{ item }">
                              <v-row dense flat justify="start" align="center">
                                <v-col cols="9" class="d-flex justify-center align-center">
                                  <v-icon
                                    class="icon-noti"
                                    :color="item.is_urgent ? 'red' : '#A9A9A9'"
                                    size="30"
                                    @click="updateIsCheck(item, 2)"
                                  >
                                    mdi-bell-ring-outline
                                  </v-icon>
                                </v-col>
                              </v-row>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                              <v-icon color="pink" small class="mr-2" @click="deleteRowItemConfirm(item)">delete</v-icon>
                            </template>

                            <template v-slot:item.active="{ item }">
                              <v-simple-checkbox
                                v-model="item.active"
                                color="primary"
                                @input="onRowEdited(item)" 
                              ></v-simple-checkbox>
                            </template>

                            <template v-slot:item.cancel="{ item }">
                              <v-simple-checkbox
                                v-model="item.cancel"
                                color="error"
                                @input="onRowEdited(item)"
                              ></v-simple-checkbox>
                            </template>

                            <!-- <template v-slot:item.note="{ item }">
                              <v-btn icon @click="openNoteDialog(item)">
                                <v-icon :color="item.note ? 'blue' : (item.edit_flag === 1 ? 'orange' : 'grey')">
                                  mdi-note-text-outline
                                </v-icon>
                              </v-btn>
                            </template> -->
                            <template v-slot:[`item.note`]="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" :color="item.note ? 'blue' : 'gray'" large class="mr-2" @click="openNoteDialog(item)">check_circle</v-icon>
                                </template>
                                <span>{{$t('WpLabRequest.note')}}</span>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                          <!-- :headers="AfterCreatedHeaders" -->
                          <!-- <v-data-table
                            v-if="isCreateSuccess"
                            v-model="vDataTableAfterCreated.selected"
                            :headers="AfterCreatedHeaders"
                            :items="vDataTableAfterCreated.data"
                            :search="vDataTableAfterCreated.search"
                            fixed-header
                            :page.sync="vDataTableAfterCreated.options.page"
                            :itemsPerPage.sync="vDataTableAfterCreated.options.itemsPerPage"
                            :options.sync="vDataTableAfterCreated.options"
                            :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
                            :footer-props="{
                              itemsPerPageText: $t('itemsPerPageText'),
                              itemsPerPageAllText: $t('itemsPerPageAllText'),
                              showFirstLastPage: true,
                              showCurrentPage: true,
                              firstIcon: 'mdi-arrow-collapse-left',
                              lastIcon: 'mdi-arrow-collapse-right',
                              prevIcon: 'mdi-minus',
                              nextIcon: 'mdi-plus',
                            }"
                            item-key="specimenTypeId"
                            class="fill-height"
                            show-expand single-expand>
                              <template v-slot:item.requireCollectionDate="{ item }">
                                <v-icon 
                                  v-if="item.requireCollectionDate === 2" 
                                  large 
                                  color="green"
                                >
                                  mdi-check
                                </v-icon>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon 
                                      v-if="item.requireCollectionDate === 1" 
                                      large 
                                      color="red" 
                                      v-bind="attrs" 
                                      v-on="on"
                                    >
                                      mdi-exclamation
                                    </v-icon>
                                  </template>
                                  <span>{{ $t('WpLabRequest.enterReceiveDate') }}</span>
                                </v-tooltip>
                              </template>
                            <template v-slot:item.collectionDate="{ item }">
                              {{ formatDateTimeDisplay(item.collectionDate) }} 
                              <v-icon v-if="item.requireCollectionDate === 1 || item.requireCollectionDate === 2" large color="blue" @click="updateLabCollectionDate(item)">mdi-calendar-edit</v-icon>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                              <td :colspan="headers.length" style="background-color: #f0f0f0; padding: 3;">
                                <v-card class="ma-3" style="overflow-x: auto; ">
                                  <v-data-table
                                    fixed-header
                                    :headers="AfterCreatedItemHeaders"
                                    :items="item.orderItems"
                                    class="elevation-1"
                                    hide-default-footer
                                    style="margin: auto;"
                                    dense>
                                    <template v-slot:top>
                                      <v-toolbar flat>
                                        <v-toolbar-title>{{$t('WpLabRequest.aOrderItem')}}</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                      </v-toolbar>
                                    </template>
                                    <template v-slot:item.price="{ item }">
                                      <div class="text-right pe-5">
                                        {{ formatPrice(item.price) }}
                                      </div>
                                    </template>
                                  </v-data-table>
                                </v-card>
                              </td>
                            </template>
                          </v-data-table> -->
                        </div>
                      </v-tab-item>
                      <v-tab-item value="pricing">
                        <div class="ml-3 mt-1">
                          <v-data-table
                            dense
                            v-model="vDataTableLisLabPricing.selected"
                            :headers="headerDataTableLisLabPricing"
                            :items="vDataTableLisLabPricing.data"
                            :search="vDataTableLisLabPricing.search"
                            fixed-header
                            :page.sync="vDataTableLisLabPricing.options.page"
                            :itemsPerPage.sync="vDataTableLisLabPricing.options.itemsPerPage"
                            :options.sync="vDataTableLisLabPricing.options"
                            :footer-props="{
                              itemsPerPageText: $t('itemsPerPageText'),
                              itemsPerPageAllText: $t('itemsPerPageAllText'),
                              showFirstLastPage: true,
                              showCurrentPage: true,
                              firstIcon: 'mdi-arrow-collapse-left',
                              lastIcon: 'mdi-arrow-collapse-right',
                              prevIcon: 'mdi-minus',
                              nextIcon: 'mdi-plus',
                            }"
                            item-key="resource_no"
                            class="elevation-0">
                            
                            <template v-slot:item.is_urgent="{ item }">
                              <v-row dense flat justify="start" align="center">
                                <v-col cols="9" class="d-flex justify-center align-center">
                                  <v-icon
                                    class="icon-noti"
                                    :color="item.is_urgent ? 'red' : '#A9A9A9'"
                                    size="30"
                                    @click="updateIsCheck(item, 2)"
                                  >
                                    mdi-bell-ring-outline
                                  </v-icon>
                                </v-col>
                              </v-row>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                              <v-icon color="pink" small class="mr-2" @click="deleteRowItemConfirm(item)">delete</v-icon>
                            </template>

                            <!-- <template v-slot:item.price="{ item }">
                              <div class="text-right pe-5">{{ formatPrice(item.price) }}</div>
                            </template>
                            <template v-slot:item.qty="{ item }">
                              <div class="text-right pe-5">{{ formatPrice(item.qty) }}</div>
                            </template>

                            <template v-slot:item.disc_pct="{ item }">
                              <div class="text-right pe-5">{{ formatPrice(item.disc_pct) }}</div>
                            </template>

                            <template v-slot:item.disc_amount="{ item }">
                              <div class="text-right pe-5">{{ formatPrice(item.disc_amount) }}</div>
                            </template>

                            <template v-slot:item.total_amount="{ item }">
                              <div class="text-right pe-5">{{ formatPrice(item.total_amount) }}</div>
                            </template> -->
                            <template v-slot:item.price="{ item }">
                              <v-text-field
                                v-model.number="item.price"
                                outlined
                                dense
                                hide-details
                                type="number"
                                class="text-right-input"
                                @input="onRowEdited(item)"
                              ></v-text-field>
                            </template>

                            <template v-slot:item.qty="{ item }">
                              <v-text-field
                                v-model.number="item.qty"
                                outlined
                                dense
                                hide-details
                                type="number"
                                class="text-right-input"
                                @input="onRowEdited(item)"
                              ></v-text-field>
                            </template>

                            <template v-slot:item.disc_pct="{ item }">
                              <v-text-field
                                v-model.number="item.disc_pct"
                                outlined
                                dense
                                hide-details
                                type="number"
                                suffix="%"
                                class="text-right-input"
                                @input="onDiscountPctChanged(item)"
                              ></v-text-field>
                            </template>

                            <template v-slot:item.disc_amount="{ item }">
                              <v-text-field
                                v-model.number="item.disc_amount"
                                outlined
                                dense
                                hide-details
                                type="number"
                                class="text-right-input"
                                @input="onDiscountAmountChanged(item)"
                              ></v-text-field>
                            </template>

                            <template v-slot:item.total_amount="{ item }">
                              <div class="text-right pe-5 font-weight-bold blue--text">
                                {{ formatPrice(calculateRowTotal(item)) }}
                              </div>
                            </template>

                            <template v-slot:[`item.is_get_back`]="{ item }">
                              <v-checkbox v-model="item.is_get_back" @click="updateIsCheck(item, 1)">item.is_get_back</v-checkbox>
                            </template>

                            <template v-slot:item.filename="{ item }">
                              <v-tooltip bottom v-if="item.filename !== null">
                                <template v-slot:activator="{ on }">
                                  <v-row dense flat justify="start" align="center">
                                    <v-col cols="9" class="d-flex justify-center align-center">
                                      <v-icon v-on="on" color="blue" @click="clickPreviewImage(item.order_item_skey)" size="30">
                                        mdi-file-download-outline
                                      </v-icon>
                                    </v-col>
                                  </v-row>                                
                                </template>
                                <span>{{ $t('WpLabRequest.remarkForm') }}</span>
                              </v-tooltip>
                            </template>

                            <template v-slot:footer>
                              <v-divider></v-divider>
                              <div class="pa-4 d-flex justify-end align-center">
                                <span class="text-h6 font-weight-bold mr-4">{{ $t('WpLabRequest.totalPrice') }}:</span>
                                <span class="text-h6 primary--text font-weight-bold">
                                  {{ formatPrice(calculateGrandTotal()) }}
                                </span>
                              </div>
                            </template>
                          </v-data-table>
                        </div>
                      </v-tab-item>
                      <v-tab-item value="specimen-type">
                        <div class="ml-3 mt-1">
                          <v-data-table
                            dense
                            v-model="vDataTableLisLabSpecimenType.selected"
                            :headers="headerDataTableLisLabSpecimenType"
                            :items="vDataTableLisLabSpecimenType.data"
                            :search="vDataTableLisLabSpecimenType.search"
                            fixed-header
                            :height="$vuetify.breakpoint.height - 640"
                            :page.sync="vDataTableLisLabSpecimenType.options.page"
                            :itemsPerPage.sync="vDataTableLisLabSpecimenType.options.itemsPerPage"
                            :options.sync="vDataTableLisLabSpecimenType.options"
                            show-select
                            :footer-props="{
                              itemsPerPageText: $t('itemsPerPageText'),
                              itemsPerPageAllText: $t('itemsPerPageAllText'),
                              showFirstLastPage: true,
                              showCurrentPage: true,
                              firstIcon: 'mdi-arrow-collapse-left',
                              lastIcon: 'mdi-arrow-collapse-right',
                              prevIcon: 'mdi-minus',
                              nextIcon: 'mdi-plus',
                            }"
                            item-key="specimen_type_id"
                            class="elevation-0"
                            show-expand single-expand>
                            <template v-slot:expanded-item="{ headers, item }">
                              <td :colspan="headers.length" style="background-color: #f0f0f0; padding: 3;">
                                <v-card class="ma-3" style="overflow-x: auto; ">
                                  <v-data-table
                                    fixed-header
                                    :headers="headerDataTableLisLabSpecimenTypeTestItem"
                                    :items="item.lis_lab_specimen_type_test_item"
                                    class="elevation-1"
                                    hide-default-footer
                                    style="margin: auto;"
                                    dense>
                                  </v-data-table>
                                </v-card>
                              </td>
                            </template>
                          </v-data-table>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-col>
              </v-row>
              <!-- </v-row> -->
            </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Edit Lab Dialog -->
    <v-dialog v-model="dialog.dialogAddEditWindow" max-width="100%"  >
      <v-card outlined elevation="2" class="rounded-lg main-work-card">
        <v-icon 
        size="30"
        style="position: absolute;  left: 95%; top: 5%;  "
        @click="close" 
       >
          mdi-close
        </v-icon>
        <v-card-title>
        </v-card-title>
       
        <v-card-text>
          
          <span class="font-weight-bold"><h3 style="color: #003057;" >{{ $t('WpLabRequest.labRequest') }}</h3></span>
            <v-divider class="mt-3"></v-divider>
            <v-row no-gutters justify="start">
              <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn
                  v-if="current_order_skey" 
                  color="#04AB2F"
                  height="46px"
                  :disabled="isAddItemDisabled" 
                  @click="savePatientButton(appName)" 
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-content-save</v-icon>
                  <span v-html="formatText($t('WpLabRequest.save'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <!-- <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn
                  color="primary"
                  height="46px"
                  :disabled="isAddItemDisabled" 
                  @click="editpatientButton(appName)" 
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-square-edit-outline</v-icon>
                  <span v-html="formatText($t('WpLabRequest.editPatientInfo'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col> -->
              <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn
                  color="#0073BE"
                  height="46px"
                  
                  @click="addSendRequestSelected('|' + orderSkeyCreateList)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-package</v-icon>
                  <span v-html="formatText($t('WpLabRequest.sendPackage'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn
                  color="#003057"
                  height="46px"
                  @click="printRequest(current_order_id)" 
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-printer-outline</v-icon>
                  <span v-html="formatText($t('WpLabRequest.requestReport'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn
                  color="#CC0202"
                  height="46px"
                  @click="deleteSendRequestSelected('|' + current_package_no)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-file-cancel-outline</v-icon>
                  <span v-html="formatText($t('WpLabRequest.cancelPackage'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn
                  color="#CC0202"
                  height="46px"
                  @click="deletelabSelected(current_order_skey)" 
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-file-cancel-outline</v-icon>
                  <span v-html="formatText($t('WpLabRequest.cancelLab'))" class="text-left"></span>
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn  
                  color="#003057"
                  height="46px"
                  
                  @click="printReceiptForm('S')"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-1">mdi-printer-outline</v-icon>
                  {{$t('WpLabRequest.ReceiptForm')}}
                </v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <div style="align-items: center">
                  <v-btn  
                  color="#e69138" 
                  height="46px"
                  
                  @click="callGetStickerBarcode(orderSkeyCreateList)"
                >
                  <v-icon color="#FFF" height="24px" width="24px" class="mr-1">mdi-printer-outline</v-icon>
                  {{$t('WpLabRequest.SIDSticker')}}
                </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-tabs class="w-100 ma-0 pa-0" center-active dense flat v-model="active_tab" style="color: #000000 !important;">
              <!--RRRRr -->
              <v-tab style="color: #000000 !important;">{{$t('WpLabRequest.patientInfo')}}</v-tab>
              <v-tab-item eager v-show="vDataTable.editedItem.company_flag != 'Y'">
                <v-card flat>
                  <v-row class="mt-3" no-gutters>
                    <v-col cols="3" sm="3" md="3">
                      <v-row no-gutters>
                        <v-col cols="7" sm="7" md="7">
                          <div class="mx-3">
                            <v-text-field 
                            outlined 
                            dense 
                            hide-details 
                            v-model="hn" 
                            maxlength="50"
                            :label="$t('WpLabRequest.HN')"
                            @keydown.enter.prevent="retrieveFromIDCard(hn)" 
                            :disabled="editpatient">
                            </v-text-field>
                          </div>
                        </v-col>

                        <v-col cols="5" sm="5" md="5">
                          <div class="mx-3">
                            
                            <v-select
                              class="custom-select"
                              :items="prefixList"
                              v-model="prefix"
                              item-text="prefix_desc"
                              item-value="prefix_cd"
                              :label="$t('WpLabRequest.prefix')"
                              outlined
                              dense
                              autocomplete
                              hide-details 
                              :disabled="editpatient"
                            >
                            </v-select>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3" sm="3" md="2">
                      <div class="mx-3">
                        <v-text-field outlined dense hide-details v-model="firstName" :disabled="editpatient" maxlength="100">
                        <template v-slot:label>
                          <span class="input__label text-title">{{ $t('WpLabRequest.firstName') }}</span>
                        </template>
                      </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="2" sm="2" md="2">
                      <div class="mx-3">
                        <v-text-field outlined dense hide-details v-model="middleName" :disabled="editpatient" maxlength="100">
                          <template v-slot:label>
                            <span class="input__label text-title">{{ $t('WpLabRequest.middleName') }}</span>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="3" sm="3" md="2">
                      <div class="mx-3">
                        <v-text-field outlined dense hide-details v-model="lastName" :disabled="editpatient" maxlength="100">
                          <template v-slot:label>
                            <span class="input__label text-title">{{ $t('WpLabRequest.lastName') }}</span>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="3" md="3" class="d-flex align-center">
                      <v-text-field
                        class="ma-0 pa-0"
                        hide-details
                        outlined
                        dense
                        :label="$t('WpLabRequest.customer')"
                        v-model="cust_name"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mt-3" no-gutters>
                    <v-col cols="4" sm="4" md="4">
                      <v-row no-gutters>
                        <v-col cols="9" sm="9" md="9">
                          <div class="mx-3">
                              <v-menu
                                v-model="menuBrithday"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    dense
                                    v-model="dateBrithdayText"
                                    :label="$t('WpLabRequest.brithDay')"
                                    append-icon="mdi-calendar-month"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    @click:append="clearDate"
                                    :disabled="editpatient"
                                    hide-details
                                    :append-icon="dateBrithday ? 'mdi-close' : ''"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="dateBrithday"
                                  @input="updateAge"
                                  :disabled="ageEditing"
                                  :max-width="'none'"
                                  
                                  color="primary"
                                ></v-date-picker>
                              </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                          <div class="mx-3">
                          <v-text-field
                              outlined
                              dense
                              hide-details
                              v-model="age"
                              :readonly="!!dateBrithday || editpatient"
                              @focus="disableDatePicker"
                              @blur="enableDatePicker"
                              @input="handleAgeChange"
                              maxlength="3"
                            >
                              <template v-slot:label>
                                <span class="input__label text-title">{{ $t('WpLabRequest.age') }}</span>
                              </template>
                            </v-text-field>
                        </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4" sm="4" md="2">
                      <div class="mx-3">
                        <v-select
                          :items="sexListAll"
                          v-model="sex"
                          item-text="sex_desc"
                          item-value="sex_cd"
                          :label="$t('WpLabRequest.sex')"
                          outlined dense hide-details
                          :disabled="editpatient"
                        >
                        </v-select>
                          </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <v-row no-gutters>
                        <v-col cols="6" sm="6" md="6">
                          <div class="mx-3">
                            <v-text-field 
                              outlined 
                              dense 
                              hide-details 
                              v-model="hospital_lab_no" 
                              :disabled="editpatient"
                              maxlength="100"
                            >
                              <template v-slot:label>
                                <span class="input__label text-title">{{ $t('WpLabRequest.hln') }}</span>
                              </template>
                            </v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                          <div class="mx-3">
                            <v-text-field
                              :value="getPaymentDescription(payment)"
                              :label="$t('WpLabRequest.payment')"
                              outlined dense hide-details
                              disabled
                            />
                          </div>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="3">
                          <div class="mx-3">
                            <!-- เพศ -->
                            <v-select
                              disabled
                              :items="patientRightsList"
                              v-model="patientRights"
                              item-text="description"
                              item-value="code"
                              :label="$t('WpLabRequest.patientRights')"
                              outlined dense hide-details
                              :error="!patientRights && showError"
                              :style="{ 
                                'font-size': $vuetify.breakpoint.mdAndDown ? '12px' : '16px',
                              }"
                            >
                            </v-select>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="mt-3" no-gutters>
                    <v-col cols="3" sm="3" md="3">
                      <div class="mx-3">
                        <v-menu
                          v-model="menuReceive"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                              <v-btn
                              dense
                              append-icon="mdi-calendar-month"
                              disabled
                              v-bind="attrs"
                              v-on="on"
                            
                              color="#003057"
                              width="23.5%"
                              style="position: absolute;"
                            >
                            <v-icon color="#FFF" class="mr-1">mdi-calendar</v-icon> {{ $t('WpLabRequest.collectDate') }} {{ dateCollectionText }}
                          </v-btn>
                          </template>
                          <v-date-picker  
                            v-model="dateCollection"
                            
                            color="primary"
                              @input="menuReceive = true"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                      <div class="mx-3">
                        <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                          :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']"
                          label="Hour"
                          v-model="selectedHour"
                          outlined
                          :disabled="editpatient"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                      <div class="mx-3">
                        <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                          :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                          label="Minute"
                          v-model="selectedMinute"
                          outlined
                          :disabled="editpatient"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                      <div class="mx-3">
                        <v-select class="ma-0 pa-0 d-flex align-center justify-center" dense hide-details
                          :items="['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']"
                          label="Second"
                          v-model="selectedSecond"
                          outlined
                          :disabled="editpatient"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="3">
                      <div class="mx-3">
                        <v-text-field 
                        outlined 
                        dense 
                        hide-details 
                        v-model="requestBy" 
                        :disabled="editpatient"
                        maxlength="100"
                      >
                        <template v-slot:label>
                          <span class="input__label text-title">{{ $t('WpLabRequest.requestBy') }}</span>
                        </template>
                      </v-text-field>
                      </div>
                    </v-col>

                    <v-col cols="3" sm="3" md="3">
                      <!-- เอกสารอ้างอิง -->
                      <div class="mx-3">
                        <v-text-field 
                        outlined 
                        dense 
                        hide-details 
                        v-model="refDoc" 
                        :disabled="editpatient"
                        maxlength="100"
                        :label="$t('WpLabRequest.refDoc')"
                      >
                      </v-text-field>
                      </div>
                    </v-col>
                  </v-row> 
                </v-card>
              </v-tab-item>
            </v-tabs>

            <v-row class="mt-2 mb-2">
              <v-col>
                <v-divider class="mx-1" inset vertical></v-divider>
                <v-btn 
                :disabled="isAddItemDisabled" 
                 height="46px"
                color="#0073BE" 
                @click="addOrderItem(false)">
                <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-plus</v-icon>
                  {{ $t('WpLabRequest.addOrderItem') }}
                </v-btn>
                <v-divider class="mx-1" inset vertical></v-divider>
                <v-btn 
                :disabled="isAddItemDisabled" 
                color="#CC0202" 
                height="46px"
                @click="checkDeleteselected">
                <v-icon color="#FFF" height="24px" width="24px" class="mr-2">mdi-trash-can-outline</v-icon>
                  {{ $t('WpLabRequest.deleteOrderItem') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-data-table
                v-model="vDataTable2.selected"
                :headers="LabOrderItemHeadersList"
                :items="vDataTable2.data"
                :search="vDataTable2.search"
                fixed-header
                :page.sync="vDataTable2.options.page"
                :itemsPerPage.sync="vDataTable2.options.itemsPerPage"
                :options.sync="vDataTable2.options"
                :height="$vuetify.breakpoint.height - 430 - offsetAppBar"
                show-select
                :footer-props="{
                  itemsPerPageText: $t('itemsPerPageText'),
                  itemsPerPageAllText: $t('itemsPerPageAllText'),
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  firstIcon: 'mdi-arrow-collapse-left',
                  lastIcon: 'mdi-arrow-collapse-right',
                  prevIcon: 'mdi-minus',
                  nextIcon: 'mdi-plus',
                }"
                item-key="order_item_id"
                class="fill-height">
                <template v-slot:footer="{ itemsPerPage, pageStart, pageStop }">
                  <tr>
                    <td colspan="6"></td> 
                    <td>ราคารวมทั้งหมด :</td>
                    <td>{{ calculateTotal('medium_price') }}</td>
                  </tr>
                </template>
                <template v-slot:item.filename="{ item }">
                  <v-tooltip bottom v-if="item.filename">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" class="mr-2" large @click="clickPreviewImage(item.order_item_skey)">mdi-file-download-outline</v-icon>
                    </template>
                    <span>{{ $t('WpLabRequest.remarkForm') }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.medium_price="{ item }">
                  <div class="text-right pe-5">
                    {{ formatPrice(item.medium_price) }}
                  </div>
                </template>
                <template v-slot:item.qty="{ item }">
                  <div class="text-right pe-5">
                    {{ formatPrice(item.qty) }}
                  </div>
                </template>
                <template v-slot:item.disc_pct="{ item }">
                  <div class="text-right pe-5">
                    {{ formatPrice(item.disc_pct) }}
                  </div>
                </template>
                <template v-slot:item.disc_amount="{ item }">
                  <div class="text-right pe-5">
                    {{ formatPrice(item.disc_amount) }}
                  </div>
                </template>
                <template v-slot:item.total_amount="{ item }">
                  <div class="text-right pe-5">
                    {{ formatPrice(item.total_amount) }}
                  </div>
                </template>
                <template v-slot:item.is_get_back="{ item }">
                  <v-checkbox v-model="item.is_get_back" @click="updateIsCheck(item, 1)">item.is_get_back</v-checkbox>
                </template>
                <template v-slot:item.is_urgent="{ item }">
                <v-row dense flat justify="start" align="center">
                  <v-col cols="9" class="d-flex justify-center align-center">
                    <div>
                      <v-icon
                        class="icon-noti"
                        :color="item.is_urgent ? 'red' : '#A9A9A9'"
                        size="30"
                        @click="updateIsCheck(item, 2)"
                      >
                        mdi-bell-ring-outline
                      </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </template>
              </v-data-table>
            </v-row>
        </v-card-text>
      </v-card>

    </v-dialog>
    <v-dialog v-model="dialog.dialogViewItem" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('WpLabRequest.viewItem') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0"
                    outlined
                    name="input-7-4"
                  :label="$t('WpLabRequest.viewOrderId')"
                  v-model="viewOrderItemID"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('WpLabRequest.viewOrderDesc')"
                  v-model="viewOrderItemDesc"
                  readonly
                ></v-text-field>
              </v-col> 
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('WpLabRequest.lablaboratory')"
                  v-model="viewSubcategory"
                  readonly
                ></v-text-field>
              </v-col> 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeViewitem">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddOrder" max-width="100%" eager fullscreen>
      <v-card class="text-center my-5 py-5"  id="dialog-add-order">
        <v-card-title>
          <span class="headline">{{ $t('WpLabRequest.orderitemHeader') }}</span>
        </v-card-title>
        <v-card-text class="pt-1">
          <v-container fluid>
            <v-container v-if="!current_order_id">
              <v-row class="mt-" no-gutters>
                <v-col cols="4" sm="4" md="4">
                  <v-row no-gutters>
                    <v-col cols="6" sm="6" md="6">
                      <div class="mx-3">
                        <v-text-field outlined dense hide-details v-model="hn" maxlength="50" disabled>
                          <template v-slot:label>
                            <span class="input__label text-title">{{ $t('WpLabRequest.HN') }}</span>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <div class="mx-3">
                        <v-text-field
                          class="custom-select"
                          v-model="prefix"
                          :label="$t('WpLabRequest.prefix')"
                          outlined
                          dense
                          hide-details 
                          disabled
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="mx-3">
                    <v-text-field outlined dense hide-details v-model="firstName" disabled maxlength="100">
                    <template v-slot:label>
                      <span class="input__label text-title">{{ $t('WpLabRequest.firstName') }}</span>
                    </template>
                  </v-text-field>
                  </div>
                </v-col>
                <v-col cols="2" sm="2" md="2">
                  <div class="mx-3">
                    <v-text-field outlined dense hide-details v-model="middleName" disabled maxlength="100">
                      <template v-slot:label>
                        <span class="input__label text-title">{{ $t('WpLabRequest.middleName') }}</span>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="mx-3">
                    <v-text-field outlined dense hide-details v-model="lastName" disabled maxlength="100">
                      <template v-slot:label>
                        <span class="input__label text-title">{{ $t('WpLabRequest.lastName') }}</span>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <!-- <v-col cols="4" sm="3" md="4" class="d-flex align-center">
                  <v-text-field
                    class="ma-0 pa-0"
                    hide-details
                    outlined
                    dense
                    clearable
                    :label="$t('WpLabRequest.customer')"
                    v-model="cust_name"
                    append-outer-icon="mdi-magnify"
                    @click:append-outer="openBrowseCustomer"
                    @click:clear="clearCustomer"
                  />

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        elevation="0"
                        class="ml-1 no-bg"
                        v-bind="attrs"
                        v-on="on"
                        @click="copyPatientToCustomer" color="primary"
                      >
                        <v-icon  color="primary">mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Copy Patient Info to Customer</span>
                  </v-tooltip>
                </v-col> -->
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="4" sm="4" md="4">
                    <v-row no-gutters>
                      <v-col cols="8" sm="8" md="8">
                        <div class="mx-3">
                          <v-text-field outlined dense hide-details v-model="dateRequestBrithdayText" disabled maxlength="100">
                            <template v-slot:label>
                              <span class="input__label text-title">{{ $t('WpLabRequest.brithDay') }}</span>
                            </template>
                          </v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="4" sm="4" md="4">
                        <div class="mx-3">
                        <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="age"
                            :readonly="ageEditing"
                            @focus="disableDatePicker"
                            @blur="enableDatePicker"
                            @input="handleAgeChange"
                            disabled
                            maxlength="3"
                          >
                            <template v-slot:label>
                              <span class="input__label text-title">{{ $t('WpLabRequest.age') }}</span>
                            </template>
                          </v-text-field>
                      </div>
                      </v-col>
                    </v-row>
                </v-col>
                <v-col cols="4" sm="4" md="4">
                  <div class="mx-3">
                    <v-text-field
                      v-model="sex"
                      :label="$t('WpLabRequest.sex')"
                      outlined dense hide-details
                      disabled
                    >
                    </v-text-field>
                      </div>
                </v-col>
                <v-col cols="4" sm="4" md="4">
                  <v-row no-gutters>
                    <v-col cols="6" sm="6" md="6">
                      <div class="mx-3">
                        <v-text-field 
                          outlined 
                          dense 
                          hide-details 
                          v-model="hospital_lab_no" 
                          disabled
                          maxlength="100"
                        >
                          <template v-slot:label>
                            <span class="input__label text-title">{{ $t('WpLabRequest.hln') }}</span>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <div class="mx-3">
                        <v-text-field
                          :value="getPaymentDescription(payment)"
                          :label="$t('WpLabRequest.payment')"
                          outlined dense hide-details
                          disabled
                        />
                      </div>
                    </v-col>
                    <!-- <v-col cols="6" sm="6" md="6">
                      <div class="mx-3">
                        <v-select
                          :items="paymentListAll"
                          v-model="payment"
                          item-text="description"
                          item-value="code"
                          :label="$t('WpLabRequest.payment')"
                          outlined dense hide-details
                          disabled
                        >
                        </v-select>
                      </div>
                    </v-col> -->
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="4" sm="4" md="4">
                  <div class="mx-3">
                    <v-text-field outlined dense hide-details v-model="dateRequestCollectionText" disabled maxlength="100">
                      <template v-slot:label>
                        <span class="input__label text-title">{{ $t('WpLabRequest.collectDate') }}</span>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="4" sm="4" md="4">
                  <div class="mx-3">
                    <v-text-field 
                    outlined 
                    dense 
                    hide-details 
                    v-model="requestBy" 
                    disabled
                    maxlength="100"
                  >
                    <template v-slot:label>
                      <span class="input__label text-title">{{ $t('WpLabRequest.requestBy') }}</span>
                    </template>
                  </v-text-field>
                  </div>
                </v-col>
                <v-col cols="4" sm="4" md="4">
                  <div class="mx-3">
                    <v-text-field 
                    outlined 
                    dense 
                    hide-details 
                    v-model="refDoc" 
                    disabled
                    maxlength="100"
                  >
                    <template v-slot:label>
                      <span class="input__label text-title">{{ $t('WpLabRequest.refDoc') }}</span>
                    </template>
                  </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-row>
              <v-col cols="3" sm="3" md="3">
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="itemSearch"
                  append-icon="mdi-magnify"
                  :label="$t('WpLabRequest.search')"
                  @click:append="searchItem"
                  @keydown.enter="searchItem"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <div class="label-header">
                  {{ $t('WpLabRequest.lablaboratory') }}
                </div>
                <v-card
                class="mx-auto"
                outlined>
                  <v-data-table
                    id="laboratory-order-item-table"
                    v-model="vDataTableView.selected"
                    :headers="ViewHeaders"
                    :items="vDataTableView.data"
                    hide-default-header
                    hide-default-footer
                    :page.sync="vDataTableView.options.page"
                    :itemsPerPage.sync="vDataTableView.options.itemsPerPage"
                    :options.sync="vDataTableView.options"
                    :height="tableHeight"
                    :footer-props="{
                      itemsPerPageText: $t('itemsPerPageText'),
                      itemsPerPageAllText: $t('itemsPerPageAllText'),
                      showFirstLastPage: true,
                      showCurrentPage: true,
                    }"
                    item-key="laboratory_skey"
                    class="elevation-1 order-item-list-table"
                    @click:row="selectCatRow">
                  </v-data-table>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <div class="label-header">
                  {{ $t('WpLabRequest.orderItem') }}
                </div>
                <v-card
                class="mx-auto"
                outlined>
                  <v-data-table
                    id="order-item-table"
                    v-model="vDataTableOrderItem.selected"
                    :headers="OrderItemHeaders"
                    :items="vDataTableOrderItem.data"
                    hide-default-footer
                    :page.sync="vDataTableOrderItem.options.page"
                    :itemsPerPage.sync="vDataTableOrderItem.options.itemsPerPage"
                    :options.sync="vDataTableOrderItem.options"
                    :height="tableHeight"
                    :footer-props="{
                      itemsPerPageText: $t('itemsPerPageText'),
                      itemsPerPageAllText: $t('itemsPerPageAllText'),
                      showFirstLastPage: true,
                      showCurrentPage: true,
                      firstIcon: 'mdi-arrow-collapse-left',
                      lastIcon: 'mdi-arrow-collapse-right',
                      prevIcon: 'mdi-minus',
                      nextIcon: 'mdi-plus',
                    }"
                    item-key="Order_id"
                    class="elevation-1 order-item-list-table"
                    @click:row="selectOrderItemListRow"
                    >
                    <template v-slot:item.medium_price="{ item }">
                      <div class="text-right pe-5">
                        {{ formatPrice(item.medium_price) }}
                      </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-row align="center" no-gutters>
                        <!-- Conditional icon for remark -->
                        <v-tooltip bottom v-if="item.remark">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="red" small class="mr-2" v-bind="attrs" v-on="on">mdi-book</v-icon>
                          </template>
                          <span>{{ item.remark }}</span>
                        </v-tooltip>

                        <!-- Edit icon -->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click.stop="viewItem(item)">mdi-magnify</v-icon>
                          </template>
                          <span>Review</span>
                        </v-tooltip>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="5">
                <div class="label-header">
                  {{ $t('WpLabRequest.orderItemSelected') }}
                </div>
                <v-card
                class="mx-auto"
                outlined>
                  <v-data-table
                    v-model="vDataTableLabOrderItem.selected"
                    :headers="LabOrderItemHeaders"
                    :items="vDataTableLabOrderItem.data"
                    hide-default-header
                    hide-default-footer
                    :page.sync="vDataTableLabOrderItem.options.page"
                    :itemsPerPage.sync="vDataTableLabOrderItem.options.itemsPerPage"
                    :options.sync="vDataTableLabOrderItem.options"
                    :height="tableHeight"
                    :footer-props="{
                      itemsPerPageText: $t('itemsPerPageText'),
                      itemsPerPageAllText: $t('itemsPerPageAllText'),
                      showFirstLastPage: true,
                      showCurrentPage: true,
                      firstIcon: 'mdi-arrow-collapse-left',
                      lastIcon: 'mdi-arrow-collapse-right',
                      prevIcon: 'mdi-minus',
                      nextIcon: 'mdi-plus',
                    }"
                    item-key="Order_id"
                    class="elevation-1 order-item-list-table">
                    <template v-slot:item.actions="{ item, index }">
                      <v-tooltip bottom v-if="item.filename">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="blue" small class="mr-2" v-bind="attrs" v-on="on" @click.stop="clickPreviewImage(item.order_item_skey)">mdi-download</v-icon>
                        </template>
                        <span>Download</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deletefromselected(item, index, current_order_skey)">delete</v-icon>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>                      
                    </template>
                    <template v-slot:item.medium_price="{ item }">
                      <div class="text-right pe-5">
                        {{ formatPrice(item.medium_price) }}
                      </div>
                    </template>
                    <template v-slot:item.probes="{ item, index }">
                      <div class="d-flex align-center">
                        <template v-if="item.probes && item.probes.length > 0">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <div class="d-flex align-center" v-bind="attrs" v-on="on" @click.stop="openEditProbe(item, current_order_skey)">
                                <v-icon color="pink" class="mr-1">mdi-dna</v-icon>
                                <span class="me-2">{{ item.probes.length }} Probe(s)</span>
                              </div>
                            </template>
                            <span>{{ item.probes.map(p => p.probe_cd).join(', ') }}</span>
                          </v-tooltip>
                        </template>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="item.require_diagnosis == 1"
                              color="pink"
                              class="mr-2"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="selectOrderItemDiagnosisRow(item, 1)"
                            >
                              mdi-stethoscope
                            </v-icon>
                          </template>
                          <span>Diagnosis</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="item.require_volume_urine == 1"
                              color="pink"
                              class="mr-2"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="selectOrderItemValumeUrine(item, 1)"
                            >
                              mdi-beaker
                            </v-icon>
                          </template>
                          <span>Volume Urine</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="pink"
                              class="mr-2"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="selectOrderItemCommentRow(item, 1)"
                            >
                              mdi-comment-text-outline
                            </v-icon>
                          </template>
                          <span>Comment</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="justify-center">
            <div class="d-flex justify-center" style="gap: 16px;">
              <v-btn color="#0073BE" style="width:150px" @click="addSelectOrder()" v-if="!current_order_skey">
                {{ $t('WpLabRequest.save') }}
              </v-btn>

              <v-btn color="#CC0202" style="width:150px" @click="closeAddOrder">
                {{ $t('WpLabRequest.close') }}
              </v-btn>

              <v-btn color="#04AB2F" style="width:150px" @click="createOrder()" v-if="!current_order_skey">
                {{ $t('WpLabRequest.saveCreateLabOreder') }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogSelectProbe" max-width="1000px" max-height="80%" eager persistent>
      <v-card flat>
        <v-card-title>
          <v-toolbar dense flat color="white">
            <v-toolbar-title>{{$t('WpLabRequest.selectProbes')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          v-model="vDataTableProbe.selected"
          :headers="selectProbeHeaders"
          :items="vDataTableProbe.data"
          :search="vDataTableProbe.search"
          fixed-header
          :page.sync="vDataTableProbe.options.page"
          :itemsPerPage.sync="vDataTableProbe.options.itemsPerPage"
          :options.sync="vDataTableProbe.options"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="probe_cd"
          class="fill-height"
          show-select
          >
        </v-data-table>
        <v-card-actions>
          <v-btn color="primary" @click="closeSelectProbe">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseCustomer" max-width="800px" scrollable eager>
      <CustomerBrowse ref="customerBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </CustomerBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogCustomerForm" max-width="1000px" eager>
      <v-card>
        <!-- Header -->
        <v-card-title
          class="py-2 white--text"
          :style="{
            'background-color': customerFormMode === 'new' ? '#4CAF50' : '#9ec9f3'
          }"
        >
          <v-icon left color="white">
            {{ customerFormMode === 'new' ? 'mdi-account-plus' : 'mdi-account-details' }}
          </v-icon>

          <span class="subtitle-1 font-weight-medium">
            {{ 
              customerFormMode === 'new' 
                ? $t('WpLabRequest.newCustomer') 
                : $t('WpLabRequest.customerInformation') 
            }}
          </span>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container fluid>
            <v-row>
              <!-- Left Column -->
              <v-col cols="12" md="6">
                <!-- Customer Number & Cust Skey -->
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      readonly
                      v-model="customer.customerNumber"
                      label="Customer Number"
                      outlined
                      dense
                      hide-details
                      :style="{
                        'background-color': '#F5F5F5'
                      }"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="customer.customerType"
                      :items="dropDownData.r_customer_type"
                      :label="$t('WpLabRequest.CustomerType')"
                      item-value="customer_type_skey"
                      item-text="description"
                      prepend-inner-icon="mdi-account-group-outline"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
                <!-- Customer Name -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.customerName"
                      :label="$t('WpLabRequest.CustomerName')"
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.firstName"
                      label="First Name"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.middleName"
                      label="Middle Name"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.lastName"
                      label="Last Name"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- Additional Field -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.TaxIDNumber"
                      outlined
                      dense
                      hide-details
                      :label="$t('WpLabRequest.TaxIDNumber')"
                      prepend-inner-icon="mdi-card-account-details-outline"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- E-mail Address -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.email"
                      :label="$t('WpLabRequest.emailAddress')"
                      outlined
                      dense
                      prepend-inner-icon="mdi-card-account-mail-outline"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Address Fields -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.address1"
                      :label="$t('WpLabRequest.address')"
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-map-marker-outline"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.address2"
                      :label="$t('WpLabRequest.addressOptional')"
                      prepend-inner-icon="mdi-map-marker-outline"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.address3"
                      :label="$t('WpLabRequest.addressOptional')"
                      prepend-inner-icon="mdi-map-marker-outline"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.address4"
                      :label="$t('WpLabRequest.addressOptional')"
                      prepend-inner-icon="mdi-map-marker-outline"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- City & State -->
                <v-row dense class="mt-2">
                  <v-col cols="4">
                    <v-text-field
                      v-model="customer.city"
                      :label="$t('WpLabRequest.city')"
                      prepend-inner-icon="mdi-city-variant-outline"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                      v-model="customer.state"
                      :items="filteredStates"
                      :label="$t('WpLabRequest.state')"
                      item-value="state_province_skey"
                      item-text="name"
                      prepend-inner-icon="mdi-map-outline"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Country & Zip -->
                <v-row dense class="mt-2">
                  <v-col cols="6">
                    <v-select
                      v-model="customer.country"
                      :items="dropDownData.r_country"
                      :label="$t('WpLabRequest.country')"
                      item-value="country_skey"
                      item-text="description"
                      prepend-inner-icon="mdi-earth"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="customer.zip"
                      :label="$t('WpLabRequest.zip')"
                      outlined
                      prepend-inner-icon="mdi-post-outline"
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Phone -->
                <v-row dense class="mt-2">
                  <!-- <v-col cols="2">
                    <v-text-field
                      v-model="customer.phoneCode"
                      label="Phone"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="customer.phoneArea"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.phoneNumber"
                      :label="$t('WpLabRequest.phoneNumber')"
                      prepend-inner-icon="mdi-phone-outline"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="3">
                    <v-text-field
                      v-model="customer.phoneExt"
                      label="Extension"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col> -->
                </v-row>

                <!-- Fax -->
                <!-- <v-row dense class="mt-2">
                  <v-col cols="2">
                    <v-text-field
                      v-model="customer.faxCode"
                      label="Fax"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="customer.faxArea"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="customer.faxNumber"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row> -->
              </v-col>

              <!-- Right Column -->
              <v-col cols="12" md="6">
                <!-- Status -->
                <!-- <v-row dense>
                  <v-col cols="12">
                    <v-select
                      v-model="customer.status"
                      :items="statusOptions"
                      label="Status"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row> -->

                <!-- Hold Code -->
                <v-row dense>
                  <v-col cols="12">
                    <v-select
                      v-model="customer.holdCode"
                      :items="dropDownData.r_state_order_hold"
                      :label="$t('WpLabRequest.holdCode')"
                      item-value="code"
                      item-text="description"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Bank Remit -->
                <!-- <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.bankRemit"
                      :items="bankRemitOptions"
                      label="Bank Remit"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row> -->

                <!-- Pay Terms -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.payTerms"
                      :items="dropDownData.r_terms"
                      :label="$t('WpLabRequest.payTerms')"
                      item-value="code"
                      item-text="description"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- A/R Rep -->
                <!-- <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.arRep"
                      :items="arRepOptions"
                      label="A/R Rep"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row> -->

                <!-- Freight Code -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.freightCode"
                      :items="freightCodeOptions"
                      label="Freight Code"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Income Code -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.incomeCode"
                      :items="incomeCodeOptions"
                      label="Income Code"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Invoice Type -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.invoiceType"
                      :items="invoiceTypeOptions"
                      label="Invoice Type"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Payment Type -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.paymentType"
                      :items="paymentListAll"
                      label="Payment Type"
                      item-text="description"
                      item-value="code"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Free On Board -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.freeOnBoard"
                      :items="fobOptions"
                      label="Free On Board"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Market Segment -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.marketSegment"
                      :items="marketSegmentOptions"
                      label="Market Segment"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Market Channel -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.marketChannel"
                      :items="marketChannelOptions"
                      label="Market Channel"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Authorize Card Credits -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-select
                      v-model="customer.authorizeCardCredits"
                      :items="authorizeOptions"
                      label="Authorize Card Credits"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Alias -->
                <v-row dense class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="customer.alias"
                      label="Alias"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Footer Actions -->
        <v-divider/>

        <!-- <v-card-actions class="justify-end">
          <v-btn outlined color="primary" @click="saveCustomer">
            SAVE
          </v-btn>

          <v-btn outlined color="grey" @click="closeDialog">
            CLOSE
          </v-btn>
        </v-card-actions> -->
        <v-card-actions class="px-4 py-3">
          <template v-if="customerFormMode === 'new'">
            <v-btn 
              depressed 
              color="success" 
              class="white--text" 
              @click="resetCustomerForm"
            >
              <v-icon left>mdi-plus-circle-outline</v-icon>
              {{ $t('new') }}
            </v-btn>

            <v-btn 
              depressed 
              color="warning" 
              class="white--text ml-2" 
              @click="copyPatientToCustomer"
            >
              <v-icon left>mdi-content-copy</v-icon>
              {{ $t('WpLabRequest.copyPatient') }}
            </v-btn>
          </template>
          
          <v-spacer></v-spacer>

          <v-btn 
            v-if="customerFormMode === 'new'" 
            depressed 
            color="primary" 
            class="white--text" 
            @click="saveCustomer"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            {{ $t('save') }}
          </v-btn>

          <v-btn 
            depressed 
            color="grey darken-1" 
            class="white--text ml-2" 
            @click="closeDialog"
          >
            <v-icon left>mdi-close-circle-outline</v-icon>
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogIDCard" max-width="850px" persistent eager>
      <v-card class="rounded-lg elevation-4">
        <v-card-title
          class="py-2 white--text"
          style="background-color:#9ec9f3;"
        >
          <span class="subtitle-1 font-weight-medium">
            ตรวจสอบข้อมูลบัตรประจำตัวประชาชน
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="3" class="d-flex flex-column align-center pt-3">
              <v-hover v-slot="{ hover }">
                <v-card :elevation="hover ? 6 : 2" class="rounded-lg overflow-hidden" width="160" height="200">
                  <v-img 
                    v-if="idCard.image" 
                    :src="'data:image/jpeg;base64,' + idCard.image" 
                    height="100%" 
                    width="100%"
                    contain
                  ></v-img>
                  <v-sheet v-else color="grey lighten-4" height="100%" class="d-flex align-center justify-center">
                    <v-icon size="80" color="grey lighten-1">mdi-account-box</v-icon>
                  </v-sheet>
                </v-card>
              </v-hover>
              <div class="mt-3 font-weight-medium grey--text text--darken-1">รูปถ่ายหน้าบัตร</div>
            </v-col>

            <v-col cols="12" md="9">
              <v-container class="pa-1">
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      v-model="idCard.cid"
                      :label="$t('WpLabRequest.cid')"
                      prepend-inner-icon="mdi-card-account-details-outline"
                      outlined
                      dense
                      hide-details readonly filled color="primary"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-text-field v-model="idCard.prefix" label="คำนำหน้า" outlined
                      dense
                      hide-details filled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="idCard.firstname" label="ชื่อ (First Name)" outlined
                      dense
                      hide-details readonly filled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field v-model="idCard.lastname" label="นามสกุล (Last Name)" outlined
                      dense
                      hide-details readonly filled></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" md="4" class="pb-0 mb-0">
                    <v-text-field 
                      v-model="idCard.birth_date" 
                      label="วันเกิด (Birth Date)" 
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      hide-details readonly filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" class="pb-0 mb-0">
                    <v-text-field 
                      v-model="idCard.gender" 
                      label="เพศ" 
                      prepend-inner-icon="mdi-gender-male-female"
                      outlined
                      dense
                      hide-details readonly filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" class="pb-0 mb-0">
                    <v-text-field 
                      v-model="idCard.age" 
                      label="อายุ (ปี)" 
                      prepend-inner-icon="mdi-clock-outline"
                      outlined dense readonly filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pt-0 mt-0">
                    <v-textarea
                      v-model="idCard.address"
                      label="ที่อยู่ตามทะเบียนบ้าน (Address)"
                      prepend-inner-icon="mdi-home-map-marker"
                      outlined
                      dense
                      hide-details readonly filled rows="3"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mx-6"></v-divider>

        <v-card-actions class="pa-6">
          <v-btn 
            color="#1976D2" 
            dark 
            large 
            elevation="2"
            class="rounded-lg px-6" 
            :loading="loading.readCard"
            @click="onReadIDCard"
          >
            <v-icon left>mdi-card-search</v-icon>
            อ่านข้อมูลบัตร (Read Card)
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="success" 
            large 
            class="rounded-lg px-6 mr-2" 
            @click="saveIDCardData"
            :disabled="!idCard.cid"
          >
            <v-icon left>mdi-check-circle-outline</v-icon>
            ตกลง (SAVE)
          </v-btn>
          <v-btn 
            color="grey darken-1" 
            text 
            large 
            class="rounded-lg" 
            @click="closeAndClearDialog"
          >
            ปิดหน้าต่าง (CLOSE)
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogOrderItemNote" max-width="600px" eager>
      <v-card>
        <v-card-title>
          <span class="headline"><h6 style="color: #003057;">{{$t('WpLabRequest.note')}}</h6></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea 
                  outlined
                  :label="$t('WpLabRequest.note')"
                  v-model="itemOrderItemNote"
                  rows="4"
                  hide-details
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveOrderItemNote()">{{$t('ok')}}</v-btn>
          <v-btn outlined color="error" @click="closeOrderItemNote()">{{$t('WpLabRequest.cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
 
  
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import Base64Binary from 'base64-arraybuffer'
import moment from 'moment'
import { template } from 'babel-core'
import CustomerBrowse from '@/components/common/CustomerBrowse'
export default {
  components: {
    CustomerBrowse,
  },

  props: ['parentComponent'],

  data () {
    return {
      tab: 'order-item',
      customerFormMode: 'view',
      activeRowItem: null,
      isChecked: false,
      appName: process.env.VUE_APP_DB_APP_NAME,
      showError: false,
      dialog: {
        dialogProgress: false,
        dialogAddRequest: false,
        dialogAddEditWindow: false,
        dialogLanguage: false,
        dialogReceivedDateFromTo: false,
        dialogAddOrder: false,
        dialogViewItem: false,
        dialogviewRemark: false,
        dialogFindPatient: false,
        dialogEditPatient: false,
        dialogOrderItemComment: false,
        dialogOrderItemDiagnosis: false,
        dialogSelectProbe: false,
        dialogOrderItemVolumeUrine: false,
        dialogEditCollectionDate: false,
        dialogBrowseCustomer: false,
        dialogCustomerForm: false,
        dialogIDCard: false,
        dialogOrderItemNote: false,
      },
      loading: {
        readCard: false
      },
      idCard: {
        cid: '',
        name: '',
        gender: '',
        birth_date: '',
        age: '',
        address: '',
        image: '',
        firstname: '',
        lastname: '',
        prefix: ''
      },
      dialogpdfShow: false,
      orderItemDiagnosis: '',
      orderItemComment: '',
      orderItemVolumeUrine: '',
      isCreateSuccess: false,
      active_tab: null,
      idCardText: '',
      smartCardUrl: null,
      criteria: {
        // ReceivedDateFromTo: [new Date(Date.now() - 1209600000).toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)],
        ReceivedDateFromTo: [new Date(new Date().setHours(0, 0, 0, 0) - (new Date().getTimezoneOffset() * 60000))
            .toISOString()
            .slice(0, 10)]
        // ReceivedDateFromTo: [new Date(Date.now()).toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)],
      },
      statusListAll: [
        { status_name: 'WpLabRequest.statusObj.OP', status: 'OP' },
        { status_name: 'WpLabRequest.statusObj.COLLECTION', status: 'COLLECTION' },
        { status_name: 'WpLabRequest.statusObj.RECEIVEDALL', status: 'RECEIVED' },
        { status_name: 'WpLabRequest.statusObj.FIRSTAPPROVE', status: 'FIRSTAPPROVE' },
        { status_name: 'WpLabRequest.statusObj.LASTAPPROVE', status: 'LASTAPPROVE' },
        { status_name: 'WpLabRequest.statusObj.CA', status: 'CA' },
      ],
      viewList: [],
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      pdfShow: '',
      searchName: '',
      searchPackage: '',
      lab: '',
      findTestItem: '',
      cust_skey: localStorage.getItem('cust_skey'),
      // addedit
      vDataTable2: {
        search: '',
        selected: [],
        editedIndex: -1,
        editedItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        defaultItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableSubcategory: {
        search: '',
        selected: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableLisLabPricing: {
        search: '',
        selected: [],
        editedIndex: -1,
        editedItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        defaultItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableLisLabSpecimenType: {
        search: '',
        selected: [],
        editedIndex: -1,
        editedItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        defaultItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableAfterCreated: {
        search: '',
        selected: [],
        editedIndex: -1,
        editedItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        defaultItem: {
          OrderItemId: '',
          OrderItemdesc: '',
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableFindPatient: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
        },
      },
      vDataTableProbe: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
        },
      },
      current_order_id: '',
      current_lab_status: '',
      current_order_skey: '',
      current_package_no: '',
      current_patient_skey: '',
      current_probes: '',
      current_order_item_id: '',
      current_order_item_skey: '',
      prefixList: [],
      sexListAll: [],
      prefixSexListAll: [],
      paymentListAll: [],
      patientRightsList: [],
      serviceChannelList: [],
      hn: '',
      patient_id: '',
      find_hn: '',
      prefix: '',
      firstName: '',
      middleName: '',
      lastName: '',
      cust_no: '',
      cust_name: '',
      sendVar: {
        PathoNo: ''
      },
      menuBrithday: false,
      menuRequestBrithday: false,
      menuEditRequestBrithday: false,
      menuReceive: false,
      menuRequestReceive: false,
      editMenuRequestReceive: false,
      menuCollectionDate: false,
      dateBrithday: '',
      dateRequestBrithday: '',
      age: '',
      ageEditing: false,
      ageEditing2: false,
      sex: '',
      patientRights: '',
      status_lab: '',
      patientRightsDefault: '',
      paymentType: '',
      paymentTypeDefault: '',
      dateReceive: '',
      dateCollection: '',
      dateRequestCollection: '',
      requestBy: '',
      refDoc: '',
      serviceChannel: '',
      isAddItemDisabled: false,
      isOrderDisabled: false,
      updateLabDetailCheck: 0,
      editpatient: true,
      tabPerson: '',
      // add item
      itemSearch: '',
      request_view_skey: '',
      sub_category_skey: 0,
      vDataTableView: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          Lotskey: '',
          resultItemSkey: '',
          comments: ''
        },
        defaultItem: {
          Lotskey: '',
          resultItemSkey: '',
        },
        options: {
          page: 1,
          itemsPerPage: -1,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      vDataTableOrderItem: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          Lotskey: '',
          resultItemSkey: '',
          comments: ''
        },
        defaultItem: {
          Lotskey: '',
          resultItemSkey: '',
        },
        options: {
          page: 1,
          itemsPerPage: -1,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      vDataTableLabOrderItem: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          Lotskey: '',
          resultItemSkey: '',
          comments: ''
        },
        defaultItem: {
          Lotskey: '',
          resultItemSkey: '',
        },
        options: {
          page: 1,
          itemsPerPage: -1,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      tempOrderListItem: [],
      isAddNew: false,
      viewOrderItemID: '',
      viewOrderItemDesc: '',
      viewSubcategory: '',
      orderSkeyCreateList: '',
      orderIDCreateList: '',
      hospital_lab_no: '',
      payment: '',
      paymentDefault: '',
      itemRemark: '',
      itemOrderItemNote: '',
      findOrderId: '',
      orderItemCommentList: [],
      shouldOpenComment: false,
      itemComment: {},
      newOrder: false,
      newOrderSkey: '',
      selectedHour: '',
      selectedMinute: '',
      selectedSecond: '',
      isEditProbe: 0,
      isEditDiagnosis: 0,
      isEditVolumeUrine: 0,
      isEditComment: 0,
      addRequestDiagnosis: 0,
      addRequestComment: 0,
      newlabItem: [],
      editCollectionDate: '',
      editCollectionHour: '',
      editCollectionMinute: '',
      editCollectionSecond: '',
      customer: {
        customerNumber: '',
        custSkey: '',
        customerName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        city: '',
        state: '',
        country: 96,
        zip: '',
        phoneCode: '',
        phoneArea: '',
        phoneNumber: '',
        phoneExt: '',
        faxCode: '',
        faxArea: '',
        faxNumber: '',
        TaxIDNumber: '',
        status: 'Active',
        holdCode: '',
        customerType: 16,
        bankRemit: '',
        payTerms: '30D',
        arRep: '',
        freightCode: '',
        incomeCode: 'Direct Sale',
        invoiceType: 'Detail Invoice',
        paymentType: 'TRN',
        freeOnBoard: '',
        marketSegment: '',
        marketChannel: 'Major',
        authorizeCardCredits: '',
        alias: 'GEN'
      },
      statusOptions: ['Active', 'Inactive', 'Pending'],
      bankRemitOptions: ['-- Select --'],
      arRepOptions: ['-- Select --'],
      freightCodeOptions: ['-- Select --'],
      incomeCodeOptions: ['Direct Sale', 'Retail', 'Wholesale'],
      invoiceTypeOptions: ['Detail Invoice', 'Summary Invoice'],
      paymentTypeOptions: ['-- Select --'],
      fobOptions: ['-- Select --'],
      marketSegmentOptions: ['-- Select --'],
      marketChannelOptions: ['Major', 'Minor', 'Online'],
      authorizeOptions: ['-- Select --'],
      dropDownData: [],
      currentMode: 'create', // หรือ 'edit', 'display'
    }
  },

  computed: {
    showButtons () {
      const mode = this.currentMode
      return {
        // ปุ่มสร้างใหม่/บันทึกหลัก
        addNew: mode === 'create',
        saveOrder: mode === 'create',
        // ปุ่มข้อมูลคนไข้
        savePatient: (mode === 'create' || mode === 'edit') && this.current_order_skey,
        editPatient: mode === 'display' || mode === 'edit',
        // ปุ่มจัดการ Package / Lab
        sendPackage: mode === 'create' || mode === 'edit',
        cancelPackage: mode === 'edit',
        cancelLab: mode === 'edit' || mode === 'display',
        // ปุ่มกลุ่มพิมพ์เอกสาร
        requestForm: mode === 'display' || mode === 'edit',
        receiptForm: mode === 'display' || mode === 'edit',
        sidSticker: mode === 'display' || mode === 'edit',
        searchPatient: mode === 'create',
        customerBtn: mode === 'create',
      }
    },
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      name: state => `${state.user.profile.first_name} ${state.user.profile.last_name}`,
      userID: state => `${state.user.profile.user_id}`,
      picture_base64: state => `${state.user.profile.picture_base64}`,
      token: state => `${state.auth.token}`,
    }),
    tableHeight () {
      return this.$vuetify.breakpoint.height - (this.current_order_skey ? 290 : 470)
    },
    selectDate () {
      var text = '$vuetify.datePicker.itemsSelected'
      text = 'ช่วงเวลาค้นหาข้อมูล'
      return text
    },
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? this.$t('RegisterMaint.NewRegister') : this.$t('RegisterMaint.Title')
    },
    formLanguageTitle () {
      return this.vDataTable.editedLanguageIndex === -1 ? this.$t('SubscribeMaint.newSubscribeLanguage') : this.$t('SubscribeMaint.editSubscribeLanguage')
    },
    ViewHeaders () {
      return [
        { text: '', value: 'view_desc', align: 'start', class: 'blue lighten-3 text-sm-left body-2 black--text background-color: #00f', width: '100%' },
      ]
    },
    OrderItemHeaders () {
      return [
        { text: this.$t('WpLabRequest.orderID'), value: 'order_item_id', align: 'start', class: 'grey lighten-3 text-sm-left body-2 black--text', width: '13%' },
        { text: this.$t('WpLabRequest.orderName'), value: 'order_item_desc', align: 'start', class: 'grey lighten-3 text-sm-left body-2 black--text background-color: #c8c8c8', width: '70%' },
        { text: this.$t('WpLabRequest.price'), value: 'medium_price', align: 'start', class: 'grey lighten-3 text-sm-left body-2 black--text background-color: #c8c8c8', width: '17%', sortable: true },
        // { text: this.$t('WpLabRequest.specimenType'), value: 'specimen_type_desc', align: 'start', class: 'grey lighten-3 text-sm-left body-2 black--text background-color: #00f', width: '24%' },
        { text: '', value: 'actions', class: 'grey lighten-3 text-sm-left body-2 black--text background-color: #00f', width: '30px', sortable: true },
      ]
    },
    LabOrderItemHeaders () {
      return [
        { text: 'Item Id', value: 'order_item_id', align: 'start', class: 'blue lighten-3 text-sm-left body-2 black--text', width: '70px' },
        { text: 'Description', value: 'order_item_desc', align: 'start', class: 'blue lighten-3 text-sm-left body-2 black--text', width: '70px' },
        { text: 'Description', value: 'medium_price', align: 'start', class: 'blue lighten-3 text-sm-left body-2 black--text', width: '70px' },
        { text: 'Specimen', value: 'specimen_type_desc', align: 'start', class: 'blue lighten-3 text-sm-left body-2 black--text background-color: #00f', width: '30%' },
        { text: 'probes', value: 'probes', align: 'start', class: 'blue lighten-3 text-sm-left body-2 black--text background-color: #00f', width: '30%' },
        { text: this.$t('actions'), value: 'actions', width: '40px', sortable: true },
      ]
    },
    headersMain () {
      return [
        { text: this.$t('actions'), value: 'actions', width: '60px', sortable: false },
        { text: this.$t('WpLabRequest.receivedDate'), value: 'date_receive', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.reportedDate'), value: 'date_result', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabRequest.isUrgent'), value: 'is_urgent', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.paymentStatus'), value: 'invoice_desc', align: 'start', class: ' body-1 black--text ml-6', style: 'text-align: center !important;' },
        { text: this.$t('WpLabRequest.patientId'), value: 'patient_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.patientFullname'), value: 'patient_fullname', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.labNumber'), value: 'order_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('HN'), value: 'hn', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.dateCreated'), value: 'date_created', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.releasedDate'), value: 'date_send', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabRequest.lablaboratoryName'), value: 'view_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabRequest.isGetBack'), value: 'is_get_back', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.packageNo'), value: 'package_no', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabRequest.paymentType'), value: 'payment_tpye', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.labStatus'), value: 'lab_status', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.labApproveStatus'), value: 'is_approved', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    AfterCreatedHeaders () {
      return [
        // { text: this.$t('actions'), value: 'actions', width: '60px', sortable: false },
        { text: this.$t('WpLabRequest.labNumber'), value: 'orderId', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.specimenID'), value: 'specimenTypeId', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.collectDate'), value: 'collectionDate', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { value: 'actions', width: '60px', sortable: false },
        { value: 'requireCollectionDate', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    AfterCreatedItemHeaders () {
      return [
        // { text: this.$t('actions'), value: 'actions', width: '60px', sortable: false },
        { text: this.$t('WpLabRequest.orderID'), value: 'orderItemId', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.orderName'), value: 'orderItemDesc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.price'), value: 'price', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.qty'), value: 'qty', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.discPct'), value: 'disc_pct', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.discAmount'), value: 'disc_amount', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.totalAmount'), value: 'total_amount', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('ห้องปฎิบัติการ'), value: 'sub_category_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('ชนิดสิ่งส่งตรวจ'), value: 'specimen_type_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabRequest.turnaroundTime'), value: 'due_date', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('ราคา'), value: 'medium_price', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabRequest.isGetBack'), value: 'is_get_back', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('ขอผลด่วน'), value: 'is_urgent', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabRequest.remark'), value: 'remark', align: 'center', class: 'text-xl-left body-1 black--text', width: '7%' },
        // { text: this.$t('WpLabRequest.remarkForm'), value: 'formAction', align: 'left', class: 'text-xl-left body-1 black--text', width: '7%' },
      ]
    },
    LabOrderItemHeadersList () {
      return [
        { text: this.$t('WpLabRequest.orderItemID'), value: 'order_item_id', align: 'left', class: 'text-xl-left body-1 black--text', width: '7%' },
        { text: this.$t('WpLabRequest.orderItemName'), value: 'order_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.active'), value: 'active', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.cancel'), value: 'cancel', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.note'), value: 'note', align: 'left', class: 'text-xl-left body-1 black--text' },
        /* { text: this.$t('WpLabRequest.price'), value: 'medium_price', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.qty'), value: 'qty', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.discPct'), value: 'disc_pct', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.discAmount'), value: 'disc_amount', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.totalAmount'), value: 'total_amount', align: 'left', class: 'text-xl-left body-1 black--text' }, */
        /* { text: this.$t('WpLabRequest.status'), value: 'status_desc', align: 'left', class: 'text-xl-left body-1 black--text' }, */
        /* { text: this.$t('WpLabRequest.receivedDate'), value: 'sid_received_date', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.remark'), value: 'remark', align: 'center', class: 'text-xl-left body-1 black--text', width: '8%' }, */
      ]
    },
    headerDataTableLisLabPricing () {
      return [
        { text: this.$t('WpLabRequest.No'), value: 'row_num', align: 'left', class: 'text-xl-left body-1 black--text', width: '7%' },
        { text: this.$t('WpLabRequest.itemNo'), value: 'resource_no', align: 'left', class: 'text-xl-left body-1 black--text', width: '7%' },
        { text: this.$t('WpLabRequest.itemDesc'), value: 'resource_desc', align: 'left', class: 'text-xl-left body-1 black--text', width: '26%' },
        /* { text: this.$t('WpLabRequest.lablaboratoryName'), value: 'sub_category_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.specimenType'), value: 'specimen_type_desc', align: 'left', class: 'text-xl-left body-1 black--text' }, */
        { text: this.$t('WpLabRequest.price'), value: 'price', align: 'left', class: 'text-xl-left body-1 black--text', width: '10%' },
        { text: this.$t('WpLabRequest.qty'), value: 'qty', align: 'left', class: 'text-xl-left body-1 black--text', width: '10%' },
        { text: this.$t('WpLabRequest.discPct'), value: 'disc_pct', align: 'left', class: 'text-xl-left body-1 black--text', width: '10%' },
        { text: this.$t('WpLabRequest.discAmount'), value: 'disc_amount', align: 'left', class: 'text-xl-left body-1 black--text', width: '10%' },
        { text: this.$t('WpLabRequest.totalAmount'), value: 'total_amount', align: 'left', class: 'text-xl-left body-1 black--text', width: '20%' },
      ]
    },
    headerDataTableLisLabSpecimenType () {
      return [
        { text: this.$t('WpLabRequest.No'), value: 'row_num', align: 'left', class: 'text-xl-left body-1 black--text', width: '7%' },
        { text: this.$t('WpLabRequest.specimenID'), value: 'specimen_type_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.specimenType'), value: 'specimen_type_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.containerType'), value: 'container_type', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    headerDataTableLisLabSpecimenTypeTestItem () {
      return [
        { text: this.$t('WpLabRequest.No'), value: 'row_num', align: 'left', class: 'text-xl-left body-1 black--text', width: '7%' },
        { text: this.$t('WpLabRequest.testItemID'), value: 'test_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.testItemName'), value: 'test_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    selectProbeHeaders () {
      return [
        // { text: 'skey', value: 'patient_skey', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: 'Code', value: 'probe_cd', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: 'Description', value: 'probe_desc', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: 'Price', value: 'price', align: 'start', class: 'text-xl-left body-2 secondary--text' },
      ]
    },
    headersFindPatient () {
      return [
        // { text: 'skey', value: 'patient_skey', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: 'PID', value: 'patient_id', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: this.$t('WpLabRequest.prefix'), value: 'prefix_desc', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: this.$t('WpLabRequest.patientName'), value: 'firstname', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: this.$t('WpLabRequest.lastName'), value: 'lastname', align: 'start', class: 'text-xl-left body-2 secondary--text' },
        { text: this.$t('WpLabRequest.HN'), value: 'hn', align: 'start', class: 'text-xl-left body-2 secondary--text' },
      ]
    },
    offsetAppBar () {
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
    // dateRangeText () {
    //   return this.criteria.ReceivedDateFromTo.join(' ~ ')
    // },
    dateRangeText () {
      if (this.criteria.ReceivedDateFromTo.length > 0) {
        return this.criteria.ReceivedDateFromTo.map(date =>
          this.convertToThaiDate(date)
        ).join(' ~ ')
      }
      return ''
    },
    dateRequestCollectionText () {
      return this.dateRequestCollection
        ? this.convertToThaiDate(this.dateRequestCollection)
        : '' // Return a default value like '-' if undefined
    },
    dateRequestBrithdayText () {
      return this.dateRequestBrithday
        ? this.convertToThaiDate(this.dateRequestBrithday)
        : '' // Return a default value like '-' if undefined
    },
    dateRequestBrithdayTextEdit () {
      return this.dateRequestBrithday
        ? this.convertToThaiDate(this.dateRequestBrithday)
        : '' // Return a default value like '-' if undefined
    },
    dateCollectionText () {
      return this.dateCollection
        ? this.convertToThaiDate(this.dateCollection)
        : '' // Return a default value like '-' if undefined
    },
    dateBrithdayText () {
      return this.dateBrithday
        ? this.convertToThaiDate(this.dateBrithday)
        : '' // Return a default value like '-' if undefined
    },
    filteredStates () {
      if (!this.dropDownData || !this.dropDownData.r_state_province) {
        return []
      }
      if (!this.customer.country) {
        return []
      }
      if (!this.customer.country) return []
      return this.dropDownData.r_state_province.filter(state => {
        return state.country_skey === this.customer.country
      })
    },
    isTablet () {
      return this.$vuetify.breakpoint.mdAndDown
    },
  },

  watch: {
    'dialog.dialogAddEditWindow' (val) {
      val || this.close()
    },
    'dialog.dialogAddRequest' (val) {
      // รีเซ็ต Tab เป็น order-item ทุกครั้งที่เปิด (val = true) หรือ ปิด (val = false)
      this.tab = 'order-item'
      // 2. เคลียร์ Checkbox (selected) ของทั้ง 3 ตาราง
      this.vDataTable2.selected = []
      this.vDataTableLisLabPricing.selected = []
      this.vDataTableLisLabSpecimenType.selected = []

      // 3. เคลียร์ข้อความค้นหา (search) ของทั้ง 3 ตาราง
      this.vDataTable2.search = ''
      this.vDataTableLisLabPricing.search = ''
      this.vDataTableLisLabSpecimenType.search = ''

      // 4. รีเซ็ตการขยายแถว (expanded) ถ้ามี
      this.vDataTableLisLabSpecimenType.expanded = []

      // 5. กรณีปิด Dialog (val === false) ให้เคลียร์ Error และค่าค้างคาอื่นๆ
      if (!val) {
        this.showError = false
        this.clearCustomer()
        // หากต้องการให้ข้อมูลในตารางว่างเปล่าเมื่อปิด ให้ใส่คำสั่งด้านล่างนี้ (เลือกตามความเหมาะสม)
        // this.vDataTable2.data = [];
        // this.vDataTableLisLabPricing.data = [];
        // this.vDataTableLisLabSpecimenType.data = [];
      }
      // หากต้องการให้ scroll กลับไปด้านบนสุดของ dialog ด้วย (Optional)
      if (val) {
        this.$nextTick(() => {
          const container = document.querySelector('.v-dialog--active')
          if (container) container.scrollTop = 0
        })
      }
    }
  },

  async created () {
    this.retrieveView()
    this.getSex()
    this.getPrefix()
    this.getPrefixSex()
    this.getPayment()
    // this.getCustomerInfo()
    this.retrieveDropDown()
    this.getPatientRights()
    this.getServiceChannel()
    this.status = 'ALL'
    this.detail_receive_date = null
    localStorage.setItem('dataListItem', '')
    if (localStorage.getItem('clickToGoStatus') === 'OrderToday') {
      this.criteria.ReceivedDateFromTo = [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)]
    }
    this.retrieveLabRequest()
  },

  mounted () {
    const now = new Date()
    const pad = n => n.toString().padStart(2, '0')
    this.selectedHour = pad(now.getHours())
    this.selectedMinute = pad(now.getMinutes())
    this.selectedSecond = pad(now.getSeconds())
  },

  updated () {
  },

  methods: {
    formatPrice (value) {
      if (value === null || value === undefined || value === '') return '0.00'
      return Number(value).toFixed(2)
    },
    updateLabCollectionDate (item) {
      // ทำงานตอนผู้ใช้แก้ไข Collection Date
      this.editCollectionItem = item
      this.editCollectionDate = item.collectionDateMin
      this.editCollectionHour = item.collectionHour
      this.editCollectionMinute = item.collectionMinute
      this.editCollectionSecond = item.collectionSecond
      this.dialog.dialogEditCollectionDate = true
    },
    submitEditCollectionDate () {
      let item = this.editCollectionItem
      if (!item) return
      let date = new Date(this.editCollectionDate)
      date.setHours(parseInt(this.editCollectionHour))
      date.setMinutes(parseInt(this.editCollectionMinute))
      date.setSeconds(parseInt(this.editCollectionSecond))

      item.collectionDate = date
      item.collectionDateMin = this.editCollectionDate
      item.collectionHour = this.editCollectionHour
      item.collectionMinute = this.editCollectionMinute
      item.collectionSecond = this.editCollectionSecond

      this.axios.post(process.env.VUE_APP_API + '/updateLabCollectionDate' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: item.orderSkey,
        collectionDate: date,
        userID: localStorage.getItem('username'),
      })
        .then(response => {
          if (response.data.isSuccess) {
            item.requireCollectionDate = 2
            this.$swal({ text: 'บันทึก Collection Date สำเร็จ', type: 'success' })
          } else {
            this.$swal({ type: 'error', title: response.message })
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogEditCollectionDate = false
    },
    closeEditCollectionDate () {
      this.dialog.dialogEditCollectionDate = false
    },
    updateCollectionDate (value) {
      this.dateRequestCollectionText = this.formatDate(value) // อัปเดตวันที่
      this.menuRequestReceive = false// ปิด v-menu อัตโนมัติ
    },
    updateDateTime () {
      let date = new Date(this.dateRequestCollection)
      // Set time components from selected values
      date.setHours(parseInt(this.selectedHour))
      date.setMinutes(parseInt(this.selectedMinute))
      date.setSeconds(parseInt(this.selectedSecond))
      // Update the full datetime
      this.collectDate = date
    },
    formatText (text) {
      if (!text.includes('(')) {
        return text
      }
      var textformat = text.split('(')
      return `${textformat[0]}<br/>(${textformat[1]}`
    },
    paymentPage () {
      this.$router.push('/WpLabAttachPayment')
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    clearData () {
      this.searchPackage = ''
      this.searchName = ''
      this.lastName = ''
      this.tel = ''
      this.idCard = ''
      this.dateBrithday = ''
      this.dateRequestBrithday = ''
      this.find_hn = ''
      this.dateReceive = ''
      this.dateCollection = ''
      this.packageNo = ''
      this.criteria.ReceivedDateFromTo = [new Date(new Date().setHours(0, 0, 0, 0) - (new Date().getTimezoneOffset() * 60000))
            .toISOString()
            .slice(0, 10)]
      this.status = 'ALL'
      this.request_view_skey = ''
      this.findTestItem = ''
      localStorage.setItem('clickToGoStatus', '')
      this.findOrderId = ''
      this.retrieveLabRequest()
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTableView.selected = []
      this.vDataTableView.editedIndex = -1
      this.vDataTableView.editedItem = {
        Lotskey: '',
        method_description: ''
      }
      this.vDataTableView.defaultItem = {
        Lotskey: '',
        method_description: ''
      }
      this.vDataTableOrderItem.selected = []
      this.vDataTableOrderItem.editedIndex = -1
      this.vDataTableOrderItem.editedItem = {
        Lotskey: '',
        method_description: ''
      }
      this.vDataTableOrderItem.defaultItem = {
        Lotskey: '',
        method_description: ''
      }
      this.vDataTableLabOrderItem.selected = []
      this.vDataTableLabOrderItem.editedIndex = -1
      this.vDataTableLabOrderItem.editedItem = {
        Lotskey: '',
        method_description: ''
      }
      this.vDataTableLabOrderItem.defaultItem = {
        Lotskey: '',
        method_description: ''
      }
    },
    getPrefix () {
      this.axios.post(process.env.VUE_APP_API + '/getPrefix')
        .then(response => {
          this.prefixList = response.data
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    getSex () {
      this.axios.post(process.env.VUE_APP_API + '/getSex')
        .then(response => {
          this.sexListAll = response.data
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async getServiceChannel () {
      try {
        const endpoint = `${process.env.VUE_APP_API}/api/v1/service_channel`
        const res = await this.axios.get(endpoint)
        this.serviceChannelList = res.data.data || []
      } catch (e) {
        console.log(e)
      }
    },
    getPrefixSex () {
      this.axios.post(process.env.VUE_APP_API + '/getPrefixSex')
        .then(response => {
          this.prefixSexListAll = response.data
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    getPayment () {
      this.axios.post(process.env.VUE_APP_API + '/getPayment', {
        /* cust_skey: parseInt(localStorage.getItem('cust_skey')) || null */
        cust_skey: parseInt(this.cust_skey) || null
      })
        .then(response => {
          this.paymentListAll = response.data
          this.defaultPayment = response.data[0].description
          this.payment = response.data[0].code
          this.paymentDefault = response.data[0].code
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    getPaymentDescription (item) {
      let found = this.paymentListAll.find(item => item.code === this.payment)
      return found ? found.description : ''
    },
    async retrieveLabRequest (methodcode) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      this.isAddNew = false
      if (this.criteria.ReceivedDateFromTo.length > 0) {
        this.dateSearchFrom = this.criteria.ReceivedDateFromTo[0]
        if (this.criteria.ReceivedDateFromTo.length > 1) {
          this.dateSearchTo = this.criteria.ReceivedDateFromTo[1]
        } else {
          // this.dateSearchTo = this.criteria.ReceivedDateFromTo[0]
          this.dateSearchTo = new Date().toISOString().slice(0, 10)
        }
      }
      await this.axios.post(process.env.VUE_APP_API + '/retrieveLabRequest' + process.env.VUE_APP_DATABASE_TYPE, {
        Lotskey: methodcode,
        status_list: this.status,
        first_Name: this.searchName,
        dateSearch_From: this.dateSearchFrom,
        dateSearch_To: this.dateSearchTo,
        view_skey: this.request_view_skey,
        find_PackageNo: this.searchPackage,
        find_hn: this.find_hn,
        user: localStorage.getItem('username'),
        find_order_id: this.findOrderId
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.appSkey = response.data.data.length > 0 ? response.data.data[0]['Lotskey'] : -1
            this.vDataTable.data = response.data.data
            this.initialize()
            // })
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    viewRemark (item) {
      this.dialog.dialogviewRemark = true
      this.itemRemark = item.remark
    },
    closeViewRemark () {
      this.dialog.dialogviewRemark = false
    },
    getStatusName (status, isReceivedCheck, collected) {
      switch (status) {
        case '' || 'OP':
          return this.$t('WpLabRequest.statusObj.OP')
        case 'COLLECTION':
          return isReceivedCheck === 'YES'
            ? `${this.$t('WpLabRequest.statusObj.RECEIVEDALL')} (${collected})`
            : this.$t('WpLabRequest.statusObj.COLLECTION')
        case 'RECEIVED':
          return this.$t('WpLabRequest.statusObj.RECEIVEDALL')
        case 'CA':
          return this.$t('WpLabRequest.statusObj.CA')
        case 'FIRSTAPPROVE':
          return this.$t('WpLabRequest.statusObj.FIRSTAPPROVE')
        case 'LASTAPPROVE':
          return this.$t('WpLabRequest.statusObj.LASTAPPROVE')
        default:
          return '-'
      }
    },
    getStatusApproveName (status) {
      switch (status) {
        case null:
          return this.$t('WpLabRequest.statusObj.labNotApprove')
        case '':
          return this.$t('WpLabRequest.statusObj.labNotApprove')
        case 0:
          return this.$t('WpLabRequest.statusObj.labNotApprove')
        case 1:
          return this.$t('WpLabRequest.statusObj.labApprove')
      }
    },
    async retrieveView (methodcode) {
      await this.axios.post(process.env.VUE_APP_API + '/wp_view_order_item/retrieveView' + process.env.VUE_APP_DATABASE_TYPE, {})
        .then(response => {
          if (response.data.isSuccess) {
            this.viewList = response.data.data
            this.appSkey = response.data.data.length > 0 ? response.data.data[0]['Lotskey'] : -1
            this.vDataTableView.data = response.data.data
            this.initialize()
            // })
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    addNew () {
      this.currentMode = 'create'
      this.dialog.dialogAddRequest = true
      this.isCreateSuccess = false
      this.editpatient = false
      this.isOrderDisabled = false
      this.isAddItemDisabled = false
      localStorage.setItem('dataListItem', '')
      this.current_order_skey = ''
      this.current_package_no = ''
      this.current_order_id = ''
      this.current_lab_status = ''
      this.hn = ''
      this.prefix = null
      this.firstName = ''
      this.middleName = ''
      this.lastName = ''
      this.dateRequestBrithday = null
      this.patient_id = ''
      this.age = ''
      this.sex = ''
      this.patientRights = this.patientRightsDefault
      this.idCardText = ''
      this.dateReceive = null
      this.dateRequestCollection = this.formatDate(new Date())
      this.requestBy = ''
      this.refDoc = ''
      this.serviceChannel = ''
      this.vDataTable2.data = []
      this.vDataTableLisLabPricing.data = []
      this.vDataTableLisLabSpecimenType.data = []
      this.tempOrderListItem = []
      this.vDataTableLabOrderItem.data = []
      this.vDataTableOrderItem.data = []
      this.isAddNew = true
      this.ageEditing = false
      this.payment = this.paymentListAll[0].default_payment
      this.hospital_lab_no = ''
      this.criteria.firstname = ''
      this.criteria.lastname = ''
      this.criteria.hn = ''
      this.current_patient_skey = ''
      const now = new Date()
      const pad = n => n.toString().padStart(2, '0')
      this.selectedHour = pad(now.getHours())
      this.selectedMinute = pad(now.getMinutes())
      this.selectedSecond = pad(now.getSeconds())
      this.status_lab = ''
    },
    addOther () {
      this.isOrderDisabled = false
      this.isAddItemDisabled = false
      this.isCreateSuccess = false
      this.editpatient = false
      localStorage.setItem('dataListItem', '')
      this.current_order_skey = ''
      this.current_package_no = ''
      this.current_order_id = ''
      this.current_lab_status = ''
      this.hn = ''
      this.prefix = null
      this.firstName = ''
      this.middleName = ''
      this.lastName = ''
      this.dateRequestBrithday = null
      this.patient_id = ''
      this.age = ''
      this.sex = ''
      this.requestBy = ''
      this.refDoc = ''
      this.dateReceive = null
      this.dateRequestCollection = this.formatDate(new Date())
      this.vDataTable2.data = []
      this.vDataTableLisLabPricing.data = []
      this.vDataTableLisLabSpecimenType.data = []
      this.tempOrderListItem = []
      this.vDataTableLabOrderItem.data = []
      this.vDataTableOrderItem.data = []
      this.isAddNew = true
      this.ageEditing = false
      this.payment = this.paymentListAll[0].default_payment
      this.hospital_lab_no = ''
      this.criteria.firstname = ''
      this.criteria.lastname = ''
      this.criteria.hn = ''
      this.current_patient_skey = ''
      const now = new Date()
      const pad = n => n.toString().padStart(2, '0')
      this.selectedHour = pad(now.getHours())
      this.selectedMinute = pad(now.getMinutes())
      this.selectedSecond = pad(now.getSeconds())
      this.patientRights = ''
      this.idCardText = ''
      this.patientRights = this.patientRightsDefault
      this.serviceChannel = ''
      this.status_lab = ''
    },
    updateAge () {
      this.menuBrithday = false
      if (this.dateBrithday) {
        this.age = this.calculateAge(new Date(this.dateBrithday))
        this.ageEditing = false // Stop editing age if date is selected
      } else {
        this.age = '' // Optionally clear age if date is removed
      }
    },
    updateRequestAge () {
      this.menuRequestBrithday = false
      this.menuEditRequestBrithday = false
      if (this.dateRequestBrithday) {
        this.age = this.calculateAge(new Date(this.dateRequestBrithday))
        this.ageEditing = false // Stop editing age if date is selected
      } else {
        this.age = '' // Optionally clear age if date is removed
      }
    },
    calculateAge (birthDate) {
      const today = new Date()
      const birthYear = birthDate.getFullYear()
      const birthMonth = birthDate.getMonth()
      const birthDay = birthDate.getDate()
      let age = today.getFullYear() - birthYear
      if (today.getMonth() < birthMonth || (today.getMonth() === birthMonth && today.getDate() < birthDay)) {
        age--
      }
      return age
    },
    clearDate () {
      this.ageEditing = false
      this.dateBrithday = null
      this.dateRequestBrithday = null
      this.age = '' // Optionally clear age if you want to reset it as well
    },
    handleAgeChange () {
      if (!this.dateBrithday) {
        this.ageEditing = true // Allow editing when no date is selected
      }
      if (!this.dateRequestBrithday) {
        this.ageEditing = true // Allow editing when no date is selected
      }
    },
    disableDatePicker () {
      this.ageEditing = true // Disable date picker when age field is focused
    },
    enableDatePicker () {
      if (!this.age) {
        this.ageEditing = false // Re-enable date picker if age is cleared
      }
    },
    editpatientButton () {
      if (!this.current_order_skey) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorNolab')})
        return
      }
      this.editpatient = false
    },
    // async findPatientFromHN (hn) {
    //   this.dialog.dialogProgress = true
    //   this.progressMessage = this.$t('waiting')
    //   await this.axios.post(process.env.VUE_APP_API + '/register/getListPatient' + process.env.VUE_APP_DATABASE_TYPE, {
    //     firstname: '',
    //     lastname: '',
    //     hn: hn,
    //   })
    //   .then(response => {
    //     if (response.data.isSuccess) {
    //       this.dialog.dialogProgress = false
    //       this.vDataTableFindPatient.data = response.data.data
    //     } else {
    //       this.dialog.dialogProgress = false
    //       this.$swal({type: 'error', title: response.data.reasonText})
    //     }
    //   })
    //   .catch(e => {
    //     this.dialog.dialogProgress = false
    //     this.$swal({type: 'error', title: e.message})
    //   })
    //   this.dialog.dialogFindPatient = true
    // },
    async findPatient () {
      if (!this.criteria.firstname && !this.criteria.lastname && !this.criteria.hn) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorFindPatient')})
      } else {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/register/getListPatient' + process.env.VUE_APP_DATABASE_TYPE, {
          firstname: this.criteria.firstname,
          lastname: this.criteria.lastname,
          hn: this.criteria.hn,
          profile_skey: localStorage.getItem('profile_skey'),
          /* cust_skey: localStorage.getItem('cust_skey') */
          cid: this.idCardText
        })
        .then(response => {
          if (response.data.isSuccess) {
            this.dialog.dialogProgress = false
            const resultData = response.data.data
            if (resultData.length === 1) {
              this.vDataTableFindPatient.selected = [resultData[0]]
              this.addPatient()
            } else if (resultData.length > 1) {
              this.vDataTableFindPatient.data = resultData
              this.dialog.dialogFindPatient = true
            } else {
              this.$swal({type: 'info', title: 'ไม่พบข้อมูลผู้ป่วย'})
            }
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.dialog.dialogProgress = false
          this.$swal({type: 'error', title: e.message})
        })
      }
    },
    addPatient () {
      if (this.vDataTableFindPatient.selected.length === 0) {
        this.$swal({type: 'error', title: 'กรุณาเลือกข้อมูลผู้ป่วย'})
      } else {
        let selPatient = this.vDataTableFindPatient.selected[0]
        this.current_patient_skey = selPatient.patient_skey
        this.hn = selPatient.hn
        this.prefix = selPatient.prefix
        this.firstName = selPatient.firstname
        this.lastName = selPatient.lastname
        this.middleName = selPatient.middle_name
        this.idCardText = selPatient.id_card
        this.patient_id = selPatient.patient_id
        // this.patientRights = '' // comment ข้อมูลที่ User ต้องกรอกเพิ่ม
        // this.Ethnicity = selPatient.race
        // this.Weight = ''
        // this.Height = ''
        // this.hospital_lab_no = ''
        // this.payment = selPatient.pmt_type

        if (selPatient.ignore_birthday === true) {
          this.age = selPatient.age
        }
        if (selPatient.ignore_birthday === null || selPatient.ignore_birthday === false) {
          this.dateRequestBrithday = selPatient.birthday
          this.updateRequestAge()
        }
        // this.dateBrithday = selPatient.birthday
        // this.calculateAge(this.dateBrithday)

        this.sex = selPatient.sex
        // this.dateReceive = ''
        this.editpatient = true
        this.dialog.dialogFindPatient = false
      }
    },
    editpatientFix () {
      this.openEditPatient()
    },
    openEditPatient () {
      this.dialog.dialogEditPatient = true
    },
    async confirmEditPatient () {
      if (this.current_patient_skey) {
        this.dialog.dialogProgress = true
        await this.axios.post(process.env.VUE_APP_API + '/register/editPatient' + process.env.VUE_APP_DATABASE_TYPE, {
          patient_skey: this.current_patient_skey,
          prefix: this.prefix,
          firstname: this.firstName,
          middlename: this.middleName,
          lastname: this.lastName,
          sex: this.sex,
          birthday: this.dateRequestBrithday,
          age: this.age,
          hn: this.hn,
        })
        .then(response => {
          if (response.data.isSuccess) {
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
        .finally(() => {
          this.dialog.dialogProgress = false
        })
      }
      this.dialog.dialogEditPatient = false
    },
    async savePatientButton () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      if (!this.current_order_skey) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorNolab')})
        return
      }
      await this.updatePatientDetail()
      await this.updateUrgent(0)
      await this.updateLabOrder()
      await this.updateLabOrderItemStatus()
      await this.updateCustomerLabOrder(this.current_order_skey, this.cust_skey)
      // await this.getCustomerInfo()
      this.$swal({type: 'success', title: this.$t('WpLabRequest.savePatientSuccess'), showConfirmButton: false, timer: 1000})
      this.dialog.dialogProgress = false
    },
    async addOrderItem (isCreate) {
      let check = 0
      if (this.status_lab && this.status_lab !== 'OP') {
        this.$swal({
          type: 'warning',
          title: this.$t('WpLabRequest.MessageStatusOpenAddOrderItem')
        })
        return
      }
      if (this.payment === '' || this.payment === null) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorPayment')})
        return
      }
      // this.sex === '' || this.firstName === '' || dataListItem === '' || this.dateRequestBrithday === ''
      if (isCreate) {
        let massageError = this.$t('WpLabRequest.pleaseFill')
        if (this.prefix === '') {
          massageError += ' ' + this.$t('WpLabRequest.prefix')
          check += 1
        }
        if (this.firstName === '') {
          massageError += ' ' + this.$t('WpLabRequest.firstName')
          this.showError = true
          check += 1
        }
        if (this.lastName === '') {
          massageError += ' ' + this.$t('WpLabRequest.lastName')
          this.showError = true
          check += 1
        }
        if (this.sex === '') {
          massageError += ' ' + this.$t('WpLabRequest.sex')
          check += 1
        }
        if (!this.dateRequestBrithday && this.age === '') {
          massageError += ' ' + this.$t('WpLabRequest.brithdayOrAge')
          check += 1
        }
        // if (this.patientRights === '') {
        //   massageError += ' ' + this.$t('WpLabRequest.patientRights')
        //   check += 1
        // }
        if (this.cust_skey === '' || this.cust_skey === null) {
          massageError += ' ' + this.$t('WpLabRequest.customer')
          check += 1
        }
        massageError += ' ' + this.$t('WpLabRequest.beforeAddOrderItem')
        if (this.prefix !== '' && this.sex !== '') {
          const isValid = this.prefixSexListAll.some(
            (combination) =>
              combination.prefix_cd === this.prefix &&
              combination.sex_cd === this.sex
          )
          if (!isValid) {
            // Proceed with sending the data
            check += 1
            massageError += ' ' + this.$t('WpLabRequest.prefixSexMismatch')
          }
        }
        if (check > 0) {
          this.$swal({type: 'error', title: massageError})
          return
        }
        this.showError = false
        this.editpatient = true
      } else {
        check = 0
      }
      if (check === 0) {
        if (!this.current_patient_skey) {
          const found = await this.checkExistingPatient(this.firstName, this.lastName, this.idCardText)
          if (found) return
          /* await this.axios.post(process.env.VUE_APP_API + '/checkPatient' + process.env.VUE_APP_DATABASE_TYPE, {
            firstname: this.firstName,
            lastname: this.lastName
          }
          ).then(responce => {
            if (responce.data.data[0].result === 1) {
              this.$swal({
                html: `
                  <p>พบข้อมูลผู้ป่วยในระบบ</p>
                  <p>ต้องการใช้ข้อมูลผู้ป่วยนี้หรือไม่?</p>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
              }).then((result) => {
                if (result) {
                  this.criteria.firstName = this.firstName
                  this.criteria.lastname = this.lastName
                  this.findPatient()
                }
              })
            }
          }) */
        }
        this.dialog.dialogAddOrder = true
        this.tempOrderListItem = []
        this.vDataTableLabOrderItem.data = []
        localStorage.setItem('dataListItem', null)
        if (this.vDataTable2.data.length > 0) {
          for (let index = 0; index < this.vDataTable2.data.length; index++) {
            this.new_row = {
              No: index + 1,
              order_item_id: this.vDataTable2.data[index].order_item_id,
              order_item_desc: this.vDataTable2.data[index].order_item_desc,
              medium_price: this.vDataTable2.data[index].medium_price,
              specimen_type_desc: this.vDataTable2.data[index].specimen_type_desc,
              specimen_type_cd: this.vDataTable2.data[index].specimen_type_cd,
              sub_category_desc: this.vDataTable2.data[index].sub_category_desc,
              Qty: 1,
              order_item_skey: this.vDataTable2.data[index].order_item_skey,
              view_skey: this.vDataTable2.data[index].view_skey,
              filename: this.vDataTable2.data[index].filename,
              probe_list: this.vDataTable2.data[index].probe_list,
              probes: this.vDataTable2.data[index].probes,
              diagnosis: this.vDataTable2.data[index].diagnosis,
              require_comment: this.vDataTable2.data[index].require_comment,
              require_diagnosis: this.vDataTable2.data[index].require_diagnosis,
              require_volume_urine: this.vDataTable2.data[index].require_volume_urine,
              volume_urine: this.vDataTable2.data[index].volume_urine
            }
            this.tempOrderListItem.push(this.new_row)
            if (index === 0) {
              localStorage.setItem('dataListItem', this.vDataTable2.data[index].order_item_id + '^' + this.vDataTable2.data[index].specimen_type_cd + '^' + (this.vDataTable2.data[index].probes.map(p => p.probe_cd).join(',') || '') + '^')
            } else {
              localStorage.setItem('dataListItem', localStorage.getItem('dataListItem') + '|' + this.vDataTable2.data[index].order_item_id + '^' + this.vDataTable2.data[index].specimen_type_cd + '^' + (this.vDataTable2.data[index].probes.map(p => p.probe_cd).join(',') || '') + '^')
            }
          }
          this.vDataTableLabOrderItem.data = this.tempOrderListItem
        }
      }
    },
    async checkExistingPatient (firstName, lastName, cid) {
      try {
        const response = await this.axios.post(`${process.env.VUE_APP_API}/checkPatient${process.env.VUE_APP_DATABASE_TYPE}`, {
          firstname: firstName,
          lastname: lastName,
          cid: cid
          // คุณสามารถเพิ่ม cid: cid ถ้า API รองรับ
        })
        if (response.data.data[0].result === 1) {
          this.$swal({
            html: `
              <p>พบข้อมูลผู้ป่วยในระบบ</p>
              <p>ต้องการใช้ข้อมูลผู้ป่วยนี้หรือไม่?</p>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.criteria.firstname = this.firstName
              this.criteria.lastname = this.lastName
              this.findPatient()
            }
          })
        }
      } catch (error) {
        console.error('Error checking patient:', error)
      }
      return false
    },
    async searchItem () {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/retrieveSearchItem', {
        item: this.itemSearch,
        sub_category_skey: this.sub_category_skey,
        cust_skey: this.cust_skey
      }
      ).then(res => {
        if (res.data.isSuccess) {
          this.vDataTableOrderItem.data = res.data.data
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
      this.dialog.dialogProgress = false
    },
    selectCatRow (item, row) {
      row.select(true)
      this.view_skey = item.view_skey
      this.retrieveOrderItem(this.view_skey)
    },
    async retrieveOrderItem (viewSkey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      await this.axios.post(process.env.VUE_APP_API + '/retrieveOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: this.cust_skey,
        view_skey: viewSkey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.appSkey = response.data.data.length > 0 ? response.data.data[0]['Lotskey'] : -1
            this.vDataTableOrderItem.data = response.data.data
            this.initialize()
            this.lab_id = this.viewIdSelect
            // })
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    selectOrderItemListRow (item, row) {
      if (item.price_active === 1 && item.medium_price !== null) {
        row.select(true)
        this.selectOrderItem(item)
      } else {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorPrice'), showConfirmButton: false, timer: 1000})
      }
    },
    async selectOrderItemCommentRow (item, isEdit) {
      this.isEditComment = isEdit
      this.orderItemComment = ''
      this.selectedOrderItemId = item.order_item_id
      this.current_specimen_type = item.specimen_type_cd
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/selectOrderItemComment' + process.env.VUE_APP_DATABASE_TYPE, {
        order_item_skey: item.order_item_skey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.orderItemCommentList = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      if (this.current_order_skey === '') {
        let localData = localStorage.getItem('dataListItem') || ''
        let dataArray = localData.split('|') // Split into multiple items
        // Find the entry for the selected `order_item_id`
        let foundItem = dataArray.find(data => {
          let [storedId, storedSpecimen] = data.split('^') // Get order_item_id and specimen_type_cd
          return storedId === item.order_item_id && storedSpecimen === this.current_specimen_type
        })
        // Extract the comment (3rd value after second `^`)
        this.orderItemComment = foundItem && foundItem.split('^').length > 3 ? foundItem.split('^')[3] : null
      } else {
        if (this.addRequestComment === 0) {
          if (this.newOrderSkey === '') {
            this.dialog.dialogProgress = true
            await this.axios.post(process.env.VUE_APP_API + '/orderItem/getOrderItemComment' + process.env.VUE_APP_DATABASE_TYPE, {
              order_item_skey: item.order_item_skey,
              order_skey: this.current_order_skey
            })
              .then(response => {
                if (response.data.isSuccess) {
                  this.orderItemComment = response.data.data[0]?.comment || ''
                } else {
                  this.$swal({type: 'error', title: response.data.reasonText})
                }
              })
              .catch(e => {
                this.$swal({type: 'error', title: e.message})
              })
            this.dialog.dialogProgress = false
          } else {
            this.orderItemComment = ''
          }
        } else {
          this.addLabOrderItem(this.current_order_skey, this.current_order_item_skey, this.current_specimen_type, this.current_probes)
          this.addRequestComment = 0
        }
      }
      this.dialog.dialogProgress = false
      this.dialog.dialogOrderItemComment = true
    },
    async submitOrderItemComment () {
      if (this.current_order_skey === '') {
        // Retrieve existing data
        let localData = localStorage.getItem('dataListItem') || ''
        let dataArray = localData ? localData.split('|') : []
        // Find index of the entry to update
        let index = dataArray.findIndex(data => {
          let [storedId, storedSpecimen] = data.split('^')
          return storedId === this.selectedOrderItemId && storedSpecimen === this.current_specimen_type
        })
        if (index !== -1) {
          // Update the existing entry (order_item_id^code^new_comment)
          let parts = dataArray[index].split('^')
          dataArray[index] = `${parts[0]}^${parts[1]}^${parts[2]}^${this.orderItemComment}^${parts[4]}^${parts[5]}`
        } else {
          // Add a new entry if not found
          let newEntry = `${this.selectedOrderItemId}^^${this.orderItemComment}^^`
          dataArray.push(newEntry)
        }
        // Store updated data back in localStorage
        localStorage.setItem('dataListItem', dataArray.join('|'))
        // Close dialog after saving
        if (this.isEditComment === 0) {
          this.closeOrderItemComment()
        } else {
          this.dialog.dialogOrderItemComment = false
        }
      } else {
        if (this.newOrderSkey !== '') {
          this.dialog.dialogProgress = true
          await this.axios.post(process.env.VUE_APP_API + '/orderItem/updateOrderItemComment' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_id: this.selectedOrderItemId,
            order_skey: this.newOrderSkey,
            comment: this.orderItemComment
          })
          .then(response => {
            if (response.data.isSuccess) {
              this.$swal({type: 'success', title: 'บันทึกเรียบร้อย', showConfirmButton: false, timer: 1500})
              this.newOrderSkey = ''
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
          this.dialog.dialogProgress = false
        } else {
          this.dialog.dialogProgress = true
          await this.axios.post(process.env.VUE_APP_API + '/orderItem/updateOrderItemComment' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_id: this.selectedOrderItemId,
            order_skey: this.current_order_skey,
            comment: this.orderItemComment
          })
          .then(response => {
            if (response.data.isSuccess) {
              this.$swal({type: 'success', title: 'บันทึกเรียบร้อย', showConfirmButton: false, timer: 1500})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
          this.dialog.dialogProgress = false
        }
        this.dialog.dialogProgress = false
        if (this.isEditComment === 0) {
          this.closeOrderItemComment()
        } else {
          this.dialog.dialogOrderItemComment = false
        }
      }
    },
    closeOrderItemVolumeUrine () {
      this.dialog.dialogOrderItemVolumeUrine = false
    },
    closeOrderItemComment () {
      this.dialog.dialogOrderItemComment = false
      this.dialog.dialogOrderItemDiagnosis = false
      let foundItem = []
      if (this.newOrder === true) {
        foundItem = this.newlabItem
      } else {
        foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId)
      }
      if (foundItem.require_volume_urine === 1) {
        this.selectOrderItemValumeUrine(this.itemComment, 0)
      } else {
        this.newOrderSkey = ''
      }
    },
    async autoSaveOrderItem () {
      if (this.current_order_skey !== '') {
        this.dialog.dialogProgress = true
        await this.updateLabOrderItem()
        // await this.retrieveDetailFromOrderID(this.current_order_id, this.current_sub_category_skey)
        this.dialog.dialogProgress = false
      }
    },
    async selectOrderItemDiagnosisRow (item, isEdit) {
      this.isEditDiagnosis = isEdit
      this.orderItemDiagnosis = ''
      this.selectedOrderItemId = item.order_item_id
      this.current_order_item_skey = item.order_item_skey
      this.current_specimen_type = item.specimen_type_cd
      if (this.current_order_skey === '') {
        const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId && x.specimen_type_cd === this.current_specimen_type)
        this.orderItemDiagnosis = foundItem ? foundItem.diagnosis : ''
      } else {
        this.orderItemDiagnosis = item.diagnosis
      }
      this.dialog.dialogProgress = false
      this.dialog.dialogOrderItemDiagnosis = true
    },
    async submitOrderItemDiagnosis () {
      if (this.current_order_skey === '') {
        const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId && x.specimen_type_cd === this.current_specimen_type)
        if (foundItem) {
          foundItem.diagnosis = this.orderItemDiagnosis
          let localData = localStorage.getItem('dataListItem') || ''
          let dataArray = localData ? localData.split('|') : []
          // Find the correct index by order_item_id and specimen_type_cd
          let index = dataArray.findIndex(data => {
            let [storedId, storedSpecimen] = data.split('^')
            return storedId === this.current_order_item_id && storedSpecimen === this.current_specimen_type
          })
          let parts = dataArray[index].split('^')
          // Replace only the 3rd field (probes)
          parts[4] = this.orderItemDiagnosis || ''
          dataArray[index] = parts.join('^')
          localStorage.setItem('dataListItem', dataArray.join('|'))
        }
        if (this.isEditDiagnosis === 0) {
          this.closeOrderItemDiagnosis()
        } else {
          this.dialog.dialogOrderItemDiagnosis = false
        }
      } else {
        if (this.newOrderSkey !== '') {
          this.dialog.dialogProgress = true
          await this.axios.post(process.env.VUE_APP_API + '/updataDiagnosis' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_skey: this.current_order_item_skey,
            order_skey: this.newOrderSkey,
            diagnosis: this.orderItemDiagnosis
          })
          .then(response => {
            if (response.data.isSuccess) {
              this.closeOrderItemDiagnosis()
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
          this.dialog.dialogProgress = false
        } else {
          if (this.addRequestDiagnosis === 0) {
            this.dialog.dialogProgress = true
            await this.axios.post(process.env.VUE_APP_API + '/updataDiagnosis' + process.env.VUE_APP_DATABASE_TYPE, {
              order_skey: this.current_order_skey,
              order_item_skey: this.current_order_item_skey,
              diagnosis: this.orderItemDiagnosis
            }).then(res => {
              const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId)
              if (foundItem) {
                foundItem.diagnosis = this.orderItemDiagnosis
              }
              if (this.isEditDiagnosis === 0) {
                this.closeOrderItemDiagnosis()
              } else {
                this.dialog.dialogOrderItemDiagnosis = false
              }
            })
            this.dialog.dialogProgress = false
          } else {
            this.addLabOrderItem(this.current_order_skey, this.current_order_item_skey, this.current_specimen_type, this.current_probes)
            this.axios.post(process.env.VUE_APP_API + '/updataDiagnosis' + process.env.VUE_APP_DATABASE_TYPE, {
              order_skey: this.current_order_skey,
              order_item_skey: this.current_order_item_skey,
              diagnosis: this.orderItemDiagnosis
            }).then(res => {
              const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId)
              if (foundItem) {
                foundItem.diagnosis = this.orderItemDiagnosis
              }
              this.addRequestDiagnosis = 1
              if (this.isEditDiagnosis === 0) {
                this.closeOrderItemDiagnosis()
              } else {
                this.dialog.dialogOrderItemDiagnosis = false
              }
            })
          }
        }
        this.dialog.dialogProgress = false
      }
    },
    async selectOrderItemValumeUrine (item, isEdit) {
      this.isEditVolumeUrine = isEdit
      this.orderItemVolumeUrine = ''
      this.selectedOrderItemId = item.order_item_id
      this.current_order_item_skey = item.order_item_skey
      this.current_specimen_type = item.specimen_type_cd
      if (this.current_order_skey === '') {
        const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId && x.specimen_type_cd === this.current_specimen_type)
        this.orderItemVolumeUrine = foundItem ? foundItem.volume_urine : ''
      } else {
        this.orderItemVolumeUrine = item.volume_urine
      }
      this.dialog.dialogProgress = false
      this.dialog.dialogOrderItemVolumeUrine = true
    },
    async submitOrderItemVolumeUrine () {
      if (this.current_order_skey === '') {
        const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId && x.specimen_type_cd === this.current_specimen_type)
        if (foundItem) {
          foundItem.volume_urine = this.orderItemVolumeUrine
          // Retrieve existing data
          let localData = localStorage.getItem('dataListItem') || ''
          let dataArray = localData ? localData.split('|') : []
          // Find index of the entry to update
          let index = dataArray.findIndex(data => {
            let [storedId, storedSpecimen] = data.split('^')
            return storedId === this.selectedOrderItemId && storedSpecimen === this.current_specimen_type
          })
          if (index !== -1) {
            let parts = dataArray[index].split('^')
            parts[5] = this.orderItemVolumeUrine || ''
            dataArray[index] = `${parts[0]}^${parts[1]}^${parts[2]}^${parts[3]}^${parts[4]}^${parts[5]}`
          } else {
            // Add a new entry if not found
            let newEntry = `${this.selectedOrderItemId}^^^^${this.orderItemVolumeUrine}`
            dataArray.push(newEntry)
          }
          // Store updated data back in localStorage
          localStorage.setItem('dataListItem', dataArray.join('|'))
          // Close dialog after saving
          this.closeOrderItemVolumeUrine()
        }
      } else {
        if (this.newOrderSkey !== '') {
          this.dialog.dialogProgress = true
          await this.axios.post(process.env.VUE_APP_API + '/updataVolumeUrine' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_skey: this.current_order_item_skey,
            order_skey: this.newOrderSkey,
            volume_urine: this.orderItemVolumeUrine
          })
          .then(response => {
            if (response.data.isSuccess) {
              const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId && x.specimen_type_cd === this.current_specimen_type)
              if (foundItem) {
                foundItem.volume_urine = this.orderItemVolumeUrine
              }
              this.$swal({type: 'success', title: 'บันทึกเรียบร้อย', showConfirmButton: false, timer: 1500})
              this.newOrderSkey = ''
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
          this.dialog.dialogProgress = false
        } else {
          this.dialog.dialogProgress = true
          await this.axios.post(process.env.VUE_APP_API + '/updataVolumeUrine' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_skey: this.current_order_item_skey,
            order_skey: this.current_order_skey,
            volume_urine: this.orderItemVolumeUrine
          })
          .then(response => {
            if (response.data.isSuccess) {
              const foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId && x.specimen_type_cd === this.current_specimen_type)
              if (foundItem) {
                foundItem.volume_urine = this.orderItemVolumeUrine
              }
              this.$swal({type: 'success', title: 'บันทึกเรียบร้อย', showConfirmButton: false, timer: 1500})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
          this.dialog.dialogProgress = false
        }
        this.dialog.dialogProgress = false
        this.closeOrderItemVolumeUrine()
      }
    },
    closeOrderItemDiagnosis () {
      this.dialog.dialogOrderItemDiagnosis = false
      let foundItem = []
      if (this.newOrder === true) {
        foundItem = this.newlabItem
      } else {
        foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.selectedOrderItemId)
      }
      if (foundItem.require_comment === 1) {
        this.selectOrderItemCommentRow(this.itemComment, 0)
      } else if (foundItem.require_volume_urine === 1) {
        this.selectOrderItemValumeUrine(this.itemComment, 0)
      } else {
        this.newOrderSkey = ''
      }
    },
    async addLabOrderItem (orderSkey, orderItemSkey, specimenTypeCd, probes) {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/addOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: orderSkey,
        order_item_skey: orderItemSkey,
        specimen_type_cd: specimenTypeCd,
        probes: probes
      })
        .then(res => {
          if (res.data.isSuccess) {
            this.$swal({type: 'success', title: res.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: res.data.reasonText, showConfirmButton: false, timer: 1500})
          }
          // this.dialog.dialogProgress = false
        })
      this.dialog.dialogProgress = false
    },
    async selectOrderItem (item) {
      this.itemComment = {}
      this.current_specimen_type = ''
      this.current_probes = ''
      this.current_order_item_skey = ''
      this.current_order_item_id = item.order_item_id
      this.current_specimen_type = item.specimen_type_cd
      this.current_order_item_skey = item.order_item_skey
      this.addRequestDiagnosis = 0
      this.addRequestComment = 0
      this.newlabItem = []
      this.newOrder = false
      this.itemComment = {
        order_item_id: item.order_item_id,
        order_item_skey: item.order_item_skey,
        specimen_type_cd: item.specimen_type_cd
      }
      if (this.tempOrderListItem.length === 0) {
        this.tempOrderListItem = [{
          'No': 1,
          'order_item_skey': item.order_item_skey,
          'order_item_id': item.order_item_id,
          'order_item_desc': item.order_item_desc,
          'medium_price': item.medium_price,
          'specimen_type_desc': item.specimen_type_desc,
          'sub_category_desc': item.sub_category_desc,
          'specimen_type_cd': item.specimen_type_cd,
          'remark': item.remark,
          'is_get_back': 0,
          'is_urgent': 0,
          'due_date': item.due_date,
          'view_skey': item.view_skey,
          'filename': item.filename,
          'require_probe': item.probes.length > 0 ? 1 : 0,
          'probe_list': item.probes,
          'probes': [],
          'diagnosis': '',
          'require_comment': item.require_comment,
          'require_diagnosis': item.require_diagnosis,
          'require_volume_urine': item.require_volume_urine
        }]
        localStorage.setItem('dataListItem', item.order_item_id + '^' + item.specimen_type_cd + '^' + (item.probes.length > 0 ? 'preProbeCode' : '') + '^^^')
        if (item.probes.length > 0) {
          this.vDataTableProbe.data = item.probes
          this.vDataTableProbe.selected = []
          this.dialog.dialogSelectProbe = true
        } else if (item.require_diagnosis === 1) {
          this.addRequestDiagnosis = 1
          this.selectOrderItemDiagnosisRow(this.itemComment, 0)
        } else if (item.require_comment === 1) {
          this.addRequestComment = 1
          this.selectOrderItemCommentRow(this.itemComment, 0)
        } else if (item.require_volume_urine === 1) {
          this.addRwequestVolumeUrine = 1
          this.selectOrderItemValumeUrine(this.itemComment, 0)
        } else {
          if (this.current_order_skey !== '') {
            this.addLabOrderItem(this.current_order_skey, this.current_order_item_skey, this.current_specimen_type, this.current_probes)
          }
        }
        this.vDataTableLabOrderItem.data = this.tempOrderListItem
        this.tmpOrderItemID = this.SelectOrderItemID
      } else {
        // Check for duplicate item and mismatched specimen_type_cd
        const existingItem = this.tempOrderListItem.find(item2 =>
          item2.order_item_id === item.order_item_id &&
          item2.specimen_type_cd === item.specimen_type_cd
        )
        const hasConflict = this.tempOrderListItem.some(item2 =>
          item2.specimen_type_cd !== item.specimen_type_cd || item2.view_skey !== item.view_skey
        )
        if (existingItem) {
          this.$swal({type: 'error', title: this.$t('WpLabRequest.errorDuplicateItem'), showConfirmButton: false, timer: 1500})
        /* } else if (hasConflict && this.current_order_skey !== '') {
          this.$swal({
            html: `
              <p>เนื่องจากรายการตรวจต่างห้องปฏิบัติการ</p>
              <p>หรือประเภทสิ่งตรวจต่างชนิด</p>
              <p>ต้องการสร้างคำสั่งตรวจใหม่หรือไม่</p>
            `,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.newOrder = true
              this.createOrderFromOrder(item.order_item_id + '^' + item.specimen_type_cd + '^^^^')
              this.newlabItem = item
              if (item.probes.length > 0) {
                this.vDataTableProbe.data = item.probes
                this.vDataTableProbe.selected = []
                this.dialog.dialogSelectProbe = true
                if (item.require_comment === 1) {
                  this.shouldOpenComment = true
                }
              } else if (item.require_diagnosis === 1) {
                this.selectOrderItemDiagnosisRow(this.itemComment, 0)
              } else if (item.require_comment === 1) {
                this.selectOrderItemCommentRow(this.itemComment, 0)
              } else if (item.require_volume_urine === 1) {
                this.selectOrderItemValumeUrine(this.itemComment, 0)
              }
            }
          }) */
        } else {
          this.new_row = {
            No: this.tempOrderListItem.length + 1,
            order_item_skey: item.order_item_skey,
            order_item_id: item.order_item_id,
            order_item_desc: item.order_item_desc,
            medium_price: item.medium_price,
            specimen_type_desc: item.specimen_type_desc,
            sub_category_desc: item.sub_category_desc,
            specimen_type_cd: item.specimen_type_cd,
            remark: item.remark,
            is_get_back: 0,
            is_urgent: 0,
            due_date: item.due_date,
            view_skey: item.view_skey,
            filename: item.filename,
            require_probe: item.probes.length > 0 ? 1 : 0,
            probe_list: item.probes,
            probes: [],
            diagnosis: '',
            require_comment: item.require_comment,
            require_diagnosis: item.require_diagnosis,
            require_volume_urine: item.require_volume_urine
          }
          this.tempOrderListItem.push(this.new_row)
          // this.vDataTableLabOrderItem.data = this.tempOrderListItem
          localStorage.setItem('dataListItem', localStorage.getItem('dataListItem') + '|' + item.order_item_id + '^' + item.specimen_type_cd + '^' + (item.probes.length > 0 ? 'preProbeCode' : '') + '^^^')
          if (item.probes.length > 0) {
            this.vDataTableProbe.data = item.probes
            this.vDataTableProbe.selected = []
            this.dialog.dialogSelectProbe = true
            if (item.require_comment === 1) {
              this.shouldOpenComment = true
            }
          } else if (item.require_diagnosis === 1) {
            this.addRequestDiagnosis = 1
            this.selectOrderItemDiagnosisRow(this.itemComment, 0)
          } else if (item.require_comment === 1) {
            this.addRequestComment = 1
            this.selectOrderItemCommentRow(this.itemComment, 0)
          } else if (item.require_volume_urine === 1) {
            this.selectOrderItemValumeUrine(this.itemComment, 0)
          } else {
            if (this.current_order_skey !== '') {
              this.addLabOrderItem(this.current_order_skey, this.current_order_item_skey, this.current_specimen_type, this.current_probes)
            }
          }
          this.vDataTableLabOrderItem.data = this.tempOrderListItem
        }
      }
    },
    openEditProbe (item) {
      this.isEditProbe = 1
      this.current_order_item_id = item.order_item_id
      this.current_order_item_skey = item.order_item_skey
      this.vDataTableProbe.data = item.probe_list
      this.vDataTableProbe.selected = item.probes
      this.dialog.dialogSelectProbe = true
    },
    async closeSelectProbe () {
      var selectedProbe = ''
      selectedProbe = this.vDataTableProbe.selected
        .map(item => item.probe_cd)
        .join(',')
      this.current_probes = selectedProbe
      if (this.newOrder === false) {
        const selectedTotalPrice = this.vDataTableProbe.selected.reduce((sum, probe) => sum + (probe.price || 0), 0)
        const selectedProbeList = this.vDataTableProbe.selected.map(probe => ({
          probe_cd: probe.probe_cd,
          price: probe.price
        }))
        this.tempOrderListItem = this.tempOrderListItem.map(item => {
          if (item.order_item_id === this.current_order_item_id && item.specimen_type_cd === this.current_specimen_type) {
            return {
              ...item,
              medium_price: selectedTotalPrice,
              probes: selectedProbeList
            }
          }
          return item
        })
        this.vDataTableLabOrderItem.data = this.tempOrderListItem
      }
      if (this.current_order_skey === '') {
        let localData = localStorage.getItem('dataListItem') || ''
        let dataArray = localData ? localData.split('|') : []
        let index = dataArray.findIndex(data => {
          let [storedId, storedSpecimen] = data.split('^')
          return storedId === this.current_order_item_id && storedSpecimen === this.current_specimen_type
        })
        if (index !== -1) {
          let parts = dataArray[index].split('^')
          // Replace only the 3rd field (probes)
          parts[2] = selectedProbe
          dataArray[index] = parts.join('^')
        } else {
          // Add new entry with probes only (comment can be empty for now)
          let newEntry = `${this.current_order_item_id}^${this.current_specimen_type}^${selectedProbe}^^`
          dataArray.push(newEntry)
        }
        localStorage.setItem('dataListItem', dataArray.join('|'))
      }
      if (this.current_order_skey !== '') {
        if (this.isEditProbe === 1) {
          this.dialog.dialogProgress = true
          await this.axios.post(process.env.VUE_APP_API + '/wp_probe/updateLabProbe' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_skey: this.current_order_item_skey,
            order_skey: this.current_order_skey,
            probes: this.current_probes
          })
          .then(response => {
            if (response.data.isSuccess) {
              this.$swal({type: 'success', title: 'บันทึกเรียบร้อย', showConfirmButton: false, timer: 1500})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          this.dialog.dialogProgress = false
        } else {
          if (this.newOrder === true) {
            await this.axios.post(process.env.VUE_APP_API + '/wp_probe/updateLabProbe' + process.env.VUE_APP_DATABASE_TYPE, {
              order_item_skey: this.current_order_item_skey,
              order_skey: this.newOrderSkey,
              probes: this.current_probes
            })
            .then(response => {
              if (response.data.isSuccess) {
                this.$swal({type: 'success', title: 'บันทึกเรียบร้อย', showConfirmButton: false, timer: 1500})
              } else {
                this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
          } else {
            await this.addLabOrderItem(this.current_order_skey, this.current_order_item_skey, this.current_specimen_type, this.current_probes)
          }
        }
      }
      this.dialog.dialogSelectProbe = false
      let foundItem = []
      if (this.newOrder === true) {
        foundItem = this.newlabItem
      } else {
        foundItem = this.tempOrderListItem.find(x => x.order_item_id === this.current_order_item_id)
      }
      if (this.isEditProbe === 0) {
        if (foundItem.require_diagnosis === 1) {
          this.selectOrderItemDiagnosisRow(this.itemComment, 0)
        } else if (foundItem.require_comment === 1) {
          this.selectOrderItemCommentRow(this.itemComment, 0)
        } else if (foundItem.require_volume_urine === 1) {
          this.selectOrderItemValumeUrine(this.itemComment, 0)
        }
      }
      this.isEditProbe = 0
    },
    async deletefromselected (item, index, orderSkey) {
      this.dialog.dialogProgress = true
      this.tempOrderListItem.splice(index, 1)
      let tmpItem = localStorage.getItem('dataListItem').split('|')
      let searchPattern = item.order_item_id + '^' + item.specimen_type_cd + '^'
      // Find the index of the item to delete (including comment if exists)
      let indexToDelete = tmpItem.findIndex(entry => entry.startsWith(searchPattern))
      if (indexToDelete !== -1) {
        // Delete the item from the localStorage list
        tmpItem.splice(indexToDelete, 1)
        // Update the localStorage with the modified list
        localStorage.setItem('dataListItem', tmpItem.join('|'))
      }
      if (this.current_order_skey !== '') {
        await this.axios.post(process.env.VUE_APP_API + '/deleteOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
          order_skey: orderSkey,
          order_item_skey: item.order_item_skey
        })
          .then(res => {
            if (res.data.isSuccess) {
              this.$swal({type: 'success', title: res.data.reasonText, showConfirmButton: false, timer: 1500})
            } else {
              this.$swal({type: 'error', title: res.data.reasonText, showConfirmButton: false, timer: 1500})
            }
            // this.dialog.dialogProgress = false
          })
      }
      this.dialog.dialogProgress = false
    },
    async deletefromselected_BK (item, index) {
      this.tempOrderListItem.splice(index, 1)
      let tmpItem = localStorage.getItem('dataListItem').split('|')
      let indexToDelete = tmpItem.indexOf((item.order_item_id + '^' + item.specimen_type_cd).toString())
      if (indexToDelete !== -1) {
        tmpItem.splice(indexToDelete, 1)
      }
      localStorage.setItem('dataListItem', tmpItem.join('|'))
      this.autoSaveOrderItem()
    },
    addSelectOrder () {
      this.vDataTable2.data = this.vDataTableLabOrderItem.data
      this.$swal({type: 'success', title: this.$t('WpLabRequest.saveSucess'), showConfirmButton: false, timer: 1000})
      // this.dialog.dialogAddOrder = false
    },
    async closeAddOrder () {
      this.dialog.dialogAddOrder = false
      if (this.current_order_skey !== '') {
        /* await this.retrieveDetailFromOrderID(this.current_order_id, this.current_sub_category_skey) */
        await this.retrieveLabOrderAll(this.current_order_skey)
      }
    },
    async retrieveLabOrder (orderSkey) {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/OrderEntry/retrieveLabOrder', {
        order_skey: orderSkey
      })
      .then(response => {
        if (response.data.isSuccess) {
          this.vDataTableAfterCreated.data = response.data.data
          /* this.vDataTableAfterCreated.data = response.data.data.map(item => ({
            ...item,
            orderId: item.order_id || item.orderId, // รองรับทั้งสองแบบ
            collectionDate: item.collection_date || item.collectionDate,
            orderItems: item.order_items || item.orderItems || [] // ต้องมีอันนี้ ตารางถึงจะขยายได้
          })) */
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
      .catch(e => {
        this.$swal({type: 'error', title: e.message})
      })
      .finally(() => {
        this.dialog.dialogProgress = false
      })
    },
    async createOrder () {
      this.vDataTableAfterCreated.data = []
      let check = 0
      const stored = localStorage.getItem('dataListItem')
      const selectedOrders = stored?.split('|').map(str => {
        const [orderId, specimenCd, comment] = str.split('^')
        return {
          order_item_id: orderId,
          specimen_type_cd: specimenCd,
          comment: comment || null
        }
      }) || []
      const hasRequireDOB = selectedOrders.some(item => {
        const matched = this.vDataTableOrderItem.data.find(o => o.order_item_id === item.order_item_id)
        return matched?.require_dob === 1
      })
      // Check if DOB is empty
      if (hasRequireDOB && !this.dateRequestBrithday) {
        this.$swal({ type: 'error', title: 'กรุณาเลือกวันเดือนปีเกิด' })
        check += 1
      }
      const dataListItem = localStorage.getItem('dataListItem')
      if (this.sex === '' || this.firstName === '' || dataListItem === '' || this.dateRequestBrithday === '' || this.lastName === '') {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCreateOrderIncompleteData')})
        check += 1
      }
      if (this.current_order_skey !== '') {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.cannotCreateOrder')})
        check += 1
      }
      // if (!this.patientRights) {
      //   this.$swal({ type: 'error', title: 'Please Select Patient Rights' })
      //   check += 1
      // }
      if (check === 0) {
        this.dialog.dialogProgress = true
        this.updateDateTime()
        await this.axios.post(process.env.VUE_APP_API + '/createOrder' + process.env.VUE_APP_DATABASE_TYPE, {
          patient_skey: this.current_patient_skey,
          prefix: this.prefix,
          firstname: this.firstName,
          middlename: this.middleName,
          lastname: this.lastName,
          sex: this.sex,
          birthday: this.dateRequestBrithday,
          age: this.age,
          hn: this.hn,
          requestBy: this.requestBy,
          refDoc: this.refDoc,
          /* cust_skey: localStorage.getItem('cust_skey'), */
          cust_skey: this.cust_skey,
          lab_items_code_list: dataListItem,
          user_created: localStorage.getItem('username'),
          payment_tpye: this.payment,
          hospital_lab_no: this.hospital_lab_no,
          collectDate: this.collectDate.toISOString(),
          idCard: this.idCardText,
          patientRights: this.patientRights,
          service_channel: this.serviceChannel
        }).then(res => {
          if (res.data.isSuccess === true) {
            this.current_order_skey = res.data.data[0].order_skey
            this.current_order_id = res.data.data[0].order_id
            this.isOrderDisabled = true
            this.isAddNew = false
            this.editpatient = true
            this.$swal({type: 'success', title: this.$t('WpLabRequest.createOrderSuccess'), showConfirmButton: false, timer: 1500})
            this.updateUrgent(0)
            this.isCreateSuccess = true
            /* this.retrieveLabOrder(this.current_order_skey) */
            setTimeout(() => {
              this.retrieveLabOrderAll(this.current_order_skey)
            }, 300)
            /* const reformattedData = res.data.data.reduce((acc, {
              patient_skey: patientSkey,
              order_skey: orderSkey,
              order_id: orderId,
              order_item_skey: orderItemSkey,
              order_item_id: orderItemId,
              order_item_desc: orderItemDesc,
              specimen_type_id: specimenTypeId,
              collection_date: collectionDate,
              require_collection_date: requireCollectionDate,
              collection_date_min: collectionDateMin,
              collection_hour: collectionHour,
              collection_minute: collectionMinute,
              collection_second: collectionSecond
            }) => {
              const existingOrder = acc.find(order => order.orderId === orderId)
              if (existingOrder) {
                existingOrder.orderItems.push({
                  orderItemSkey: orderItemSkey,
                  orderItemId: orderItemId,
                  orderItemDesc: orderItemDesc,
                  specimenTypeId: specimenTypeId,
                  requireCollectionDate: requireCollectionDate
                })
                if (requireCollectionDate === 1) {
                  existingOrder.requireCollectionDate = 1
                }
              } else {
                acc.push({
                  patientSkey: patientSkey,
                  orderSkey: orderSkey,
                  orderId: orderId,
                  collectionDate: collectionDate,
                  requireCollectionDate: requireCollectionDate,
                  specimenTypeId: specimenTypeId,
                  collectionDateMin: collectionDateMin,
                  collectionHour: collectionHour,
                  collectionMinute: collectionMinute,
                  collectionSecond: collectionSecond,
                  orderItems: [
                    {
                      orderItemSkey: orderItemSkey,
                      orderItemId: orderItemId,
                      orderItemDesc: orderItemDesc,
                      specimenTypeId: specimenTypeId,
                      requireCollectionDate: requireCollectionDate
                    }
                  ]
                })
              }
              return acc
            }, [])
            this.vDataTableAfterCreated.data = reformattedData */
            this.orderSkeyCreateList = [...new Set(res.data.data.map(order => order.order_skey))].join('|')
            this.orderIdCreateList = [...new Set(res.data.data.map(order => order.order_id))].join(',')
            // this.findOrderId = this.orderIdCreateList
            this.dialog.dialogAddOrder = false
          } else {
            this.$swal({type: 'error', title: this.$t('WpLabRequest.createOrderFailed')})
          }
        })
        this.dialog.dialogProgress = false
      }
    },
    async createOrderFromOrder (orderItem) {
      this.dialog.dialogProgress = true
      this.newOrderSkey = ''
      await this.axios.post(process.env.VUE_APP_API + '/createOrderByOrder' + process.env.VUE_APP_DATABASE_TYPE, {
        patient_skey: this.current_patient_skey,
        requestBy: this.requestBy,
        refDoc: this.refDoc,
        cust_skey: this.cust_skey,
        lab_items_code_list: orderItem,
        user_created: localStorage.getItem('username'),
        payment_tpye: this.payment
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.newOrderSkey = res.data.data[0].order_skey
          this.$swal({type: 'success', title: 'สร้างคำสั่งตรวจใหม่สำเร็จ', showConfirmButton: false, timer: 1500})
        }
      })
      this.dialog.dialogProgress = false
    },
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    },
    async checkSendRequestSelected () {
      this.current_order_skey = ''
      this.dialog.dialogProgress = true
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpLabRequest.confirmSendRequest'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.sendRequestSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabRequest.pleaseSelectItemToSend')})
      }
      this.dialog.dialogProgress = false
    },
    async sendRequestSelected () {
      var valOrderSkey = ''
      var popupDateSendNotNull = ''
      var errorLog = this.$t('WpLabRequest.errorSendRequestDateSendNotNull')
      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        if (x.date_send !== null) {
          popupDateSendNotNull = '1'
        }
        if (x.lab_status === 'CA') {
          popupDateSendNotNull = '1'
          errorLog = 'Order ที่ถูก Cancel แล้วไม่สามารถสร้างแพ็คเกจได้'
        } else {
          valOrderSkey = valOrderSkey + '|' + x.order_skey
        }
      })
      if (popupDateSendNotNull === '1') {
        this.$swal({type: 'error', title: errorLog})
      } else {
        this.addSendRequestSelected(valOrderSkey)
        this.vDataTable.selected = []
      }
    },
    async addSendRequestSelected (concatorderskey) {
      if (this.isAddNew === true) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCreatePackageBeforeSend')})
        return
      }
      if (this.current_order_skey !== '' && this.dateReceive !== null) {
        this.$swal({type: 'error', title: 'Order ที่ทำการส่งตรวจแล้ว ไม่สามารถส่งซ้ำได้ กรุณายกเลิกการส่งตรวจเก่าก่อน'})
        return
      }
      if (this.editpatient === false) {
        this.$swal({type: 'error', title: 'กรุณาบันทึกข้อมูลคนไข้ก่อน'})
        return
      }
      if (this.current_lab_status === 'CA') {
        this.$swal({type: 'error', title: 'Order ที่ถูก Cancel แล้วไม่สามารถสร้างแพ็คเกจได้'})
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/addSendRequestSelected' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: concatorderskey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.retrieveLabRequest()
            if (this.current_order_skey !== '') {
              /* this.retrieveFromOrderSkey(this.hn, this.current_order_skey) */
              this.updateLabOrder()
              this.updateLabOrderItemStatus()
              this.retrieveLabOrderAll(this.current_order_skey)
              this.isAddItemDisabled = true
            }
            this.$swal({type: 'success', title: this.$t('WpLabRequest.sendRequestSuccess')})
            this.isDisabled = true
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async checkCancelSendRequestSelected () {
      this.dialog.dialogProgress = true
      this.current_order_skey = ''
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpLabRequest.confirmCancelSendRequest'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.cancelSendRequestSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabRequest.pleaseSelectItemToCancelSend')})
      }
      this.dialog.dialogProgress = false
    },
    async cancelSendRequestSelected () {
      var valPackageNo = ''
      var popupDateSendNotNull = ''
      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        if (x.lab_status === 'CA' || x.lab_status === 'OP' || x.lab_status === 'RECEIVED') {
          popupDateSendNotNull = '1'
        } else {
          valPackageNo = valPackageNo + '|' + x.package_no
        }
      })
      if (popupDateSendNotNull === '1') {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCannotCancelNotSendRequest')})
      } else {
        this.deleteSendRequestSelected(valPackageNo)
        this.vDataTable.selected = []
      }
    },
    async deleteSendRequestSelected (concatPackageNo) {
      if (this.isAddNew === true) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCreatePackageBeforeCancel')})
        return
      }
      if (this.current_order_skey !== '' && this.dateReceive === null) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCannotCancelNotSendRequest')})
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/deleteSendRequestSelected' + process.env.VUE_APP_DATABASE_TYPE, {
        send_package_no: concatPackageNo
      })
        .then(response => {
          if (response.data.data[0].status === 1) {
            this.retrieveLabRequest()
            if (this.current_order_skey !== '') {
              /* this.retrieveFromOrderSkey(this.hn, this.current_order_skey) */
              this.retrieveLabOrderAll(this.current_order_skey)
              this.isAddItemDisabled = false
            }
            this.$swal({type: 'success', title: this.$t('WpLabRequest.cancelSendRequestSuccess')})
          }
          if (response.data.data[0].status === 2) {
            this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCannotCancelSendRequestReceived')})
          }
          if (response.data.data[0].status === 0) {
            this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCannotCancelSendRequest')})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async checkCancelLabSelected () {
      this.dialog.dialogProgress = true
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpLabRequest.confirmCancelLabRequest'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.cancelLabSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabRequest.pleaseSelectItemToCancel')})
      }
      this.dialog.dialogProgress = false
    },
    async cancelLabSelected () {
      var valOrderSkey = ''
      var popupDateSendNotNull = ''
      var errorLog = this.$t('WpLabRequest.errorCannotCancelLabRequestPackageNotNull')
      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        if (x.package_no !== null) {
          popupDateSendNotNull = '1'
        }
        if (x.lab_status === 'CA') {
          popupDateSendNotNull = '1'
          errorLog = this.$t('WpLabRequest.errorCannotCancelLabRequestAlreadyCancelled')
        } else {
          valOrderSkey = valOrderSkey + '|' + x.order_skey
        }
      })
      if (popupDateSendNotNull === '1') {
        this.$swal({type: 'error', title: errorLog})
      } else {
        this.deletelabSelected(valOrderSkey)
        this.vDataTable.selected = []
      }
    },
    async deletelabSelected (concatorderskey) {
      if (this.isAddNew === true) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCreatePackageBeforeCancel')})
        return
      }
      if (this.current_order_skey !== '' && this.dateReceive !== null) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCannotCancelLabRequestPackageNotNull')})
        return
      }
      if (this.current_lab_status === 'CA') {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCannotCancelLabRequestAlreadyCancelled')})
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/deletelabSelected' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: concatorderskey
      })
        .then(response => {
          if (response.data.data[0].status === 1) {
            this.retrieveLabRequest()
            if (this.current_order_skey !== '') {
              /* this.retrieveFromOrderSkey(this.hn, this.current_order_skey) */
              this.retrieveLabOrderAll(this.current_order_skey)
              this.isAddItemDisabled = true
              this.current_lab_status = 'CA'
            }
            this.$swal({type: 'success', title: this.$t('WpLabRequest.cancelSendRequestSuccess')})
          } else {
            this.$swal({type: 'error', title: this.$t('WpLabRequest.errorCannotCancelSendRequestReceived')})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async editOrder (item) {
      this.isAddNew = false
      this.editpatient = true
      this.current_order_id = item.order_id
      this.current_sub_category_skey = item.sub_category_skey
      this.newOrderSkey = ''
      this.current_lab_status = item.lab_status
      this.patient_id = item.patient_id
      if (!item.birthDay) {
        this.ageEditing = true
      }
      if (item.status === 'RL') {
        this.isAddItemDisabled = true
      }
      if (item.status === 'CA') {
        this.isAddItemDisabled = true
      }
      if (item.status === 'OP') {
        this.isAddItemDisabled = false
      }
      /* this.dialog.dialogAddEditWindow = true */
      this.currentMode = 'edit'
      this.dialog.dialogAddRequest = true
      /* await this.retrieveFromOrderSkey(item.hn, item.order_skey) */
      /* await this.retrieveDetailFromOrderID(item.order_id, item.sub_category_skey) */
      await this.retrieveLabOrderAll(item.order_skey)
      if (this.current_order_skey !== '') {
        this.isOrderDisabled = true
      }
    },
    async retrieveLabOrderAll (orderSkey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      try {
        const response = await this.axios.post(process.env.VUE_APP_API + '/OrderEntry/retrieveLabOrderAll', {
          orderSkey: orderSkey
        })
        if (response.data.isSuccess && response.data.data.length > 0) {
          const header = response.data.data[0]
          // --- 1. Mapping Header Data ---
          this.hn = header.hn
          this.prefix = header.prefix
          this.firstName = header.first_name
          this.middleName = header.middle_name
          this.lastName = header.last_name
          this.age = header.age
          this.sex = header.sex
          this.dateBrithday = header.birthday
          this.dateRequestBrithday = header.birthday
          this.current_order_skey = header.order_skey
          this.current_package_no = header.package_no
          this.current_patient_skey = header.patient_skey
          this.requestBy = header.request_by
          this.refDoc = header.ref_doc
          this.dateReceive = header.send_date
          this.dateCollection = header.collection_date
          this.selectedHour = header.collection_hour
          this.selectedMinute = header.collection_minute
          this.selectedSecond = header.collection_second
          this.payment = header.pmt_type
          this.hospital_lab_no = header.hospital_lab_no
          this.idCardText = header.id_card
          this.patientRights = header.patient_rights_cd
          this.status_lab = header.status
          this.cust_skey = header.cust_skey
          // --- 2. Mapping Detail Data (lis_lab_order_detail) ---
          if (header.lis_lab_pricing && header.lis_lab_pricing.length > 0) {
            this.vDataTableLisLabPricing.data = header.lis_lab_pricing
          }
          if (header.lis_lab_specimen_type && header.lis_lab_specimen_type.length > 0) {
            this.vDataTableLisLabSpecimenType.data = header.lis_lab_specimen_type
          }
          if (header.lis_lab_order_detail && header.lis_lab_order_detail.length > 0) {
            this.tempOrderListItem = [] // Clear list เดิมก่อน
            let dataListItemStr = ''
            this.vDataTable2.data = header.lis_lab_order_detail
            header.lis_lab_order_detail.forEach((item, index) => {
              // สร้าง Row สำหรับตาราง
              const newRow = {
                No: index + 1,
                order_item_id: item.order_item_id,
                order_item_desc: item.order_item_desc,
                medium_price: item.medium_price,
                specimen_type_desc: item.specimen_type_desc,
                sub_category_desc: item.sub_category_desc,
                Qty: 1,
                order_item_skey: item.order_item_skey,
                view_skey: item.view_skey,
                volume_urine: item.volume_urine,
                // เก็บข้อมูล probes และ probe_list ไว้ใน row เพื่อใช้งานต่อถ้าจำเป็น
                probes: item.probes || [],
                probe_list: item.probe_list || []
              }
              this.tempOrderListItem.push(newRow)

              // เตรียม String สำหรับ localStorage (เลียนแบบ Logic เดิม)
              const itemStr = `${item.order_item_id}^${item.specimen_type_cd}^`
              dataListItemStr += (index === 0) ? itemStr : `|${itemStr}`
              this.orderSkeyCreateList = orderSkey
            })
            localStorage.setItem('dataListItem', dataListItemStr)
            this.initialize() // เรียกใช้งานฟังก์ชันจัดการ UI หลังโหลดข้อมูล
          }
        } else {
          this.$swal({ type: 'error', title: response.data.reasonText || 'No data found' })
        }
        this.getCustomerInfo()
      } catch (e) {
        console.error(e)
        this.$swal({ type: 'error', title: e.message })
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async retrieveFromOrderSkey (hn, orderSkey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/retrieveFromHN' + process.env.VUE_APP_DATABASE_TYPE, {
        orderSkey: orderSkey,
        hn: hn
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.hn = response.data.data[0].hn
            this.prefix = response.data.data[0].prefix
            this.firstName = response.data.data[0].first_name
            this.middleName = response.data.data[0].middle_name
            this.lastName = response.data.data[0].last_name
            this.age = response.data.data[0].age
            this.sex = response.data.data[0].sex
            this.dateBrithday = response.data.data[0].birthday
            this.dateRequestBrithday = response.data.data[0].birthday
            this.current_order_skey = response.data.data[0].order_skey
            this.current_package_no = response.data.data[0].package_no
            this.current_patient_skey = response.data.data[0].patient_skey
            this.requestBy = response.data.data[0].request_by
            this.refDoc = response.data.data[0].ref_doc
            this.dateReceive = response.data.data[0].send_date
            this.dateCollection = response.data.data[0].collection_date
            this.selectedHour = response.data.data[0].collection_hour
            this.selectedMinute = response.data.data[0].collection_minute
            this.selectedSecond = response.data.data[0].collection_second
            this.payment = response.data.data[0].pmt_type
            this.hospital_lab_no = response.data.data[0].hospital_lab_no
            this.idCardText = response.data.data[0].id_card
            this.patientRights = response.data.data[0].patient_rights_cd
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async retrieveDetailFromOrderID (orderId) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/retrieveDetailFromOrderID' + process.env.VUE_APP_DATABASE_TYPE, {
        order_id: orderId
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable2.data = response.data.data
            for (let index = 0; index < this.vDataTable2.data.length; index++) {
              this.new_row = {
                No: index + 1,
                order_item_id: this.vDataTable2.data[index].order_item_id,
                order_item_desc: this.vDataTable2.data[index].order_item_desc,
                medium_price: this.vDataTable2.data[index].medium_price,
                specimen_type_desc: this.vDataTable2.data[index].specimen_type_desc,
                sub_category_desc: this.vDataTable2.data[index].sub_category_desc,
                Qty: 1,
                order_item_skey: this.vDataTable2.data[index].order_item_skey,
                view_skey: this.vDataTable2.data[index].view_skey,
                volume_urine: this.vDataTable2.data[index].volume_urine
              }
              this.tempOrderListItem.push(this.new_row)
              if (index === 0) {
                localStorage.setItem('dataListItem', this.vDataTable2.data[index].order_item_id + '^' + this.vDataTable2.data[index].specimen_type_cd + '^')
              } else {
                localStorage.setItem('dataListItem', localStorage.getItem('dataListItem') + '|' + this.vDataTable2.data[index].order_item_id + '^' + this.vDataTable2.data[index].specimen_type_cd + '^')
              }
            }
            this.initialize()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    checkDeleteselected () {
      if (this.vDataTable2.selected.length > 0) {
        if (this.status_lab !== 'OP') {
          this.$swal({
            type: 'warning',
            title: this.$t('WpLabRequest.MessageStatusOpenDeleteOrderItem')
          })
          return
        }
        this.$swal({
          text: this.$t('WpLabRequest.confirmDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('กรุณาเลือกรายการที่ต้องการลบ')})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.asyncForEach(this.vDataTable2.selected, async function (x) {
        let index = this.vDataTable2.data.findIndex(row =>
          row.order_item_id === x.order_item_id &&
          row.specimen_type_cd === x.specimen_type_cd
        )
        if (index !== -1) {
          var val = await this.deletefromselected(x, index, this.current_order_skey)
          if (val !== undefined) del.push(val)
        }
      }.bind(this))
      if (this.current_order_skey !== '') {
        /* await this.retrieveDetailFromOrderID(this.current_order_id, this.current_sub_category_skey) */
        await this.retrieveLabOrderAll(this.current_order_skey)
      }
      this.vDataTable2.selected = []
      this.dialog.dialogProgress = false
    },
    updateIsCheck (item, type) {
      this.isChecked = !this.isChecked
      item.is_edit = 1
      if (type === 1) {
        if (item.is_get_back === 0) {
          item.is_get_back = 1
        }
        if (item.is_get_back === 1) {
          item.is_get_back = 0
        }
      }
      if (type === 2) {
        item.is_urgent = item.is_urgent === 0 ? 1 : 0
      }
    },
    async updateTestDetail (orderSkey, orderItemSkey, isGetBack, isUrgent) {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/updateTestDetail' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: orderSkey,
        order_item_skey: orderItemSkey,
        is_get_back: isGetBack,
        is_urgent: isUrgent
      }).then(res => {
      })
      this.dialog.dialogProgress = false
    },
    async updateLabDetail () {
      this.vDataTable2.data = this.vDataTableLabOrderItem.data
      this.updateLabDetailCheck = 0
      this.dialog.dialogProgress = true
      if (this.dateReceive === null) {
        // await this.updateLabOrderItem()
        /* await this.retrieveDetailFromOrderID(this.current_order_id, this.current_sub_category_skey) */
        await this.retrieveLabOrderAll(this.current_order_skey)
      }
      this.$swal({type: 'success', title: 'บันทึกรายการตรวจเรียบร้อย', showConfirmButton: false, timer: 1000})
      this.dialog.dialogProgress = false
    },
    updateUrgent (isMassage) {
      const updatePromises = this.vDataTable2.data
        .filter(item => item.is_edit === 1)
        .map(item => {
          return this.updateTestDetail(this.current_order_skey, item.order_item_skey, item.is_get_back, item.is_urgent)
            .then(() => {
            })
        })
      Promise.all(updatePromises)
        .then(() => {
          if (isMassage === 1) {
            this.$swal({type: 'success', title: 'บันทึกรายการตรวจเรียบร้อย', showConfirmButton: false, timer: 1000})
          }
        })
        .catch(error => {
          console.error('Error updating items:', error)
        })
    },
    updateLabDiagnosis () {
      this.tempOrderListItem
      .filter(item => item.require_diagnosis === 1)
      .forEach(item => {
        this.axios.post(process.env.VUE_APP_API + '/updataDiagnosis' + process.env.VUE_APP_DATABASE_TYPE, {
          order_skey: this.current_order_skey,
          order_item_skey: item.order_item_skey,
          diagnosis: item.diagnosis
        }).then(res => {
        })
      })
    },
    async updateLabOrderItem () {
      await this.axios.post(process.env.VUE_APP_API + '/updateLabOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: this.cust_skey,
        order_skey: this.current_order_skey,
        order_item_id: localStorage.getItem('dataListItem'),
        user: localStorage.getItem('username')
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.updateLabDetailCheck += 1
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
    },
    async updateCustomerLabOrder (orderSkey, custSkey) {
      try {
        const response = await this.axios.post(process.env.VUE_APP_API + '/updateCustomerLabOrderMSSQL',
          {
            order_skey: orderSkey,
            cust_skey: custSkey
          }
        )

        if (response.data.isSuccess === true || response.data.isSuccess === 1) {
          this.$swal({
            icon: 'success',
            title: 'Update Successful'
          })
        } else {
          this.$swal({
            icon: 'error',
            title: response.data.message || response.data.reasonText || 'Update Failed'
          })
        }
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Server Error',
          text: error.response?.data?.reasonText || error.message
        })
      }
    },
    async updatePatientDetail () {
      let check = 0
      const isValid = this.prefixSexListAll.some(
        (combination) =>
          combination.prefix_cd === this.prefix &&
          combination.sex_cd === this.sex
      )
      if (!isValid) {
        // Proceed with sending the data
        this.$swal({type: 'error', title: 'กรุณากรกอกคำนำหน้าและเพศให้ตรงกัน'})
        check += 1
      }
      if (check === 0) {
        await this.axios.post(process.env.VUE_APP_API + '/updatePatientDetail' + process.env.VUE_APP_DATABASE_TYPE, {
          order_skey: this.current_order_skey,
          patient_skey: this.current_patient_skey,
          hn: this.hn,
          prefix: this.prefix,
          first_name: this.firstName,
          middle_name: this.middleName,
          last_name: this.lastName,
          sex: this.sex,
          birthday: this.dateBrithday,
          age: this.age,
          date_receive: this.dateCollection,
          request_by: this.requestBy,
          refDoc: this.refDoc,
          hospital_lab_no: this.hospital_lab_no,
          payment_tpye: this.payment,
          collection_hour: this.selectedHour,
          collection_minute: this.selectedMinute,
          collection_second: this.selectedSecond
        }).then(res => {
          if (res.request.status === 200) {
            /* this.retrieveFromOrderSkey(this.hn, this.current_order_skey) */
            /* this.retrieveLabOrderAll(this.current_order_skey) */
            this.updateLabDetailCheck += 1
            this.editpatient = true
          } else {
            this.$swal({type: 'error', title: this.$t('WpLabRequest.editPatientFailed')})
          }
        })
      }
    },
    calculateTotal (key) {
      /* return this.vDataTable2.data.reduce((total, item) => {
        // Use parseInt to convert string to integer before adding to total
        return total + parseInt(item[key] || 0) // Use || 0 to handle potential empty strings
      }, 0) */
      if (!this.vDataTable2 || !this.vDataTable2.data || this.vDataTable2.data.length === 0) {
        return '0.00'
      }
      const total = this.vDataTable2.data.reduce((sum, item) => {
        const value = parseFloat(item[key])
        return sum + (isNaN(value) ? 0 : value)
      }, 0)
      return total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    close () {
      this.dialog.dialogAddRequest = false
      this.dialog.dialogAddEditWindow = false
      this.editpatient = true
      this.retrieveLabRequest()
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    closeCreated () {
      this.dialog.dialogAddRequest = false
      this.dialog.dialogAddEditWindow = false
      this.editpatient = true
      this.isAddNew = false
      this.retrieveLabRequest()
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
      this.orderIDCreateList = ''
      // this.findOrderId = ''
    },
    closeRequestCreated () {
      if (!this.isCreateSuccess) {
        this.$swal({
          text: this.$t('WpLabRequest.confirmCloseWithoutSave'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.dialog.dialogAddRequest = false
            this.dialog.dialogAddEditWindow = false
            this.editpatient = true
            this.isAddNew = false
          }
        })
      } else {
        const allZero = this.vDataTableAfterCreated.data.every(row => row.requireCollectionDate !== 1)
        if (allZero) {
          this.closeCreated()
        } else {
          this.$swal({type: 'warning', title: this.$t('WpLabRequest.requireCollectDateError')})
        }
      }
    },
    async checkPrintRequestSelected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpLabRequest.confirmPrintRequest'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.printRequestSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabRequest.pleaseSelectItemToPrint')})
      }
    },
    async printRequestSelected () {
      this.progressMessage = this.$t('waiting')
      var del = []
      var valOrderSkey = ''
      var valOrderIDNotSend = ''
      var popupDateSendNotNull = ''

      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        if (x.date_send == null) {
          popupDateSendNotNull = '1'
        } else {
          valOrderSkey = valOrderSkey + ',' + x.order_id
        }
      })
      if (popupDateSendNotNull === '1') {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.printRequestError')})
      } else {
        this.orderIdPtrint = valOrderSkey
        this.requestPDF('S')
      }
    },
    async printReceiptForm (flag) {
      const selectedItems = this.vDataTableAfterCreated.data
      if (!this.current_order_id || this.current_order_id.length < 1) {
        this.$swal({ type: 'error', html: 'Please select items to print.' })
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('Now Printing waiting.......')
      var today = new Date()
      var date = today.getFullYear().toString().substr(-2) + ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1) + (today.getDate() < 10 ? '0' : '') + today.getDate()
      var time = (today.getHours() < 10 ? '0' : '') + today.getHours() + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes() + (today.getSeconds() < 10 ? '0' : '') + today.getSeconds()
      var dateTimeCurr = date + '_' + time
      await this.axios.post(process.env.VUE_APP_REPORT_PATHO + '/GetReceiptReportPdf', {
        val: {
          order_id: this.current_order_id,
          user_print: localStorage.getItem('username')
        }
      })
      .then(async response => {
        if (response.data.success === 'true' && response.data.Table && response.data.Table[0].pdf) {
          const pdfData = response.data.Table[0].pdf

          if (flag === 'D') {
            // ดาวน์โหลดไฟล์
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([Base64Binary.decode(pdfData)], {type: 'application/pdf'}))
            link.setAttribute('download', `${dateTimeCurr}.pdf`)
            link.click()
          } else if (flag === 'S') {
            // พิมพ์ทันที
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(pdfData)], {type: 'application/pdf'}))
            this.pdfShow = url
            this.dialogpdfShow = true
            // รอการจัดการ Print (สมมติว่าฟังก์ชันเหล่านี้รองรับ async)
            /* if (typeof this.autoPrintPdf === 'function') this.autoPrintPdf()
            await this.printToServer(pdfData) */
          }
        } else {
          console.warn(`No data `)
        }
      })
      .catch(async e => {
        this.$swal({type: 'error', title: e.message})
      })
      this.dialog.dialogProgress = false
    },
    // async retrieveLabResultItemDetail (orderSkey) {
    //   await this.axios.post(process.env.VUE_APP_API + '/retrieveLabResultItemDetail' + process.env.VUE_APP_DATABASE_TYPE, {
    //     order_skey: orderSkey
    //   }).then(res => {
    //     if (res.data.isSuccess) {
    //       const uniqueSubcategories = []
    //       const subcategoryMap = new Map()

    //       res.data.data.forEach(item => {
    //         if (!subcategoryMap.has(item.sub_category_skey)) {
    //           uniqueSubcategories.push({
    //             sub_category_skey: item.sub_category_skey,
    //             sub_category_id: item.sub_category_id,      // ✅ อยู่นี่แหละ!
    //             sub_category_desc: item.sub_category_desc,
    //             sub_category_seq: item.sub_category_seq,
    //             report_type_cd: item.report_type_cd,
    //             color: this.intToHexColor(item.color),
    //             test_item_status: item.test_item_status,
    //           })
    //         }
    //       })
    //       this.vDataTableSubcategory.data = uniqueSubcategories

    //       // Store subcategories in vDataSubcategory
    //       uniqueSubcategories.sort((a, b) => a.sub_category_seq - b.sub_category_seq)
    //       this.vDataTableSubcategory.data = uniqueSubcategories
    //     }
    //   })
    //   if (this.activeSubCategorySkey === null) {
    //     await this.onSubcategoryClick(this.vDataTableSubcategory.data[0], false)
    //   } else {
    //     await this.onSubcategoryClick(this.vDataTableSubcategory.data.find(item => item.sub_category_skey === this.activeSubCategorySkey), false)
    //   }
    // },
    async requestLabResultReportPdf (flag, OrderId, subCategorySkey) {
      this.is_open = false
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('Now Printing waiting.......')
      var today = new Date()
      var date = today.getFullYear().toString().substr(-2) + ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1) + (today.getDate() < 10 ? '0' : '') + today.getDate()
      var time = (today.getHours() < 10 ? '0' : '') + today.getHours() + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes() + (today.getSeconds() < 10 ? '0' : '') + today.getSeconds()
      var dateTimeCurr = date + '_' + time
      await this.axios.post(process.env.VUE_APP_REPORT_PATHO + '/GetRequestLabResultReportPdf', {
        val: {
          Order_id: OrderId,
          sub_category_id: null,
          user_print: localStorage.getItem('username'),
          is_approve: '1'
        }
      })
      .then(async response => {
        if (response.data.success === 'true') {
          console.log(response.data.Table[0], 'response.data.Table[0]')
          let decodedPdf = Base64Binary.decode(response.data.Table[0].pdf)
          let encryptedPdfBytes
          if (flag === 'D') {
            // Add password protection
            // const pdfDoc = await PDFDocument.load(decodedPdf)
            // pdfDoc.encrypt({
            //   userPassword: 'user_password', // Replace with your user password
            //   ownerPassword: 'owner_password', // Replace with your owner password
            //   permissions: {
            //     printing: 'lowResolution', // or 'highResolution'
            //     modifying: false,
            //     copying: false,
            //     annotating: false,
            //     fillingForms: false,
            //     contentAccessibility: false,
            //     documentAssembly: false,
            //   }
            // })
            // encryptedPdfBytes = await pdfDoc.save()
            this.dialog.dialogPassword = true
          } else {
            encryptedPdfBytes = decodedPdf
          }
          const encryptedBlob = new Blob([encryptedPdfBytes], { type: 'application/pdf; charset=utf-8' })
          const encryptedUrl = window.URL.createObjectURL(encryptedBlob)
          if (flag === 'D') {
            const link = document.createElement('a')
            link.href = encryptedUrl
            link.setAttribute('download', `${dateTimeCurr}.pdf`)
            link.click()
          } else if (flag === 'S') {
            this.dialogpdfShow = true
            this.pdfShow = encryptedUrl
            this.isApproved = false
          }
        } else {
          if (response.data.message === 'return row from proc 0') {
            this.$swal({type: 'warning', title: 'No Data.'})
          } else {
            this.$swal({type: 'error', title: response.data.message})
          }
        }
      })
      .catch(async e => {
        this.$swal({type: 'error', title: e.message})
      })
      this.dialog.dialogProgress = false
    },
    async printRequest () {
      if (this.dateReceive == null) {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.printRequestError')})
      } else {
        this.orderIdPtrint = this.current_order_id
        this.requestPDF('S')
      }
    },
    async requestPDF (flag) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('Now Printing waiting.......')
      var today = new Date()
      var date = today.getFullYear().toString().substr(-2) + ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1) + (today.getDate() < 10 ? '0' : '') + today.getDate()
      var time = (today.getHours() < 10 ? '0' : '') + today.getHours() + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes() + (today.getSeconds() < 10 ? '0' : '') + today.getSeconds()
      var dateTimeCurr = date + '_' + time
      await this.axios.post(process.env.VUE_APP_REPORT_PATHO + '/GetRequestReportPdf', {
        val: {
          order_id: this.orderIdPtrint,
          user_print: localStorage.getItem('username')
        }
      })
      .then(async response => {
        if (response.data.success === 'true') {
          if (flag === 'D') {
            let soMany = 10
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            link.setAttribute('download', `${dateTimeCurr}.pdf`)
            link.click()
          } else if (flag === 'S') {
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            this.dialogpdfShow = true
            this.pdfShow = url
          }
        } else {
          if (response.data.message === 'return row from proc 0') {
            this.$swal({type: 'warning', title: 'No Data.'})
          } else {
            this.$swal({type: 'error', title: response.data.message})
          }
        }
      })
      .catch(async e => {
        this.$swal({type: 'error', title: e.message})
      })
      this.dialog.dialogProgress = false
    },
    async checkPrintPackageSelected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpLabRequest.confirmPrintPackage'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.printPackageSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabRequest.pleaseSelectItemToPrintPackage')})
      }
    },
    async printPackageSelected () {
      this.progressMessage = this.$t('waiting')
      var del = []
      var valPackageNo = ''
      var popupDateSendNotNull = ''

      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        if (x.package_no === '') {
          popupDateSendNotNull = '1'
        } else {
          valPackageNo = valPackageNo + ',' + x.package_no
        }
      })
      if (popupDateSendNotNull === '1') {
        this.$swal({type: 'error', title: this.$t('WpLabRequest.printPackageError')})
      } else {
        this.orderIdPtrint = valPackageNo
        this.packagePDF('S')
      }
    },
    async packagePDF (flag) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('Now Printing waiting.......')
      var today = new Date()
      var date = today.getFullYear().toString().substr(-2) + ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1) + (today.getDate() < 10 ? '0' : '') + today.getDate()
      var time = (today.getHours() < 10 ? '0' : '') + today.getHours() + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes() + (today.getSeconds() < 10 ? '0' : '') + today.getSeconds()
      var dateTimeCurr = date + '_' + time
      await this.axios.post(process.env.VUE_APP_REPORT_PATHO + '/GetRequestPackagingReportPdf', {
        val: {
          package_list: this.orderIdPtrint,
          user_print: localStorage.getItem('username')
        }
      })
      .then(async response => {
        if (response.data.success === 'true') {
          if (flag === 'D') {
            let soMany = 10
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            link.setAttribute('download', `${dateTimeCurr}.pdf`)
            link.click()
          } else if (flag === 'S') {
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            this.dialogpdfShow = true
            this.pdfShow = url
          }
        } else {
          if (response.data.message === 'return row from proc 0') {
            this.$swal({type: 'warning', title: 'No Data.'})
          } else {
            this.$swal({type: 'error', title: response.data.message})
          }
        }
      })
      .catch(async e => {
        this.$swal({type: 'error', title: e.message})
      })
      this.dialog.dialogProgress = false
    },
    closeDialogpdfShow () {
      this.dialogpdfShow = false
    },
    clickPreviewImage (orderItemSkey) {
      this.axios.get(process.env.VUE_APP_API + '/order_item_file/' + orderItemSkey
      ).then(res => {
        window.open(res.config.url, '_blank')
      }).catch(_error => {
        this.$swal({type: 'error', title: 'ไม่พบไฟล์'})
      })
    },
    viewItem (item) {
      this.dialog.dialogViewItem = true
      this.viewOrderItemID = item.order_item_id
      this.viewOrderItemDesc = item.order_item_desc
      this.viewSubcategory = item.sub_category_desc
    },
    closeViewitem () {
      this.dialog.dialogViewItem = false
    },
    convertToThaiDate (date) {
      let [year, month, day] = date.split('-')
      year = parseInt(year) + 543
      return `${day}-${month}-${year}`
    },
    formatDateTimeDisplay (date) {
      if (!date) return ''
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear() + 543
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
    },
    getVarReturn (value) {
      switch (value.childSend) {
        case 'CustomerBrowse':
          this.dialog.dialogBrowseCustomer = false
          switch (value.actionReturn) {
            case 'OK':
              for (let data of value.dataSelected) {
                this.cust_no = data.cust_no
                this.cust_name = data.cust_name
                this.cust_skey = data.cust_skey
                this.getPayment()
              }
          }
          break
      }
    },
    getCustomerInfo () {
      this.axios.post(process.env.VUE_APP_API + '/browse/retrieveCustomer' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: parseInt(this.cust_skey) || null
      })
        .then(response => {
          this.cust_name = response.data.data[0].cust_name
          this.cust_no = response.data.data[0].cust_no
          this.cust_skey = response.data.data[0].cust_skey
          if (response.data.isSuccess && response.data.data.length > 0) {
            const item = response.data.data[0]
            this.customer.customerNumber = item.cust_no
            this.customer.custSkey = item.cust_skey
            this.customer.customerName = item.cust_name
            this.customer.address1 = item.street_1
            this.customer.address2 = item.street_2
            this.customer.address3 = item.street_3
            this.customer.address4 = item.street_4
            this.customer.city = item.city
            this.customer.state = item.state
            this.customer.country = item.country_skey
            this.customer.zip = item.zip_postal_code
            this.customer.phoneNumber = item.local_phone
            this.customer.faxNumber = item.fax_number
            this.customer.customerType = item.customer_type_skey
            this.customer.holdCode = item.hold_code
            this.customer.marketSegment = item.mrkt_segment
            this.customer.marketChannel = item.mrkt_channel
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    openBrowseCustomer () {
      if (!this.cust_name || !this.cust_name.trim()) {
        this.$swal({
          type: 'warning',
          title: this.$t('WpLabRequest.PleaseEnterCustomerName')
        })
        return
      }

      this.dialog.dialogBrowseCustomer = true
      this.$refs.customerBrowse.retrieveCustomer(this.cust_name)
    },
    clearCustomer () {
      this.cust_skey = null
      this.cust_no = null
      this.cust_name = ''
    },
    newCustomer () {
      this.resetCustomerForm()
      this.customerFormMode = 'new'
      this.dialog.dialogCustomerForm = true
    },
    viewCustomerInfo () {
      this.resetCustomerForm()
      this.getCustomerInfo()
      this.customerFormMode = 'view'
      this.dialog.dialogCustomerForm = true
    },
    copyPatientToCustomer () {
      // trim กันช่องว่าง
      const prefix = this.prefix
      const firstName = (this.firstName || '').trim()
      const lastName = (this.lastName || '').trim()

      // ===== VALIDATION =====
      if (!prefix || !firstName || !lastName) {
        this.$swal({
          type: 'warning',
          title: this.$t('WpLabRequest.PleaseEnterPrefixFirstNameAndLastName')
        })
        return
      }
      const customerName = this.buildCustomerName()
      this.customer.customerName = customerName
      this.customer.TaxIDNumber = this.idCardText
      this.dialog.dialogCustomerForm = true
      // ===== ดึงและแยกที่อยู่จากบัตรประชาชน =====
      let address = this.idCard.address || this.customer.address1
      if (address && address.trim()) {
        this.customer.address1 = address.trim()
        // Map จังหวัดใส่ dropdown state (ตรวจสอบ keyword และหา skey จาก filteredStates)
        const provinceKeywords = ['จังหวัด', 'กรุงเทพมหานคร', 'กทม', 'กรุงเทพฯ']
        let province = ''
        for (let keyword of provinceKeywords) {
          if (address.includes(keyword)) {
            const parts = address.split(keyword)
            if (parts.length > 1) {
              province = parts[1].trim()
              // ลบคำนำหน้า เช่น "กรุงเทพมหานคร" -> "กรุงเทพมหานคร"
              if (keyword === 'จังหวัด') {
                province = province.replace(/^กรุงเทพมหานคร$/, 'กรุงเทพมหานคร') // ปรับกรณีพิเศษถ้าต้องการ
              }
              break
            }
          }
        }
        // หา state_province_skey จาก filteredStates (dropdown จังหวัด)
        if (province) {
          const foundState = this.filteredStates.find(state => state.name.trim() === province.trim())
          if (foundState) {
            this.customer.state = foundState.state_province_skey
          } else {
            this.customer.state = '' // ถ้าไม่พบ ให้ว่าง
          }
        }
        // ตั้งค่า address2-4 เป็นค่าว่าง
        this.customer.address2 = ''
        this.customer.address3 = ''
        this.customer.address4 = ''
      } else {
        // ถ้าไม่มีที่อยู่ ให้ตั้งค่าเป็นว่างและแสดง warning
        this.customer.address1 = ''
        this.customer.address2 = ''
        this.customer.address3 = ''
        this.customer.address4 = ''
        this.customer.state = ''
      }
    },
    async saveCustomer () {
      if (!this.customer.customerName || this.customer.customerName.trim() === '') {
        this.$swal({
          type: 'warning',
          title: 'กรุณากรอกข้อมูล',
          text: 'โปรดระบุชื่อลูกค้า (Customer Name)',
        })
        return
      }

      // ตรวจสอบ Payment Terms (pmt_terms)
      if (!this.customer.payTerms) {
        this.$swal({
          type: 'warning',
          title: 'กรุณากรอกข้อมูล',
          text: 'โปรดเลือกเงื่อนไขการชำระเงิน (Payment Terms)',
        })
        return
      }
      this.dialog.dialogProgress = true

      try {
        const response = await this.axios.post(
          process.env.VUE_APP_API + '/createCustomer' + process.env.VUE_APP_DATABASE_TYPE,
          this.customer
        )

        if (response.data.isSuccess === true) {
          // ดึงค่าที่ได้จาก SELECT ใน Store Procedure (ตัวแรกของ list)
          const result = response.data.data[0]

          // บันทึกค่าลงตัวแปรตามที่ต้องการ
          this.cust_skey = result.cust_skey
          this.cust_no = result.cust_no
          this.cust_name = result.customer_name
          this.payment = result.pmt_type

          this.$swal({
            type: 'success',
            title: 'สำเร็จ',
            text: 'บันทึกข้อมูลลูกค้าเรียบร้อยแล้ว',
            timer: 2000
          })

          this.closeDialog()
        } else {
          throw new Error(response.data.reasonText || 'บันทึกไม่สำเร็จ')
        }
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: error.message
        })
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    closeDialog () {
      this.dialog.dialogCustomerForm = false
    },
    getPrefixDesc () {
      const found = this.prefixList.find(
        p => p.prefix_cd === this.prefix
      )
      return found ? found.prefix_desc : ''
    },
    buildCustomerName () {
      const prefixDesc = this.getPrefixDesc()
      const firstName = (this.firstName || '').trim()
      const lastName = (this.lastName || '').trim()
      return `${prefixDesc}${prefixDesc ? ' ' : ''}${firstName} ${lastName}`.trim()
    },
    decodeThai (bytes) {
      if (!bytes || typeof bytes === 'string') return bytes
      const decoder = new TextDecoder('windows-874')
      return decoder.decode(new Uint8Array(bytes)).replace(/#/g, ' ').trim()
    },
    async getSmartCardConfig () {
      try {
        const response = await this.axios.post(
          process.env.VUE_APP_API + '/getGlobalParamMSSQL',
          { global_key: 'MW_ENDPOINT_VUE_APP_SMARTCARD' }
        )
        if (response.data.isSuccess) {
          return response.data.value // คืนค่า URL กลับมา
        } else {
          console.error('Failed to get SmartCard URL:', response.data.reason)
          return process.env.VUE_APP_SMARTCARD // fallback ไปใช้ .env ถ้า API ล้มเหลว
        }
      } catch (error) {
        console.error('Error fetching SmartCard config:', error)
        return process.env.VUE_APP_SMARTCARD // fallback
      }
    },
    // ฟังก์ชันอ่านบัตรจาก Python Agent
    async onReadIDCard () {
      this.loading.readCard = true
      try {
        // ดึง URL จาก API ก่อน
        const smartCardUrl = await this.getSmartCardConfig()
        // ยิง request ไปยัง URL ที่ได้จาก API
        const response = await this.axios.get(`${smartCardUrl}/read`)
        if (response.data.status === 'success') {
          const result = response.data
          const cardData = result.data
          // ตรวจสอบว่าต้อง Decode หรือไม่
          if (result.is_decoded) {
            this.idCard = cardData
          } else {
            this.idCard = {
              cid: cardData.cid,
              name: this.decodeThai(cardData.name),
              prefix: this.decodeThai(cardData.prefix),
              firstname: this.decodeThai(cardData.firstname),
              lastname: this.decodeThai(cardData.lastname),
              gender: cardData.gender,
              birth_date: cardData.birth_date,
              age: cardData.age,
              address: this.decodeThai(cardData.address),
              image: cardData.image
            }
          }
          this.$swal({
            type: 'success',
            title: 'อ่านข้อมูลสำเร็จ',
            timer: 1500,
            showConfirmButton: false
          })
        } else {
          this.$swal({
            type: 'warning',
            title: 'ไม่สามารถอ่านบัตรได้',
            text: response.data.message || 'กรุณาตรวจสอบการเสียบบัตรประชาชน'
          })
        }
      } catch (error) {
        console.error('Error:', error)
        this.$swal({
          type: 'error',
          title: 'การเชื่อมต่อผิดพลาด',
          text: 'ไม่สามารถติดต่อเครื่องอ่านบัตรได้ กรุณาเปิดโปรแกรม Agent'
        })
      } finally {
        this.loading.readCard = false
      }
    },
    saveIDCardData () {
      // ตัวอย่างการส่งข้อมูลไป Back-end หลักของคุณ
      if (!this.idCard.cid) {
        return this.$swal({ type: 'warning', title: 'กรุณาอ่านข้อมูลบัตรก่อนบันทึก' })
      }
      this.firstName = this.idCard.firstname
      this.lastName = this.idCard.lastname
      this.age = this.idCard.age
      this.dateRequestBrithday = this.idCard.birth_date
      this.idCardText = this.idCard.cid
      this.customer.address1 = this.idCard.address
      const matchedPrefix = this.prefixList.find(item =>
        item.prefix_desc.trim() === this.idCard.prefix.trim()
      )
      const matchedGender = this.sexListAll.find(item =>
        item.sex_desc.trim() === this.idCard.gender.trim()
      )
      if (matchedGender) {
        this.sex = matchedGender.sex_cd
      }
      if (matchedPrefix) {
        // ถ้าเจอ ให้ใส่ค่า prefix_cd ลงใน v-model
        this.prefix = matchedPrefix.prefix_cd
      } else {
        // ถ้าไม่เจอ (เช่น ในบัตรเป็นยศพิเศษ) อาจจะตั้งค่าว่างไว้เพื่อให้ผู้ใช้เลือกเอง
        console.warn('ไม่พบคำนำหน้าที่ตรงกันในระบบ:', this.idCard.prefix)
      }
      this.criteria.firstname = this.idCard.firstname
      this.criteria.lastname = this.idCard.lastname
      this.findPatient()
      this.closeAndClearDialog()
      /* this.axios.post(process.env.VUE_APP_API + '/save_customer_id', this.idCard)
        .then(res => {
          this.$swal({ type: 'success', title: 'บันทึกข้อมูลเรียบร้อย' })
          this.dialog.dialogIDCard = false
        })
        .catch(err => {
          console.error(err) // เพิ่มบรรทัดนี้เพื่อใช้งานตัวแปร err
          this.$swal({ type: 'error', title: 'บันทึกไม่สำเร็จ' })
        }) */
    },
    clearIDCardData () {
      this.idCard = {
        cid: '',
        prefix: '',
        firstname: '',
        lastname: '',
        name: '',
        gender: '',
        birth_date: '',
        age: '',
        address: '',
        image: ''
      }
    },
    closeAndClearDialog () {
      // this.clearIDCardData()
      this.dialog.dialogIDCard = false
    },
    getPatientRights () {
      this.axios.post(process.env.VUE_APP_API + '/getPatientRights', {
      })
        .then(response => {
          this.patientRightsList = response.data
          this.patientRights = response.data[0].default_patient_rights
          this.patientRightsDefault = ''
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    retrieveDropDown () {
      this.axios.post(process.env.VUE_APP_API + '/OrderEntry/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.dropDownData = response.data.data[0]
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async createCustomer () {
      // เปิด loading progress
      this.dialog.dialogProgress = true

      try {
        // เรียก API ตามเส้นที่เราเพิ่งสร้างใน Python
        const response = await this.axios.post(
          process.env.VUE_APP_API + '/createCustomer' + process.env.VUE_APP_DATABASE_TYPE,
          this.customer // ส่งก้อน data customer ทั้งหมดไป
        )
        const res = response.data

        if (res.isSuccess === true) {
          // 1. ดึงข้อมูลจากก้อน data (ตัวแรกของ list)
          const result = res.data[0]

          // 2. Set ค่าให้ตัวแปรตามที่คุณต้องการ
          this.cust_skey = result.cust_skey
          this.cust_no = result.cust_no
          this.cust_name = result.customer_name
          this.getPayment()
          // 3. (Optional) อัปเดตกลับเข้าไปใน object customer ด้วย
          this.customer.custSkey = result.cust_skey
          this.customer.customerNumber = result.cust_no

          this.$swal({
            type: 'success',
            title: 'บันทึกข้อมูลลูกค้าสำเร็จ',
            text: `Customer No: ${result.cust_no}`,
            showConfirmButton: true
          })
        } else {
          this.$swal({
            type: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: res.reasonText || 'ไม่สามารถบันทึกข้อมูลได้'
          })
        }
      } catch (error) {
        console.error(error)
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'ไม่สามารถติดต่อ Server ได้'
        })
      } finally {
        // ปิด loading ไม่ว่าจะสำเร็จหรือไม่ก็ตาม
        this.dialog.dialogProgress = false
      }
    },
    /* async printSpecimenSticker (flag) {
      this.tab = 'specimen-type'
      const selectedItems = this.vDataTableLisLabSpecimenType.selected
      if (!selectedItems || selectedItems.length < 1) {
        this.$swal({ type: 'error', html: 'Please select items to print.' })
        return
      }
      if (!selectedItems || selectedItems.length < 1) {
        this.tab = 'specimen-type'
        this.$swal({
          type: 'info',
          title: 'Selection Required',
          text: 'Please select at least one item from the Specimen Type tab.'
        })
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('Now Printing waiting.......')
      // เตรียมค่าวันเวลาสำหรับชื่อไฟล์
      const today = new Date()
      const date = today.getFullYear().toString().substr(-2) +
                  ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1) +
                  (today.getDate() < 10 ? '0' : '') + today.getDate()
      const time = (today.getHours() < 10 ? '0' : '') + today.getHours() +
                  (today.getMinutes() < 10 ? '0' : '') + today.getMinutes() +
                  (today.getSeconds() < 10 ? '0' : '') + today.getSeconds()
      const dateTimeCurr = date + '_' + time
      try {
        // 2. เริ่มวนลูปรายการที่ถูกเลือก
        for (const item of selectedItems) {
          // อัปเดตข้อความบน Loading ให้รู้ว่ากำลังพิมพ์รายการไหน
          this.progressMessage = `Printing Specimen: ${item.specimen_type_id}...`

          const response = await this.axios.post(process.env.VUE_APP_REPORT_PATHO + '/GetSpecimenBarcodeReportPdf', {
            val: {
              specimen_type_id: item.specimen_type_id, // ใช้ชื่อตัวแปรที่ตรงกับ Header คือ specimen_type_id
            }
          })
          if (response.data.success === 'true' && response.data.Table && response.data.Table[0].pdf) {
            const pdfData = response.data.Table[0].pdf

            if (flag === 'D') {
              // ดาวน์โหลดไฟล์
              const link = document.createElement('a')
              link.href = window.URL.createObjectURL(new Blob([Base64Binary.decode(pdfData)], {type: 'application/pdf'}))
              link.setAttribute('download', `${item.specimen_type_id}_${dateTimeCurr}.pdf`)
              link.click()
            } else if (flag === 'S') {
              // พิมพ์ทันที
              const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(pdfData)], {type: 'application/pdf'}))
              this.pdfShow = url
              this.dialogpdfShow = true
            }
          } else {
            console.warn(`No data for Specimen ID: ${item.specimenTypeId}`)
          }
        }
      } catch (e) {
        this.$swal({ type: 'error', title: e.message })
      } finally {
        this.dialog.dialogProgress = false
      }
    } */
    async callGetStickerBarcode (orderSkey) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = 'Processing...'

        const response = await this.axios.post(
          process.env.VUE_APP_API + '/GetStickerBarcode',
          {
            order_skey: orderSkey,
            gateway_flag: '1'
          }
        )
        if (response.data && response.data.isSuccess) {
          this.$swal({
            type: 'success',
            html: 'Update gateway flag success.'
          })
        } else {
          this.$swal({
            type: 'error',
            html: response.data.message || 'Something went wrong'
          })
        }
      } catch (e) {
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    onRowEdited (item) {
      item.edit_flag = 1 // เปลี่ยน flag เป็น 1 เมื่อมีการแก้ไข
      /* this.updateCalculatedTotal(item) */
    },

    // เมื่อแก้ที่ %: ให้คำนวณยอดเงินส่วนลดใหม่
    onDiscountPctChanged (item) {
      const price = parseFloat(item.price) || 0
      const qty = parseFloat(item.qty) || 0
      const pct = parseFloat(item.disc_pct) || 0
      item.disc_amount = (price * qty) * (pct / 100)
      this.onRowEdited(item)
    },
    onDiscountAmountChanged (item) {
      const price = parseFloat(item.price) || 0
      const qty = parseFloat(item.qty) || 0
      const amount = parseFloat(item.disc_amount) || 0
      const totalBeforeDisc = price * qty
      if (totalBeforeDisc > 0) {
        item.disc_pct = (amount / totalBeforeDisc) * 100
      }
      this.onRowEdited(item)
    },
    calculateGrandTotal () {
      return this.vDataTableLisLabPricing.data.reduce((acc, item) => {
        const rowTotal = this.calculateRowTotal(item) || 0
        return acc + rowTotal
      }, 0)
    },
    calculateRowTotal (item) {
      const price = parseFloat(item.price) || 0
      const qty = parseFloat(item.qty) || 0
      const discAmount = parseFloat(item.disc_amount) || 0
      const total = (price * qty) - discAmount
      // เก็บค่าลงใน item เพื่อให้เวลานำไปใช้งานต่อมีค่าที่ถูกต้อง
      item.total_amount = total
      return total
    },
    async updateLabOrder () {
      console.log(this.vDataTableLisLabPricing.data, 'vDataTableLisLabPricing.data')
      const hasEdit = this.vDataTableLisLabPricing.data.some(item => item.edit_flag === 1)
      if (!hasEdit) {
        console.log('ไม่มีการเปลี่ยนแปลงข้อมูลราคา')
        return
      }

      const hasInvalidPrice = this.vDataTableLisLabPricing.data.some(item => {
        const price = parseFloat(item.price) || 0
        const qty = parseFloat(item.qty) || 0
        return price <= 0 || qty <= 0
      })

      if (hasInvalidPrice) {
        this.$swal({
          type: 'error',
          title: 'ข้อมูลราคาไม่ถูกต้อง',
          text: 'ราคาและจำนวนต้องมากกว่า 0 และไม่ติดลบ'
        })
        this.dialog.dialogProgress = false
        throw new Error('Invalid Price or Quantity')
      }
      try {
        const res = await this.axios.post(process.env.VUE_APP_API + '/updateLabOrder' + process.env.VUE_APP_DATABASE_TYPE, {
          order_skey: this.current_order_skey,
          pricing_data: this.vDataTableLisLabPricing.data,
          user: localStorage.getItem('username')
        })
        if (res.status !== 200 || (res.data && res.data.isSuccess === false)) {
          this.$swal({
            type: 'error',
            title: 'บันทึกราคาไม่สำเร็จ',
            text: res.data.reasonText || 'Network Error'
          })
          throw new Error('Update Lab Order API Failed')
        }
        console.log('Update Lab Order Success')
        // ไม่ต้องเรียก retrieveLabOrderAll ที่นี่แล้ว เพราะเราจะเรียกครั้งเดียวที่ฟังก์ชันหลัก
      } catch (error) {
        console.error('API Error:', error)
        // ถ้าเกิด Error จาก Axios (เช่น 404, 500) ให้ throw ต่อไปที่ savePatientButton
        if (!error.message.includes('Invalid')) {
          this.$swal({ type: 'error', title: 'เกิดข้อผิดพลาดในการเชื่อมต่อ' })
        }
        throw error
      }
    },
    async updateLabOrderItemStatus () {
      const hasEdit = this.vDataTable2.data.some(item => item.edit_flag === 1)
      if (!hasEdit) {
        console.log('ไม่มีการเปลี่ยนแปลง LabOrderItem')
        return
      }
      try {
        const res = await this.axios.post(process.env.VUE_APP_API + '/updateLabOrderItemStatus' + process.env.VUE_APP_DATABASE_TYPE, {
          order_skey: this.current_order_skey,
          order_item_data: this.vDataTable2.data,
          user: localStorage.getItem('username')
        })
        if (res.status !== 200 || (res.data && res.data.isSuccess === false)) {
          this.$swal({
            type: 'error',
            title: 'Save Order Item Fail',
            text: res.data.reasonText || 'Network Error'
          })
          throw new Error('Update Lab Order API Failed')
        }
        // ไม่ต้องเรียก retrieveLabOrderAll ที่นี่แล้ว เพราะเราจะเรียกครั้งเดียวที่ฟังก์ชันหลัก
      } catch (error) {
        console.error('API Error:', error)
        // ถ้าเกิด Error จาก Axios (เช่น 404, 500) ให้ throw ต่อไปที่ savePatientButton
        if (!error.message.includes('Invalid')) {
          this.$swal({ type: 'error', title: 'เกิดข้อผิดพลาดในการเชื่อมต่อ' })
        }
        throw error
      }
    },
    openNoteDialog (item) {
      this.activeRowItem = item
      this.itemOrderItemNote = item.note || ''
      this.dialog.dialogOrderItemNote = true
    },
    saveOrderItemNote () {
      if (this.activeRowItem) {
        // ตรวจสอบว่ามีการแก้ไขจริงไหม
        if (this.activeRowItem.note !== this.itemOrderItemNote) {
          this.activeRowItem.note = this.itemOrderItemNote
          this.onRowEdited(this.activeRowItem)
        }
      }
      this.closeOrderItemNote()
    },

    // 3. ฟังก์ชันปิด Dialog
    closeOrderItemNote () {
      this.dialog.dialogOrderItemNote = false
      this.activeRowItem = null
      this.itemOrderItemNote = ''
    },
    resetCustomerForm () {
      this.customer = {
        customerNumber: '',
        custSkey: '',
        customerName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        city: '',
        state: '',
        country: 96,
        zip: '',
        phoneCode: '',
        phoneArea: '',
        phoneNumber: '',
        phoneExt: '',
        faxCode: '',
        faxArea: '',
        faxNumber: '',
        TaxIDNumber: '',
        status: 'Active',
        holdCode: '',
        customerType: 16,
        bankRemit: '',
        payTerms: '30D',
        arRep: '',
        freightCode: '',
        incomeCode: 'Direct Sale',
        invoiceType: 'Detail Invoice',
        paymentType: 'TRN',
        freeOnBoard: '',
        marketSegment: '',
        marketChannel: 'Major',
        authorizeCardCredits: '',
        alias: 'GEN'
      }
    }
  },
}
</script>
<style scoped>

.custom-border >>> .v-input__control {
  border-color: #d3d3d3 !important;
}
.v-data-table thead th, 
.v-data-table tbody td {
  border: 1px solid rgba(221, 221, 221, 0.932) ;
}

.v-data-table thead {
  border-bottom: 2px solid rgba(0, 0, 0, 0.521) ;
}

.v-data-table tbody tr {
  border-bottom: 1px solid #ddd ;
}

.style-1 {
  color: rgb(215, 44, 44);
}
.style-2 {
  color: rgb(114,114,67);
}
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
.input__label {
  color: rgb(54, 54, 54);
}
.my-text-style >>> .v-text-field__slot input {
  background: rgb(255, 206, 215);
}
.my-select-style >>> .v-text-field__slot select {
  background: rgb(255, 206, 215);
}
a { text-decoration: none; }
.tab-with-footer {
  position: relative;
}
.container {
  overflow: hidden;
}
.text-error {
  color: red;
}
.order-item-list-table tr:hover {
  background-color: #2170BB !important; 
  color: #ffffff !important; 
}

/* .v-text-field.v-input--dense {
  font-weight: bold;
} */

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  font-weight: normal !important; /* Ensures label is not bold */
}

/* Optional: Adjust text color for hover effect */
.order-item-list-table tbody tr:hover td {
  color: white; /* Optional: Ensure text is readable */
}
 /* ขนาดหน้าจอ Tablet */
   @media screen and (min-width: 768px) and (max-width: 991px) {
    .icon-noti {
      size: 29;
    } 
  
  }
  /* ขนาดหน้าจอ Smartphone แนวนอน */
  @media screen and (min-width: 576px) and (max-width: 767px) {
  }
  /* ขนาดหน้าจอ Smartphone แนวตั้ง */
  @media screen and (max-width: 575px) {
  }
  .label-header {
    background-color: #0073BE;   /* สีพื้นหลังที่ต้องการ */
    color: white;                /* สีตัวอักษร */
    padding: 6px 12px;           /* เพิ่มช่องว่างรอบข้อความ */
    border-radius: 8px;          /* ขอบมน */
    text-align: center;          /* กึ่งกลาง */
    margin-bottom: 8px;          /* เว้นระยะจาก v-card */
    font-weight: 500;            /* ตัวหนาเล็กน้อย */
    font-size: 14px;             /* ขนาดตัวอักษรปรับตามต้องการ */
  }
  .no-bg::before {
    display: none !important; /* ปิด ripple */
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .text-xs {
    font-size: 12px;
  }
  /* สไตล์พื้นฐานของ Tab (รวมจากของเดิมและเพิ่มใหม่) */
  .v-tab {
    text-transform: none !important; /* ของเดิม */
    font-weight: 500;               /* ของเดิม */
    letter-spacing: 0.5px;          /* ของเดิม */
    font-size: 0.875rem;            /* ของเดิม */
    min-width: 120px;               /* ของเดิม */
    transition: 0.3s;               /* ของเดิม */
    
    /* เพิ่มเติม: Background บางๆ และเส้นคั่น */
    border: 1px solid #e0e0e0 !important; /* สีกรอบเทาอ่อน */
    border-bottom: none !important;        /* เอาเส้นขอบล่างออกเพื่อให้เชื่อมกับ slider */
    border-radius: 4px 4px 0 0;            /* ทำมุมโค้งมนเฉพาะด้านบน */
    margin-right: 4px;                     /* เว้นระยะห่างระหว่างกรอบของแต่ละ Tab */
    background-color: #f8f9fa !important;  /* พื้นหลัง Tab ที่ยังไม่เลือก */
  }

  /* เมื่อ Hover (ของเดิมปรับให้ชัดขึ้น) */
  .v-tab:hover {
    background-color: rgba(25, 118, 210, 0.05) !important; /* สี Primary จางๆ */
  }

  /* เมื่อ Tab ถูกเลือก (Active) */
  .v-tab--active {
    font-weight: 600;                /* ของเดิม */
    background-color: #ffffff !important; /* พื้นหลังขาวล้วนตอนเลือก */
    color: #1976d2 !important;       /* สี Primary */
  }

  /* ปรับระยะ Icon ใน Tab */
  .v-tab .v-icon {
    font-size: 18px !important;      /* ขนาดพอดีๆ ไม่ใหญ่เกินไป */
    margin-right: 6px;               /* ระยะห่างจากตัวหนังสือ */
  }

  /* สไตล์อื่นๆ ของเดิม */
  .v-tabs-items {
    background-color: transparent !important;
  }

  .v-data-table >>> .v-data-footer {
    border-top: 1px solid #e0e0e0 !important;
    margin-top: 0px !important;
  }
  /* ปรับแต่ง Background ของ Tab ทั้งหมดที่ยังไม่เลือก */
  .custom-tab-item {
    background-color: rgba(0, 0, 0, 0.03); /* สีเทาบางๆ */
    border-right: 1px solid #e0e0e0;      /* เส้นคั่นระหว่าง Tab */
    transition: 0.3s;
  }

  /* เมื่อ Hover ให้สีเข้มขึ้นนิดหน่อย */
  .custom-tab-item:hover {
    background-color: rgba(0, 0, 0, 0.07);
  }

  /* สไตล์สำหรับ Tab ที่ถูกเลือก (Active) */
  .active-tab-style {
    background-color: white !important; /* พื้นหลังสีขาวให้ดูสะอาดตา */
    color: #1976d2 !important;          /* สี Primary */
  }

  /* ลบเส้นขอบอันสุดท้าย */
  .custom-tab-item:last-of-type {
    border-right: none;
  }
  .custom-tabs-container {
    border: 1px solid #e0e0e0; /* สีกรอบภายนอก */
    border-radius: 8px 8px 0 0; /* มุมโค้งมนเฉพาะด้านบน */
    background-color: #f5f5f5 !important; /* พื้นหลังสีเทาอ่อนด้านหลัง Tab */
    padding: 4px 4px 0 4px; /* เว้นระยะให้ Tab ไม่ชิดขอบกรอบเกินไป */
    height: auto !important;
    margin-bottom: 20px;
  }
  /* .v-tab-item .ml-3.mt-1 {
    margin-left: 8px !important;
    margin-top: 4px !important;
  } */
</style>
